(function() {
    'use strict';

    angular
        .module('nasracApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'datatables',
            'datatables.buttons',
            'datatables.factory',
            'datatables.bootstrap',
            'datatables.colreorder',
            'datatables.columnfilter',
            'ods-lib',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.tinymce',
            'ui.router.tabs',
            'dndLists',
            'angulartics', 'angulartics.piwik',
            'ngIdle'

        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', '$state', 'Account', '$rootScope', '$analytics'];

    function Principal ($q, $state, Account, $rootScope, $analytics) {
        var _identity,
            _authenticated = false,
            currentIdentity;
        
        

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            currentIdentity: currentIdentity,
            findHasAnyAuthority: findHasAnyAuthority
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
            if (identity == null) {
            	$analytics.setUsername('');
            }
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }
        
        function findHasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return '';
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return authorities[i];
                }
            }

            return '';
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                service.currentIdentity = angular.copy(_identity);
                _authenticated = true;
                deferred.resolve(_identity);
                $rootScope.username = service.currentIdentity.login;
                $analytics.setUsername(service.currentIdentity.login);
                /*$state.go('home-main.home-page', {}, {
    				reload : true
    			});*/
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            var authorities = attrs.hasAnyAuthority.split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }
                    var updFlag = Principal.currentIdentity.userPasswordUpdFlag;
                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        //Do not display any other tab to user if UPD flag is true. Force User to change password.
                        if(updFlag){
                            setHidden();
                        }else{
                            setVisible();
                        }
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {

            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();


                if($rootScope.toState.name === 'password'){
                    isAuthenticated = false;
                    Principal.identity.authorize = null;

                }
                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {

                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                	// TODO Hardcoded for English
                    if (account!== null) {
                        $translate.use('en').then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

/*** Directives and services for responding to idle users in AngularJS
* @author Mike Grabski <me@mikegrabski.com>
* @version v1.3.2
* @link https://github.com/HackedByChinese/ng-idle.git
* @license MIT
*/
(function(window, angular, undefined) {
'use strict';
angular.module('ngIdle', ['ngIdle.keepalive', 'ngIdle.idle', 'ngIdle.countdown', 'ngIdle.title', 'ngIdle.localStorage']);
angular.module('ngIdle.keepalive', [])
  .provider('Keepalive', function() {
    var options = {
      http: null,
      interval: 10 * 60
    };

    this.http = function(value) {
      if (!value) throw new Error('Argument must be a string containing a URL, or an object containing the HTTP request configuration.');
      if (angular.isString(value)) {
        value = {
          url: value,
          method: 'GET'
        };
      }

      value.cache = false;

      options.http = value;
    };

    var setInterval = this.interval = function(seconds) {
      seconds = parseInt(seconds);

      if (isNaN(seconds) || seconds <= 0) throw new Error('Interval must be expressed in seconds and be greater than 0.');
      options.interval = seconds;
    };

    this.$get = ['$rootScope', '$log', '$interval', '$http',
      function($rootScope, $log, $interval, $http) {

        var state = {
          ping: null
        };

        function handleResponse(response) {
          $rootScope.$broadcast('KeepaliveResponse', response.data, response.status);
        }

        function ping() {
          $rootScope.$broadcast('Keepalive');

          if (angular.isObject(options.http)) {
            $http(options.http)
              .then(handleResponse)
              .catch(handleResponse);
          }
        }

        return {
          _options: function() {
            return options;
          },
          setInterval: setInterval,
          start: function() {
            $interval.cancel(state.ping);

            state.ping = $interval(ping, options.interval * 1000);
            return state.ping;
          },
          stop: function() {
            $interval.cancel(state.ping);
          },
          ping: function() {
            ping();
          }
        };
      }
    ];
  });

angular.module('ngIdle.idle', ['ngIdle.keepalive', 'ngIdle.localStorage'])
  .provider('Idle', function() {
    var options = {
      idle: 20 * 60, // in seconds (default is 20min)
      timeout: 30, // in seconds (default is 30sec)
      autoResume: 'idle', // lets events automatically resume (unsets idle state/resets warning)
      interrupt: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll',
      windowInterrupt: null,
      keepalive: true
    };

    /**
     *  Sets the number of seconds a user can be idle before they are considered timed out.
     *  @param {Number|Boolean} seconds A positive number representing seconds OR 0 or false to disable this feature.
     */
    var setTimeout = this.timeout = function(seconds) {
      if (seconds === false) options.timeout = 0;
      else if (angular.isNumber(seconds) && seconds >= 0) options.timeout = seconds;
      else throw new Error('Timeout must be zero or false to disable the feature, or a positive integer (in seconds) to enable it.');
    };

    this.interrupt = function(events) {
      options.interrupt = events;
    };

    this.windowInterrupt = function(events) {
      options.windowInterrupt = events;
    };

    var setIdle = this.idle = function(seconds) {
      if (seconds <= 0) throw new Error('Idle must be a value in seconds, greater than 0.');

      options.idle = seconds;
    };

    this.autoResume = function(value) {
      if (value === true) options.autoResume = 'idle';
      else if (value === false) options.autoResume = 'off';
      else options.autoResume = value;
    };

    this.keepalive = function(enabled) {
      options.keepalive = enabled === true;
    };

    this.$get = ['$interval', '$log', '$rootScope', '$document', 'Keepalive', 'IdleLocalStorage', '$window',
      function($interval, $log, $rootScope, $document, Keepalive, LocalStorage, $window) {
        var state = {
          idle: null,
          timeout: null,
          idling: false,
          running: false,
          countdown: null
        };

        var id = new Date().getTime();

        function startKeepalive() {
          if (!options.keepalive) return;

          if (state.running) Keepalive.ping();

          Keepalive.start();
        }

        function stopKeepalive() {
          if (!options.keepalive) return;

          Keepalive.stop();
        }

        function toggleState() {
          state.idling = !state.idling;
          var name = state.idling ? 'IdleStart' : 'IdleEnd';

          if (state.idling) {
            $rootScope.$broadcast(name);
            stopKeepalive();
            if (options.timeout) {
              state.countdown = options.timeout;
              countdown();
              state.timeout = $interval(countdown, 1000, options.timeout, false);
            }
          } else {
            startKeepalive();
            $rootScope.$broadcast(name);
          }

          $interval.cancel(state.idle);
        }

        function countdown() {

          // check not called when no longer idling
          // possible with multiple tabs
          if(!state.idling){
            return;
          }

          // countdown has expired, so signal timeout
          if (state.countdown <= 0) {
            timeout();
            return;
          }

          // countdown hasn't reached zero, so warn and decrement
          $rootScope.$broadcast('IdleWarn', state.countdown);
          state.countdown--;
        }

        function interrupted(anotherTab) {
          $rootScope.$broadcast('IdleInterrupt', anotherTab);
        }

        function timeout() {
          stopKeepalive();
          $interval.cancel(state.idle);
          $interval.cancel(state.timeout);

          state.idling = true;
          state.running = false;
          state.countdown = 0;

          $rootScope.$broadcast('IdleTimeout');
        }

        function changeOption(self, fn, value) {
          var reset = self.running();

          self.unwatch();
          fn(value);
          if (reset) self.watch();
        }

        function getExpiry() {
          var obj = LocalStorage.get('expiry');

          return obj && obj.time ? new Date(obj.time) : null;
        }

        function setExpiry(date) {
          if (!date) LocalStorage.remove('expiry');
          else LocalStorage.set('expiry', {id: id, time: date});
        }

        var svc = {
          _options: function() {
            return options;
          },
          _getNow: function() {
            return new Date();
          },
          getIdle: function(){
            return options.idle;
          },
          getTimeout: function(){
            return options.timeout;
          },
          setIdle: function(seconds) {
            changeOption(this, setIdle, seconds);
          },
          setTimeout: function(seconds) {
            changeOption(this, setTimeout, seconds);
          },
          isExpired: function() {
            var expiry = getExpiry();
            return expiry !== null && expiry <= this._getNow();
          },
          running: function() {
            return state.running;
          },
          idling: function() {
            return state.idling;
          },
          watch: function(noExpiryUpdate) {
            $interval.cancel(state.idle);
            $interval.cancel(state.timeout);

            // calculate the absolute expiry date, as added insurance against a browser sleeping or paused in the background
            var timeout = !options.timeout ? 0 : options.timeout;
            if (!noExpiryUpdate) setExpiry(new Date(new Date().getTime() + ((options.idle + timeout) * 1000)));


            if (state.idling) toggleState(); // clears the idle state if currently idling
            else if (!state.running) startKeepalive(); // if about to run, start keep alive

            state.running = true;

            state.idle = $interval(toggleState, options.idle * 1000, 0, false);
          },
          unwatch: function() {
            $interval.cancel(state.idle);
            $interval.cancel(state.timeout);

            state.idling = false;
            state.running = false;
            setExpiry(null);

            stopKeepalive();
          },
          interrupt: function(anotherTab) {
            if (!state.running) return;

            if (options.timeout && this.isExpired()) {
              timeout();
              return;
            } else {
              interrupted(anotherTab);
            }

            // note: you can no longer auto resume once we exceed the expiry; you will reset state by calling watch() manually
            if (anotherTab || options.autoResume === 'idle' || (options.autoResume === 'notIdle' && !state.idling)) this.watch(anotherTab);
          }
        };

        var lastMove = {
          clientX: null,
          clientY: null,
          swap: function(event) {
            var last = {clientX: this.clientX, clientY: this.clientY};
            this.clientX = event.clientX;
            this.clientY = event.clientY;
            return last;
          },
          hasMoved: function(event) {
            var last = this.swap(event);
            if (this.clientX === null || event.movementX || event.movementY) return true;
            else if (last.clientX != event.clientX || last.clientY != event.clientY) return true;
            else return false;
          }
        };

        $document.find('html').on(options.interrupt, function(event) {
          if (event.type === 'mousemove' && event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) {
            return; // Fix for Chrome desktop notifications, triggering mousemove event.
          }

          if (event.type !== 'mousemove' || lastMove.hasMoved(event)) {
            svc.interrupt();
          }
        });

        if(options.windowInterrupt) {
          var eventList = options.windowInterrupt.split(' ');
          var fn = function() {
            svc.interrupt();
          };

          for(var i=0; i<eventList.length; i++) {
            if ($window.addEventListener) {
              $window.addEventListener(eventList[i], fn, false);
              $rootScope.$on('$destroy', function () {
                $window.removeEventListener(eventList[i], fn, false);
              });
            } else {
              $window.attachEvent(eventList[i], fn);
              $rootScope.$on('$destroy', function () {
                $window.detachEvent(eventList[i], fn);
              });
            }
          }
        }

        var wrap = function(event) {
          if (event.key === 'ngIdle.expiry' && event.newValue && event.newValue !== event.oldValue) {
            var val = angular.fromJson(event.newValue);
            if (val.id === id) return;
            svc.interrupt(true);
          }
        };

        if ($window.addEventListener) {
          $window.addEventListener('storage', wrap, false);
          $rootScope.$on('$destroy', function () {
            $window.removeEventListener('storage', wrap, false);
          });
        } else if ($window.attachEvent){
          $window.attachEvent('onstorage', wrap);
          $rootScope.$on('$destroy', function () {
            $window.detachEvent('onstorage', wrap);
          });
        }

        return svc;
      }
    ];
  });

angular.module('ngIdle.countdown', ['ngIdle.idle'])
  .directive('idleCountdown', ['Idle', function(Idle) {
    return {
      restrict: 'A',
      scope: {
        value: '=idleCountdown'
      },
      link: function($scope) {
        // Initialize the scope's value to the configured timeout.
        $scope.value = Idle.getTimeout();

        $scope.$on('IdleWarn', function(e, countdown) {
          $scope.$evalAsync(function() {
            $scope.value = countdown;
          });
        });

        $scope.$on('IdleTimeout', function() {
          $scope.$evalAsync(function() {
            $scope.value = 0;
          });
        });
      }
    };
  }]);

angular.module('ngIdle.title', [])
  .provider('Title', function() {
    var options = {
      enabled: true
    };

    var setEnabled = this.enabled = function(enabled) {
      options.enabled = enabled === true;
    };

    function padLeft(nr, n, str){
      return new Array(n-String(nr).length+1).join(str||'0')+nr;
    }

    this.$get = ['$document', '$interpolate', function($document, $interpolate) {
      var state = {
        original: null,
        idle: '{{minutes}}:{{seconds}} until your session times out!',
        timedout: 'Your session has expired.'
      };

      return {
        setEnabled: setEnabled,
        isEnabled: function() {
          return options.enabled;
        },
        original: function(val) {
          if (angular.isUndefined(val)) return state.original;

          state.original = val;
        },
        store: function(overwrite) {
          if (overwrite || !state.original) state.original = this.value();
        },
        value: function(val) {
          if (angular.isUndefined(val)) return $document[0].title;

          $document[0].title = val;
        },
        idleMessage: function(val) {
          if (angular.isUndefined(val)) return state.idle;

          state.idle = val;
        },
        timedOutMessage: function(val) {
          if (angular.isUndefined(val)) return state.timedout;

          state.timedout = val;
        },
        setAsIdle: function(countdown) {
          this.store();

          var remaining = { totalSeconds: countdown };
          remaining.minutes = Math.floor(countdown/60);
          remaining.seconds = padLeft(countdown - remaining.minutes * 60, 2);

          this.value($interpolate(this.idleMessage())(remaining));
        },
        setAsTimedOut: function() {
          this.store();

          this.value(this.timedOutMessage());
        },
        restore: function() {
          if (this.original()) this.value(this.original());
        }
      };
    }];
  })
  .directive('title', ['Title', function(Title) {
      return {
        restrict: 'E',
        link: function($scope, $element, $attr) {
          if (!Title.isEnabled() || $attr.idleDisabled) return;

          Title.store(true);

          $scope.$on('IdleStart', function() {
            Title.original($element[0].innerText);
          });

          $scope.$on('IdleWarn', function(e, countdown) {
            Title.setAsIdle(countdown);
          });

          $scope.$on('IdleEnd', function() {
            Title.restore();
          });

          $scope.$on('IdleTimeout', function() {
            Title.setAsTimedOut();
          });
        }
      };
  }]);

angular.module('ngIdle.localStorage', [])
  .service('IdleStorageAccessor', ['$window', function($window) {
    return {
      get: function() {
        return $window.localStorage;
      }
    }
  }])
  .service('IdleLocalStorage', ['IdleStorageAccessor', function(IdleStorageAccessor) {
    function AlternativeStorage() {
      var storageMap = {};

      this.setItem = function (key, value) {
          storageMap[key] = value;
      };

      this.getItem = function (key) {
          if(typeof storageMap[key] !== 'undefined' ) {
              return storageMap[key];
          }
          return null;
      };

      this.removeItem = function (key) {
          storageMap[key] = undefined;
      };
    }

    function getStorage() {
       try {
          var s = IdleStorageAccessor.get();
          s.setItem('ngIdleStorage', '');
          s.removeItem('ngIdleStorage');

          return s;
       } catch(err) {
          return new AlternativeStorage();
       }
    }

    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
    // to avoid the entire page breaking, without having to do a check at each usage of Storage.
    var storage = getStorage();

    return {
      set: function(key, value) {
        storage.setItem('ngIdle.'+key, angular.toJson(value));
      },
      get: function(key) {
        return angular.fromJson(storage.getItem('ngIdle.'+key));
      },
      remove: function(key) {
        storage.removeItem('ngIdle.'+key);
      },
      _wrapped: function() {
        return storage;
      }
    };
}]);

})(window, window.angular);

/**
 * Created by rkotha on 8/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators'];
    	$stateProvider
        .state('siteadminreports', {
            parent: 'reports',
            url: '/siteadminreports',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracCustomerReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/site-admin-reports/site-admin-reports.html',
                    controller: 'SiteAdminReportsMainController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracCustomerReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                siteAdminEntity: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'piwik'}).$promise;
                }]
            }
        });

    }
})();

/**
 * Created by rkotha on 8/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('SiteAdminReportsMainController', SiteAdminReportsMainController);

    // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    SiteAdminReportsMainController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'siteAdminEntity', 'NasracWebContent'];

	    function SiteAdminReportsMainController($scope, Principal, LoginService,
			$state, $sce, siteAdminEntity, NasracWebContent) {
	    var vm = this;
		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		var entity = siteAdminEntity[0];
		if (entity !== undefined) {
			vm.trustedHtml = $sce.trustAsHtml(entity.content);
			vm.tinymceModel = entity.content;
		}
		
		

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}

		function register() {
			$state.go('register');
		}

		

	}

})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reports', {
        	abstract: true,
            parent: 'app',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User', 'Customer Users']
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('nasrac-customer-report', {
            parent: 'reports',
            url: '/nasrac-customer-report',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User', 'Customer Users'],
                pageTitle: 'nasracApp.nasracCustomerReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/nasrac-customer-report/nasrac-customer-reports.html',
                    controller: 'NasracCustomerReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracCustomerReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracCustomerReport', NasracCustomerReport);

    NasracCustomerReport.$inject = ['$resource', 'DateUtils'];

    function NasracCustomerReport ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-customer-reports/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { 
            	
            	url : 'api/nasrac-customer-reports/siteIds',
            	method: 'GET', 
            	isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastModified = DateUtils.convertDateTimeFromServer(data.lastModified);
                    }
                    return data;
                }
            },'download_report' : {
				method : 'GET',
				url : 'api/nasrac-customer-reports/download/:reportName/:siteId/:isArchived',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},'query_files_by_siteId': { 
            	
            	url : 'api/nasrac-customer-reports/siteIds/:siteId/:isArchived',
            	method: 'GET', 
            	isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracCustomerReportController', NasracCustomerReportController);

    NasracCustomerReportController.$inject = ['$scope', '$state', 'NasracCustomerReport', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];


    function NasracCustomerReportController($scope, $state, NasracCustomerReport, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.nasracCustomerReports = [];
        loadAll();

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();

        vm.dtInstance = {};
        var g_isArchived = false;
        vm.siteId = null;
        vm.reportsFlag = false;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                NasracCustomerReport.query(function (result) {
                    vm.nasracCustomerReports = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.nasracCustomerReports, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%'*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                //$compile(nRow)($scope);
            })

            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withDOM()
            .withOption('saveState', true)
            .withOption('order', [])
            .withDisplayLength(25)
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);
        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name').renderWith(function (data, type, full) {
                data = '<a ng-click="vm.get_siteId_files(\'' + data + '\', false);"> ' + data + '</a>'
                return data;

            }),
            DTColumnBuilder.newColumn('size').withTitle('Size').notVisible(),
            DTColumnBuilder.newColumn('type').withTitle('Type').notVisible(),
            DTColumnBuilder.newColumn('lastModifiedString').withTitle('Generated Date').renderWith(function (data, type, full) {
                data = data + "" + abbr;
                return data;

            })

        ];

        function loadAll() {
            NasracCustomerReport.query(function (result) {
                vm.nasracCustomerReports = result;
                vm.searchQuery = null;
            });

        }


        // Get the list of files based on the SiteId, isArchived flag
        // determines whether files need to be picked from "Archive"
        // folder or "Current" folder
        vm.get_siteId_files = function (siteId, isArchived) {

            vm.siteId = siteId;
            g_isArchived = isArchived;
            vm.reportsFlag = true;

            // Load the new data and call changeData() function for
            // reloading DataTables with new data.
            vm.dtInstance.changeData(NasracCustomerReport.query_files_by_siteId({
                siteId: siteId,
                isArchived: g_isArchived
            }).$promise);

            // Also change Columns visibility to display details.
            vm.dtColumns = [
                DTColumnBuilder.newColumn('name').withTitle('Name').renderWith(function (data, type, full) {
                    data = '<a ng-click="vm.download_report(\'' + data + '\');"> ' + data + '</a>'
                    return data;

                }),
                DTColumnBuilder.newColumn('size').withTitle('Size'),
                DTColumnBuilder.newColumn('type').withTitle('Type'),
                DTColumnBuilder.newColumn('lastModifiedString').withTitle('Generated Date').renderWith(function (data, type, full) {
                    data = data + "" + abbr;
                    return data;

                })

            ];

        }

        // This function is responsible for the file to download.
        // Makes a back-end call with file information, such that file is fetched and starts downloading.
        vm.download_report = function (reportName) {
            NasracCustomerReport.download_report({
                reportName: reportName,
                siteId: vm.siteId,
                isArchived: g_isArchived
            }).$promise
                .then(function (data) {
                    var url = URL.createObjectURL(data.response);
                    var link = document.createElement("a");
                    link.href = url;
                    link.style = "visibility:hidden";
                    link.download = reportName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
        }

        vm.reload_state = function () {
            $state.reload();
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        var roles = ['Administrators'];
        $stateProvider
            .state('change-management-hours-report', {
                parent: 'reports',
                url: '/changemanagementhoursreport',
                data: {
                    authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User', 'Customer Users'],
                    pageTitle: 'nasracApp.changemanagementHoursReport.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reports/change-management-hours-report/change-management-hours-report.html',
                        controller: 'ChangeManagementHoursMainController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('changeManagementHoursReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';
    angular.module('nasracApp').factory('ChangeManagementHoursReport', ChangeManagementHoursReport);

    ChangeManagementHoursReport.$inject = ['$resource'];

    function ChangeManagementHoursReport($resource) {
        var resourceUrl = 'api/changemanagementhoursreport';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCurrentUser': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/currentUser',
                isArray: false
            },

            'getReportYears': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/reportYear',
                isArray: true
            },
            'getCustomerList': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/allcllicodeCustomer',
                isArray: true
            },
            'getClliCodeList': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/allcllicode',
                isArray: true
            },
            'loadDataHoursReport': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/changeManagementHoursReport',
                isArray: true
            },
            'download': {
                method: 'GET',
                url: 'api/changemanagementhoursreport/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {
                            type: xlsxContentType
                        })
                    };
                }
            },

        });
    }
})();

(function () {
    'use strict';
    angular
        .module('nasracApp')
        .controller('ChangeManagementHoursMainController', ChangeManagementHoursMainController);
    ChangeManagementHoursMainController.$inject = ['$scope', '$state', 'NasracCustomerReport', 'ChangeManagementHoursReport', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'ProfileService', 'Principal'];

    function ChangeManagementHoursMainController($scope, $state, NasracCustomerReport, ChangeManagementHoursReport, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, ProfileService, Principal) {
        var vm = this;
        vm.nasracCustomerReports = [];
        vm.reportsFlag = false;
        vm.caseIdFlag = false;
        $scope.reportData = [];
        $scope.searchQuery = null;
        $scope.dtInstance = {};
        $scope.caseId = "NONE";
        $scope.selectedCustomer = {};
        $scope.selectedCustomer.customerName = "ALL";
        $scope.selectedClliCode = {};
        $scope.selectedClliCode.clliCode = "ALL";
        $scope.option = "NONE";
        $scope.isAdmin = true;
        $scope.fileName == "NAS_RAC Change Management Hours Report"
        $scope.clliCode = "ALL";
        checkRole();

        function checkRole() {
            var defer = $q.defer()
            var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function (result) {
                $scope.isAdmin = result;
                if ($scope.isAdmin)
                    $scope.clliCode = "ALL";
                else {
                    ChangeManagementHoursReport.getCurrentUser(function (result) {
                        $scope.clliCode = result.siteId;
                    });
                }
            });
        }

        $scope.tabData = [{
            heading: 'Change Management Hours Reports',
            route: 'change-management-hours',
            class: 'btn-lg'
        }];
        ChangeManagementHoursReport.getReportYears(function (result) {
            $scope.reportYear = result;
            var index = result.length - 1;
            $scope.selectedYear = result[0];
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            $scope.onYearChange();
        });

        $scope.onYearChange = function () {
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            if ($scope.isAdmin) {
                ChangeManagementHoursReport.getCustomerList({
                    year: $scope.selectedYear.reportYear
                }, function (result) {
                    $scope.customerList = result;
                    $scope.selectedCustomer.customerName = "";
                });
            }
        };
        $scope.onCustomerChange = function () {
            $scope.option = "NONE";
            $scope.clliCode = "ALL";
            $scope.clliCodeList = [];
            $scope.selectedClliCode = {};
            if ($scope.selectedCustomer != null) {
                $scope.fileName = $scope.fileName + $scope.selectedCustomer.customerName;
                ChangeManagementHoursReport.getClliCodeList({
                    year: $scope.selectedYear.reportYear,
                    customerName: $scope.selectedCustomer.customerName
                }, function (result) {
                    $scope.clliCodeList = result;

                });
            }
        };
        $scope.onClliCodeChange = function () {
            if ($scope.selectedClliCode != null) {
                $scope.option = "CLLICODE";
                $scope.clliCode = $scope.selectedClliCode.clliCode;
            }
            else {
                $scope.clliCode = "ALL";
                $scope.option = "NONE";
            }
        };
        $scope.loadDataHoursReport = function () {
            $scope.reportData = [];
            if (vm.reportsFlag || vm.caseIdFlag) {
                vm.reportsFlag = false;
                vm.caseIdFlag = false;
                $scope.option = "NONE";
                $scope.fileName = "NAS_RAC " + $scope.selectedYear + " Change Management Hours Report "
                if (!$scope.selectedCustomer || !$scope.selectedCustomer.customerName) {
                    $scope.selectedCustomer = {};
                    $scope.option = "ALL";
                    $scope.selectedCustomer.customerName = "ALL";
                    $scope.caseId = "ALL";
                    $scope.clliCode = "ALL";
                }
                ChangeManagementHoursReport.loadDataHoursReport({
                    year: $scope.selectedYear.reportYear,
                    option: $scope.option,
                    customerName: $scope.selectedCustomer.customerName,
                    caseId: $scope.caseId,
                    clliCode: $scope.clliCode
                }).$promise;
            }
            else {
                if (!$scope.selectedCustomer || !$scope.selectedCustomer.customerName) {
                    $scope.selectedCustomer = {};
                    $scope.option = "ALL";
                    $scope.selectedCustomer.customerName = "ALL";
                    $scope.caseId = "ALL";
                    $scope.clliCode = "ALL";
                }//var defer=$q.defer();
                ChangeManagementHoursReport.loadDataHoursReport({
                    year: $scope.selectedYear.reportYear,
                    option: $scope.option,
                    customerName: $scope.selectedCustomer.customerName,
                    caseId: $scope.caseId,
                    clliCode: $scope.clliCode

                }, function (result) {
                    $scope.reportData = result;
                    $scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();//getting current time
                    $scope.getTotal($scope.reportData);
                })
                // defer.resolve;
                $scope.dtColumns = [
                    DTColumnBuilder.newColumn('range').withTitle('Year'),
                    DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin),
                    DTColumnBuilder.newColumn('caseId').withTitle('CaseId').withOption('width', '20%').notVisible(),
                    DTColumnBuilder.newColumn('clliCode').withTitle('Site Id').withOption('width', '10%').renderWith(function (data, type, full) {
                        data = '<a ng-click="vm.query_by_year(\'' + data + '\', false);"> ' + data + '</a>'
                        return data;
                    }),
                    DTColumnBuilder.newColumn('site').withTitle('Site Name'),
                    DTColumnBuilder.newColumn('caseSummary').withTitle('CaseSummary').notVisible(),
                    DTColumnBuilder.newColumn('caseOwner').withTitle('CaseOwner').notVisible(),
                    DTColumnBuilder.newColumn('caseCreatedTime').withTitle('CaseCreatedTime').notVisible(),
                    DTColumnBuilder.newColumn('caseStatus').withTitle('CaseStatus').notVisible(),
                    DTColumnBuilder.newColumn('timeLog').withTitle('TimeLog').notVisible(),
                    DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('TimeLogCreatedTime').notVisible(),
                    DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
                ];
            }
        };
        $scope.getTotal = function (result) {
            $scope.total = 0.0000;

            angular.forEach(result, function (item, index) {
                $scope.total = $scope.total + item.totalTimeHrs;
            });
        };
        $scope.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                ChangeManagementHoursReport.loadDataHoursReport({
                    year: $scope.selectedYear.reportYear,
                    option: $scope.option,
                    customerName: $scope.selectedCustomer.customerName,
                    caseId: $scope.caseId,
                    clliCode: $scope.clliCode

                }, function (result) {
                    $scope.reportData = result;
                    if ($scope.clliCode != 'ALL') {
                        $scope.siteName = $scope.reportData[0].site;
                    }
                    $scope.getTotal($scope.reportData);
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter($scope.reportData, $scope.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withOption('createdRow', createdRow)

            .withDisplayLength(25)
            .withOption('order', [2, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            .withButtons(
                [{
                    extend: 'excel',
                    text: 'Export',
                    title: function () {
                        return getFileName();
                    },//'NAS_RAC 2017 Change Management hours Report',
                    exportOptions: {columns: ':visible'},
                    titleAttr: 'Excel'
                }])
            .withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            })
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>");
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('range').withTitle('Year').withOption('width', '10%'),
            DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin).withOption('width', '10%'),
            DTColumnBuilder.newColumn('clliCode').withTitle('Site Id').withOption('width', '10%').renderWith(function (data, type, full, meta) {
                data = '<a ng-click="vm.query_by_year(\'' + data + '\', false);"> ' + data + '</a>'
                return data;
            }),
            DTColumnBuilder.newColumn('caseId').withTitle('CaseId').withOption('width', '10%').notVisible(),
            DTColumnBuilder.newColumn('site').withTitle('Site Name'),
            DTColumnBuilder.newColumn('caseSummary').withTitle('CaseSummary').withOption('width', '20%').notVisible(),
            DTColumnBuilder.newColumn('caseOwner').withTitle('CaseOwner').notVisible(),
            DTColumnBuilder.newColumn('caseCreatedTime').withTitle('CaseCreatedTime').notVisible(),
            DTColumnBuilder.newColumn('caseStatus').withTitle('CaseStatus').notVisible(),
            DTColumnBuilder.newColumn('timeLog').withTitle('TimeLog').notVisible(),
            DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('TimeLogCreatedTime').notVisible(),
            DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
        ];
        vm.query_by_year = function (siteId) {
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            $scope.fileName = $scope.fileName + siteId;
            vm.caseIdFlag = false;
            vm.customer = $scope.selectedCustomer.customerName;
            vm.clliCode = siteId;
            $scope.option = 'first';
            //$scope.selectedCustomer.customerName = customer;
            var currentYear = $scope.selectedYear.reportYear;
            vm.reportsFlag = true;
            $scope.clliCode = siteId;
            ChangeManagementHoursReport.loadDataHoursReport({
                year: currentYear,
                option: 'first',
                customerName: vm.customer,
                caseId: $scope.caseId,
                siteId: vm.clliCode,
                clliCode: $scope.clliCode
            }).$promise;
            // Also change Columns visibility to display details.
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('range').withTitle('Year').withOption('width', '10%'),
                DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin).withOption('width', '20%'),
                DTColumnBuilder.newColumn('clliCode').withTitle('Site Id').withOption('width', '7%'),
                DTColumnBuilder.newColumn('site').withTitle('Site Name').withOption('width', '20%'),
                DTColumnBuilder.newColumn('caseId').withTitle('Case Id').withOption('width', '7%').renderWith(function (data, type, full) {
                    if ($scope.isAdmin) {
                        data = '<a ng-click="vm.query_by_caseId(\'' + data + '\', false);"> ' + data + '</a>'
                        return data;
                    }
                    else return data;
                }),
                DTColumnBuilder.newColumn('caseSummary').withTitle('Case Summary').withOption('width', '20%'),
                DTColumnBuilder.newColumn('caseOwner').withTitle('Case Owner'),
                DTColumnBuilder.newColumn('caseCreatedTime').withTitle('CaseCreated_Time').notVisible(),
                DTColumnBuilder.newColumn('caseStatus').withTitle('Case Status'),
                DTColumnBuilder.newColumn('timeLog').withTitle('Time_Log').notVisible(),
                DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('TimeLogCreatedTime').notVisible(),
                DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
            ];
        }

        vm.query_by_caseId = function (caseId) {
            vm.caseId = caseId;
            $scope.caseId = vm.caseId;
            $scope.fileName = "NAS_RAC " + $scope.selectedYear.range + " Change Management Hours Report "
            $scope.fileName = $scope.fileName + vm.clliCode;
            $scope.fileName = $scope.fileName + " " + caseId;
            $scope.option = 'second';
            vm.customer = $scope.selectedCustomer.customerName
            var currentYear = $scope.selectedYear.reportYear;
            vm.caseIdFlag = true;
            ChangeManagementHoursReport.loadDataHoursReport({
                year: currentYear,
                option: 'second',
                customerName: vm.customer,
                caseId: $scope.caseId,
                clliCode: $scope.clliCode
            }).$promise;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('range').withTitle('Year').withOption('width', '10%'),
                DTColumnBuilder.newColumn('customer').withTitle('Customer').withOption('visible', $scope.isAdmin).withOption('width', '10%'),
                DTColumnBuilder.newColumn('clliCode').withTitle('Site Id'),
                DTColumnBuilder.newColumn('site').withTitle('Site Name'),
                DTColumnBuilder.newColumn('caseId').withTitle('Case Id'),
                DTColumnBuilder.newColumn('caseSummary').withTitle('Case Summary'),
                DTColumnBuilder.newColumn('caseOwner').withTitle('Case Owner'),
                DTColumnBuilder.newColumn('caseCreatedTime').withTitle('Case Created Time'),
                DTColumnBuilder.newColumn('caseStatus').withTitle('Case Status'),
                DTColumnBuilder.newColumn('timeLog').withTitle('Time Log'),
                DTColumnBuilder.newColumn('timeLogCreatedTime').withTitle('Time Log Created Time'),
                DTColumnBuilder.newColumn('totalTimeHrs').withTitle('Total Time[Hrs]')
            ];
        }
        vm.reload_state = function () {
            vm.reportsFlag = false;
            vm.caseIdFlag = false;
            $state.reload();
        };

        function getFileName() {
            return $scope.fileName;
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

    }
})();


(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracWebContent', NasracWebContent);

    NasracWebContent.$inject = ['$resource', 'DateUtils'];

    function NasracWebContent ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-web-contents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.last_modified_time = DateUtils.convertDateTimeFromServer(data.last_modified_time);
                    }
                    return data;
                }
            },
            'getAll':{
                method:'GET',
                url:'/api/nasrac-web-contents/',
                isArray: true
            },
            'getPage': {
                method: 'GET',
                url: '/api/nasrac-web-contents/page/:page',
                isArray: true
            },

            'update': { method:'PUT' }
        });
    }
})();

/*
/!**
 * Created by sdarbar on 7/9/2017.
 *!/
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FormsDownloadController', FormsDownloadController);

    FormsDownloadController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity'];

    function FormsDownloadController($scope, $rootScope, $stateParams,  DataUtils, entity) {
        var vm = this;

        vm.forms = entity;
       // vm.previousState = previousState.name;
      //  vm.byteSize = DataUtils.byteSize;
       // vm.openFile =
            DataUtils.openFile(entity.fileuploadContentType , entity.fileupload);

      /!*  var unsubscribe = $rootScope.$on('nasracApp:formsUpdate', function(event, result) {
            vm.forms = result;
        });
        $scope.$on('$destroy', unsubscribe);*!/


    }
})();
*/

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FormsDialogController', FormsDialogController);

    FormsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Forms'];

    function FormsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Forms) {
        var vm = this;

        vm.forms = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.kbSize = DataUtils.kbSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

      /*  vm.forms.docvisibility = vm.forms.docvisibility+"";*/

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.forms.filesize  = vm.kbSize(vm.forms.fileupload);
            /*vm.forms.docvisibility = parseInt(vm.forms.docvisibility);*/
            if (vm.forms.id !== null) {
                Forms.update(vm.forms, onSaveSuccess, onSaveError);
            } else {
                Forms.save(vm.forms, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:formsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
            /*vm.forms.docvisibility = vm.forms.docvisibility+"";*/
        }


        vm.setFileupload = function ($file, forms) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        forms.fileupload = base64Data;
                        forms.fileuploadContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.uploaddate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FormsDeleteController',FormsDeleteController);

    FormsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Forms'];

    function FormsDeleteController($uibModalInstance, entity, Forms) {
        var vm = this;

        vm.forms = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Forms.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('forms', {

            parent: 'app',
            url: '/forms?page&sort&search',
            data: {
                pageTitle: 'nasracApp.forms.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-forms/forms/forms.html',
                    controller: 'FormsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forms');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('forms-detail', {
            parent: 'forms',
            url: '/forms/{id}',
            data: {
               // authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.forms.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-forms/forms/forms-detail.html',
                    controller: 'FormsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forms');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Forms', function($stateParams, Forms) {
                    return Forms.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'forms',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('forms-detail.edit', {
            parent: 'forms-detail',
            url: '/detail/edit',
            /*data: {
                authorities: ['ROLE_USER']
            },*/
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-dialog.html',
                    controller: 'FormsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Forms', function(Forms) {
                            return Forms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('forms.new', {
            parent: 'forms',
            url: '/new',
            data: {
         //       authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-dialog.html',
                    controller: 'FormsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                doctype: null,
                                docvisibility: null,
                                description: null,
                                fileupload: null,
                                fileuploadContentType: null,
                                uploaddate: null,
                                uploadedby: null,
                                noofdownloads: null,
                                filesize: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('forms', null, { reload: 'forms' });
                }, function() {
                    $state.go('forms');
                });
            }]
        })
        .state('forms.edit', {
            parent: 'forms',
            url: '/{id}/edit',
            data: {
     //           authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-dialog.html',
                    controller: 'FormsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Forms', function(Forms) {
                            return Forms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('forms', null, { reload: 'forms' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

            //for download functionality
            .state('forms.download', {
                parent: 'forms',
                url: '/{id}/download',
                onEnter: ['$stateParams', '$state','$window' ,'DataUtils','Forms', function($stateParams, $state,$window,DataUtils, Forms) {
                    var entity =  Forms.download({id : $stateParams.id}).$promise;

                    entity.then(function(res) {

                        //$scope.$emit('nasracApp:formsUpdate', res);

                        //console.log("download res", res);
                        //var file = new Blob([ res.fileupload ], {
                        var contentType = res.fileuploadContentType;
                        var sliceSize =  512;

                        var byteCharacters = atob(res.fileupload);
                        var byteArrays = [];

                        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                            var slice = byteCharacters.slice(offset, offset + sliceSize);

                            var byteNumbers = new Array(slice.length);
                            for (var i = 0; i < slice.length; i++) {
                                byteNumbers[i] = slice.charCodeAt(i);
                            }

                            var byteArray = new Uint8Array(byteNumbers);

                            byteArrays.push(byteArray);
                        }

                        var blob = new Blob(byteArrays,{type: contentType});


                        var fileURL = URL.createObjectURL(blob);

                        /*console.log("content type resof url", fileURL);*/

                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';

                        a.download = res.title;
                        document.body.appendChild(a);
                        a.click();
                        $state.go('forms', null, { reload: 'forms' });
                    });
                }]
            })

        .state('forms.delete', {
            parent: 'forms',
            url: '/{id}/delete',
            data: {
     //           authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-forms/forms/forms-delete-dialog.html',
                    controller: 'FormsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Forms', function(Forms) {
                            return Forms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('forms', null, { reload: 'forms' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Forms', Forms);

    Forms.$inject = ['$resource', 'DateUtils'];

    function Forms ($resource, DateUtils) {
        var resourceUrl =  'api/forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.uploaddate = DateUtils.convertDateTimeFromServer(data.uploaddate);
                    }
                    return data;
                }
            },
            'download': {
                method: 'GET',
                url: 'api/forms/:id/download',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.uploaddate = DateUtils.convertDateTimeFromServer(data.uploaddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FormsController', FormsController);
    window.localStorage.removeItem("DataTables_nasracformsbar_/");
    FormsController.$inject = ['$scope', '$filter','$state', 'DataUtils', 'Forms', 'paginationConstants', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$compile','AuthServerProvider','Principal'];

    function FormsController ($scope, $filter, $state, DataUtils, Forms, paginationConstants,  $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $compile ,AuthServerProvider, Principal) {
        var vm = this;
        vm.Forms=[];
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.hasAuthority= Principal.hasAuthority();
        vm.dtInstance = {};

        var adminAuthorities = ['Administrators'];

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/forms/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {
                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
//                data.columns[1].data = "emailAddress";
                    //data.columns.shift();
                    //data.columns.splice(7);
                    data.columns.shift();


                    /*if($scope.DocumentType && $scope.DocumentType.length>0 && $scope.DocumentType != ""){
                        data.search.value = $scope.DocumentType;
                    } else {
                        data.search.value = "";
                    }*/
                    data.order[0].column = data.order[0].column - 1;

                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                }

            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-2'l><'col-sm-3'B><'col-sm-2 pull-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withPaginationType('full_numbers')
            .withDisplayLength(25)
            .withButtons( [
            {
                extend: 'collection',
                text: ' Select Document Type',
                autoClose: true,
                responsive: true,
                buttons: [
                    {
                        text: 'All Documnets',

                        action: function ( e, dt, node, configc,$state ) {
                            dt.columns(2).search( '' ).draw();
                        }
                    },
                    {
                        text: 'Channel Map',
                        action: function ( e, dt, node, config ) {
                            dt.columns(2).search( 'Channel Map' ).draw();
                        }

                    },
                    {
                        text: 'Launch Document',
                        action: function ( e, dt, node, config ) {
                            dt.columns(2).search( 'Launch Document' ).draw();
                        }

                    },{
                        text: 'Other',
                        action: function ( e, dt, node, config ) {
                            dt.columns(2).search( 'Other' ).draw();
                        }

                    },

                ]
            }
        ])
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            .withOption('order', [1, 'asc']);

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '115px').notSortable()
                    .renderWith(actionsHtml),
                DTColumnBuilder.newColumn('title').withTitle('Title'),
                DTColumnBuilder.newColumn('doctype').withTitle('Type'),
                DTColumnBuilder.newColumn('description').withTitle('Description'),
                DTColumnBuilder.newColumn('filesize').withTitle('Size'),
                DTColumnBuilder.newColumn('uploaddate').withTitle('Uploaded date'),
                DTColumnBuilder.newColumn('uploadedby').withTitle('Uploaded by'),
                DTColumnBuilder.newColumn('noofdownloads').withTitle('No.Of Downloads'),
                DTColumnBuilder.newColumn('docvisibility').withTitle('Visibility'),
            ];


            if (Principal.hasAnyAuthority(adminAuthorities)){
            	vm.dtColumns[6].visible = true;
                vm.dtColumns[7].visible = true;
                vm.dtColumns[8].visible = true;
            } else {
            	vm.dtColumns[0].withOption('width', '55px');
            }

            vm.dtColumns[5].renderWith(function (data, type, full) {
                return $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ') + abbr;   // Angularjs date filter
            });


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }
        function actionsHtml(data, type, full, meta){
    		if(Principal.hasAnyAuthority(adminAuthorities)){
                return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete','download']);
            } else {
            	 return GUIUtils.getActionsTemplate(data, $state.current.name, ['download']);
            }
        }

        function transition() {

            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });

        }

    }
})();

/**
 * Created by rkotha on 8/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators'];
    	$stateProvider
        .state('configuresiteadmin', {
            parent: 'nasrac-admin',
            url: '/configuresiteadmin',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracCustomerReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/site-admin/configure-site-admin.html',
                    controller: 'ConfigureSiteAdminMainController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracCustomerReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                siteAdminEntity: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'piwik'}).$promise;
                }],
                piwikEntity: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'piwik-siteid'}).$promise;
                }]
            }
        });

    }
})();

/**
 * Created by rkotha on 8/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ConfigureSiteAdminMainController', ConfigureSiteAdminMainController);

    // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    ConfigureSiteAdminMainController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'siteAdminEntity', 'piwikEntity','NasracWebContent'];

	    function ConfigureSiteAdminMainController($scope, Principal, LoginService,
			$state, $sce, siteAdminEntity, piwikEntity, NasracWebContent) {
	    var vm = this;
		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		var entity = siteAdminEntity[0];
		vm.nasrac_web_content = entity;
		if (entity !== undefined) {
			vm.trustedHtml = $sce.trustAsHtml(entity.content);
			vm.tinymceModel = entity.content;
		}
		
		var pEntity = piwikEntity[0];
		console.log(JSON.parse(pEntity.content));
		vm.siteContent = JSON.parse(pEntity.content);
		vm.editMode = false;

		
		vm.updateContents = function() {
			if (entity === undefined) {
				entity = {};
				entity.content = {};
			}
			pEntity.content = JSON.stringify(vm.siteContent);
			NasracWebContent.update(pEntity);
			
			entity.content = vm.tinymceModel;
			NasracWebContent.update(entity, onSaveSuccess, onSaveError);
			
			
			vm.editMode = false;
		};

		vm.cancelEditor = function() {
			vm.editMode = false;
		}

		vm.openEditor = function() {
			vm.editMode = true;
		}

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}

		function register() {
			$state.go('register');
		}

		function onSaveSuccess(result) {
			vm.editMode = false;
			$state.go('siteadminreports', {}, {
				reload : true
			});
		}

		function onSaveError() {
			vm.editMode = true;
		}

	}

})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesDialogController', SecurityRolesDialogController);

    SecurityRolesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SecurityRoles'];

    function SecurityRolesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SecurityRoles) {
        var vm = this;

        vm.securityRoles = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.securityRoles.id !== null) {
                SecurityRoles.update(vm.securityRoles, onSaveSuccess, onSaveError);
            } else {
                SecurityRoles.save(vm.securityRoles, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:securityRolesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesDetailController', SecurityRolesDetailController);

    SecurityRolesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity','DTColumnBuilder', 'DTOptionsBuilder',  'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal', 'SecurityRoles'];

    function SecurityRolesDetailController($scope, $rootScope, $stateParams, previousState, entity,DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal, SecurityRoles) {
        var vm = this;

        vm.securityRoles = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:securityRolesUpdate', function(event, result) {
            vm.securityRoles = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.nasracPackages = {
            createRoles: "Administrators,DAC Content Administrator"
        };

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            })
            .withPaginationType('full_numbers')
    .withButtons([
            {
                text: 'Export',
                extend: "excelHtml5",
                title:"Nasrac Sources",
                action: function (e, dt, node, config) {
                    NasracPackage.download().$promise
                        .then(function (data) {
                            var url = URL.createObjectURL(data.response);
                            var link = document.createElement("a");
                            link.href = url;

                            //set the visibility hidden so it will not effect on your web-layout
                            link.style = "visibility:hidden";
                            link.download = "NAS-RAC_Packages.xlsx"; //this is an example file to download, use yours

                            //this part will append the anchor tag and remove it after automatic click
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        });
                },
                exportOptions: {
                    columns: ':visible'
                },
                //CharSet: "utf8",
                exportData: { decodeEntities: true }
            }
        ])

            .withDisplayLength(25)

            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, -1], [10, 25, 50, "All"]]);
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
            DTColumnBuilder.newColumn('packageBsgHandle').withTitle('Package Bsg Handle'),
            DTColumnBuilder.newColumn('id').withTitle('Package Id'),
            DTColumnBuilder.newColumn('packageName').withTitle('Package Name')
        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
            vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesDeleteController',SecurityRolesDeleteController);

    SecurityRolesDeleteController.$inject = ['$uibModalInstance', 'entity', 'SecurityRoles'];

    function SecurityRolesDeleteController($uibModalInstance, entity, SecurityRoles) {
        var vm = this;

        vm.securityRoles = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SecurityRoles.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('security-roles', {
            parent: 'nasrac-admin',
            url: '/security-roles',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.securityRoles.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles.html',
                    controller: 'SecurityRolesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('securityRoles');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('security-roles-detail', {
            parent: 'security-roles',
            url: '/security-roles/{id}',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.securityRoles.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-detail.html',
                    controller: 'SecurityRolesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('securityRoles');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SecurityRoles', function($stateParams, SecurityRoles) {
                    return SecurityRoles.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'security-roles',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('security-roles-detail.edit', {
            parent: 'security-roles-detail',
            url: '/detail/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-dialog.html',
                    controller: 'SecurityRolesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SecurityRoles', function(SecurityRoles) {
                            return SecurityRoles.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('security-roles.new', {
            parent: 'security-roles',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-dialog.html',
                    controller: 'SecurityRolesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                securityRoleName: null,
                                securityRoleDesc: null,
                                securityRoleGroup: null,
                                publicRoleFlag: false,
                                autoAssignFlag: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('security-roles', null, { reload: 'security-roles' });
                }, function() {
                    $state.go('security-roles');
                });
            }]
        })
        .state('security-roles.edit', {
            parent: 'security-roles',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-dialog.html',
                    controller: 'SecurityRolesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SecurityRoles', function(SecurityRoles) {
                            return SecurityRoles.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('security-roles', null, { reload: 'security-roles' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('security-roles.delete', {
            parent: 'security-roles',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-delete-dialog.html',
                    controller: 'SecurityRolesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SecurityRoles', function(SecurityRoles) {
                            return SecurityRoles.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('security-roles', null, { reload: 'security-roles' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('SecurityRoles', SecurityRoles);

    SecurityRoles.$inject = ['$resource'];

    function SecurityRoles ($resource) {
        var resourceUrl =  'api/security-roles/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'download' : {
                method : 'GET',
                url : 'api/security-roles/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SecurityRolesController', SecurityRolesController);

    SecurityRolesController.$inject = ['SecurityRoles','$scope', '$state','$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider'];

    function SecurityRolesController(SecurityRoles,$scope, $state, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider ) {

        var vm = this;

        vm.securityRoles = [];


        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/security-roles/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                // The returned object has 'email' as property, but the server entity has 'emailAddress'

                // Any values you set on the data object will be passed along as parameters to the server
                //data.access_token = AuthenticationService.getAccessToken();
            	//alert(JSON.stringify(data));
                return JSON.stringify(data);
            }
        })
        .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
        .withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        }) .withButtons([
                {
                    text: 'Export',
                    extend: "excelHtml5",
                    title:"Nasrac Source Types",
                    action: function (e, dt, node, config) {
                        SecurityRoles.download().$promise
                            .then(function (data) {
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_SecurityRole.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    },
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ])
    .withPaginationType('full_numbers')


    .withOption('createdRow', function (row) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
    })
    .withOption('saveState', true)
    .withOption('order', [0, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
    .withOption("pageLength", 25);


        vm.dtColumns = [
                      DTColumnBuilder.newColumn('securityRoleName').withTitle('Security Role Name'),
                      DTColumnBuilder.newColumn('securityRoleDesc').withTitle('Security Role Desc'),
                      DTColumnBuilder.newColumn('publicRoleFlag').withTitle('Public Role Flag'),
                      DTColumnBuilder.newColumn('autoAssignFlag').withTitle('Auto Assign Flag')
                ];


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountDialogController', NasracAdminUserAccountDialogController);

    NasracAdminUserAccountDialogController.$inject = ['$timeout','$state', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracAdminUserAccount', 'NasracAdminCustomerAccount'];

    function NasracAdminUserAccountDialogController ($timeout, $state, $scope, $stateParams, $uibModalInstance, entity, NasracAdminUserAccount, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminUserAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.nasracadmincustomeraccounts = NasracAdminCustomerAccount.query();
        vm.nasracAdminUserAccount.securityRoles = angular.fromJson(vm.nasracAdminUserAccount.securityRoles);
        vm.securityRolesMap = NasracAdminUserAccount.get_security_roles();
        vm.isSiteIdEnable = $state.$current.data.isSiteIdEnable;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if(vm.nasracAdminUserAccount.userFirstName === undefined || vm.nasracAdminUserAccount.userFirstName === null){
                vm.nasracAdminUserAccount.userFirstName = '';
            }
            vm.isSaving = true;
            if (vm.nasracAdminUserAccount.id !== null) {
                NasracAdminUserAccount.update(vm.nasracAdminUserAccount, onSaveSuccess, onSaveError);
            } else {
                NasracAdminUserAccount.save(vm.nasracAdminUserAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracAdminUserAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastLoginTime = false;
        vm.datePickerOpenStatus.lastActivityTime = false;
        vm.datePickerOpenStatus.lastPasswordChangeTime = false;
        vm.datePickerOpenStatus.lastLockOutTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }



        vm.models = [
            {listName: "All Security Roles", items: [], dragging: false},
            {listName: "Selected Roles", items: [], dragging: false}
          ];

        vm.securityRolesMap.$promise.then(function(data) {
        	angular.forEach(data, function(role) {
        		if (!vm.nasracAdminUserAccount.securityRoles.some(function(e){ return e.id == role.id;})) {
        				vm.models[0].items.push({label: role.securityRoleName, id: role.id});
        			} else {
        				vm.models[1].items.push({label: role.securityRoleName, id: role.id});
        			}

          	});
        });


        vm.getSelectedItemsIncluding = function(list, item) {
            item.selected = true;
            return list.items.filter(function(item) { return item.selected; });
          };

          /**
           * We set the list into dragging state, meaning the items that are being
           * dragged are hidden. We also use the HTML5 API directly to set a custom
           * image, since otherwise only the one item that the user actually dragged
           * would be shown as drag image.
           */
          vm.onDragstart = function(list, event) {
             list.dragging = true;
             /*if (event.dataTransfer.setDragImage) {
               var img = new Image();
               img.src = 'framework/vendor/ic_content_copy_black_24dp_2x.png';
               event.dataTransfer.setDragImage(img, 0, 0);
             }*/
          };

          /**
           * In the dnd-drop callback, we now have to handle the data array that we
           * sent above. We handle the insertion into the list ourselves. By returning
           * true, the dnd-list directive won't do the insertion itself.
           */
          vm.onDrop = function(list, items, index) {
            angular.forEach(items, function(item) { item.selected = false; });
            list.items = list.items.slice(0, index)
                        .concat(items)
                        .concat(list.items.slice(index));
            return true;
          }

          /**
           * Last but not least, we have to remove the previously dragged items in the
           * dnd-moved callback.
           */
          vm.onMoved = function(list) {
            list.items = list.items.filter(function(item) { return !item.selected; });
            vm.nasracAdminUserAccount.securityRoles = vm.models[1].items;
          };




    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountDetailController', NasracAdminUserAccountDetailController);

    NasracAdminUserAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NasracAdminUserAccount', 'NasracAdminCustomerAccount'];

    function NasracAdminUserAccountDetailController($scope, $rootScope, $stateParams, previousState, entity, NasracAdminUserAccount, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminUserAccount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:nasracAdminUserAccountUpdate', function(event, result) {
            vm.nasracAdminUserAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountDeleteController',NasracAdminUserAccountDeleteController);

    NasracAdminUserAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracAdminUserAccount'];

    function NasracAdminUserAccountDeleteController($uibModalInstance, entity, NasracAdminUserAccount) {
        var vm = this;

        vm.nasracAdminUserAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracAdminUserAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('nasrac-admin-user-account', {
            parent: 'nasrac-admin',
            url: '/nasrac-admin-user-account',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminUserAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-accounts.html',
                    controller: 'NasracAdminUserAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminUserAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nasrac-admin-user-account-detail', {
            parent: 'nasrac-admin-user-account',
            url: '/nasrac-admin-user-account/{id}',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminUserAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-detail.html',
                    controller: 'NasracAdminUserAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminUserAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NasracAdminUserAccount', function($stateParams, NasracAdminUserAccount) {
                    return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nasrac-admin-user-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nasrac-admin-user-account-detail.edit', {
            parent: 'nasrac-admin-user-account-detail',
            url: '/detail/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html',
                    controller: 'NasracAdminUserAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminUserAccount', function(NasracAdminUserAccount) {
                            return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-user-account.new', {
            parent: 'nasrac-admin-user-account',
            url: '/new',
            data: {
                authorities: roles,
                isSiteIdEnable:false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html',
                    controller: 'NasracAdminUserAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                login: null,
                                password: null,
                                lastName: null,
                                displayName: null,
                                email: null,
                                id: null,
                                securityRoles: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-user-account', null, { reload: 'nasrac-admin-user-account' });
                }, function() {
                    $state.go('nasrac-admin-user-account');
                });
            }]
        })
        .state('nasrac-admin-user-account.edit', {
            parent: 'nasrac-admin-user-account',
            url: '/{id}/edit',
            data: {
                authorities: roles,
                isSiteIdEnable:true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html',
                    controller: 'NasracAdminUserAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminUserAccount', function(NasracAdminUserAccount) {
                            return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-user-account', null, { reload: 'nasrac-admin-user-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-user-account.delete', {
            parent: 'nasrac-admin-user-account',
            url: '/{id}/delete',
            data: {
                authorities: roles,
                isSiteIdEnable:true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-delete-dialog.html',
                    controller: 'NasracAdminUserAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracAdminUserAccount', function(NasracAdminUserAccount) {
                            return NasracAdminUserAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-user-account', null, { reload: 'nasrac-admin-user-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracAdminUserAccount', NasracAdminUserAccount);

    NasracAdminUserAccount.$inject = ['$resource', 'DateUtils'];

    function NasracAdminUserAccount ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-admin-user-accounts/:id';
        var xlsxContentType = 'application/octet-stream';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastLoginTime = DateUtils.convertDateTimeFromServer(data.lastLoginTime);
                        data.lastActivityTime = DateUtils.convertDateTimeFromServer(data.lastActivityTime);
                        data.lastPasswordChangeTime = DateUtils.convertDateTimeFromServer(data.lastPasswordChangeTime);
                        data.lastLockOutTime = DateUtils.convertDateTimeFromServer(data.lastLockOutTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
                method : 'GET',
                url : 'api/nasrac-admin-user-accounts/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'get_security_roles': { method: 'GET', url: 'api/nasrac-admin-user-accounts/security-roles', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountController', NasracAdminUserAccountController);
    window.localStorage.removeItem("DataTables_usersearchbar_/");
    NasracAdminUserAccountController.$inject = ['$scope', '$state',  'NasracPackage', 'NasracAdminUserAccount', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal' ];

    function NasracAdminUserAccountController ($scope, $state, NasracPackage, NasracAdminUserAccount, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracAdminUserAccounts = [];
        vm.nasracAdminUserAccounts = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};
        var dacAdminNonPrivilegeRoles = ['Administrators', 'Billing Administrator', 'Billing User'];

        loadAll();

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-admin-user-accounts/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },

            data: function(data, dtInstance) {
                data.columns.shift();
                data.order[0].column = data.order[0].column - 1;
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
	.withBootstrap()
	.withPaginationType('full_numbers')
	.withDisplayLength(25)

	.withOption('createdRow', function (row) {
		// Recompiling so we can bind Angular directive to the DT
	        $compile(angular.element(row).contents())($scope);
	})
	.withOption('saveState', true)
	.withOption('order', [1, 'asc'])
    .withButtons([
        {
            text: 'Export',
            extend: "excelHtml5",
            title:"NasracAdminUserAccount",
            action: function (e, dt, node, config) {
                NasracPackage.downloadUserAccounts().$promise
                    .then(function (data) {
                        var url = URL.createObjectURL(data.response);
                        var link = document.createElement("a");
                        link.href = url;

                        //set the visibility hidden so it will not effect on your web-layout
                        link.style = "visibility:hidden";
                        link.download = "NAS_RAC-Admin_User_Accounts.xlsx"; //this is an example file to download, use yours

                        //this part will append the anchor tag and remove it after automatic click
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    });
            },
            exportOptions: {
                columns: ':visible'
            },
            //CharSet: "utf8",
            exportData: { decodeEntities: true }
        }
    ])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '85px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('login').withTitle('Login'),
              DTColumnBuilder.newColumn('displayName').withTitle('Display Name'),
              //DTColumnBuilder.newColumn('password').withTitle('Password'),
              DTColumnBuilder.newColumn('siteId').withTitle('Site Id'),
              DTColumnBuilder.newColumn('firstName').withTitle('First Name'),
              DTColumnBuilder.newColumn('lastName').withTitle('Last Name'),

              DTColumnBuilder.newColumn('email').withTitle('Email'),
              DTColumnBuilder.newColumn('createdDate').withTitle('Created Date').renderWith(function(data,type,full) {
            	  data = $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ');
            	  if (data) { data += abbr; }
                  return data;

              }),
              DTColumnBuilder.newColumn('lastLoginTime').withTitle('Last Login Time').renderWith(function(data,type,full) {
            	  data = $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ');
            	  if (data) { data += abbr; }
                  return data;

              })/*,
              DTColumnBuilder.newColumn('authorizeFlag').withTitle('AuthorizeFlag'),
              DTColumnBuilder.newColumn('notifyFlag').withTitle('NotifyFlag'),
              DTColumnBuilder.newColumn('createdDate').withTitle('CreatedDate'),
              DTColumnBuilder.newColumn('lastLoginTime').withTitle('LastLoginTime'),
              DTColumnBuilder.newColumn('lastActivityTime').withTitle('LastActivityTime'),
              DTColumnBuilder.newColumn('lastPasswordChangeTime').withTitle('LastPasswordChangeTime'),
              DTColumnBuilder.newColumn('lastLockOutTime').withTitle('LastLockOutTime'),
              DTColumnBuilder.newColumn('userOnlineFlag').withTitle('UserOnlineFlag'),
              DTColumnBuilder.newColumn('userLockOutFlag').withTitle('UserLockOutFlag'),
              DTColumnBuilder.newColumn('userPasswordUpdFlag').withTitle('UserPasswordUpdFlag')*/

        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }

        function loadAll() {
            NasracAdminUserAccount.query(function(result) {
                vm.nasracAdminUserAccounts = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
        	if (Principal.hasAnyAuthority(['Administrators'])){
        		return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        	} else {
        		if(anyRolesMatch(data.securityRoles, dacAdminNonPrivilegeRoles) ) {
            		return GUIUtils.getActionsTemplate(data, $state.current.name, []);
            	} else {
            		return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
            	}
        	}

        }

        function search() {
         vm.dtInstance.reloadData();
        }

        function anyRolesMatch(userRoles, nonPrivilegeRoles) {
        	  return userRoles.some(function(role) {
        		  return nonPrivilegeRoles.includes(role.securityRoleName);
        	  });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountDialogController', NasracAdminCustomerAccountDialogController);

    NasracAdminCustomerAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','$state', 'entity', 'NasracAdminCustomerAccount'];

    function NasracAdminCustomerAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance,$state, entity, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminCustomerAccount = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.isReadOnly = $state.$current.data.isReadOnly;
            $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nasracAdminCustomerAccount.id !== null) {
                NasracAdminCustomerAccount.update(vm.nasracAdminCustomerAccount, onSaveSuccess, onSaveError);
            } else {
                NasracAdminCustomerAccount.save(vm.nasracAdminCustomerAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracAdminCustomerAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.launchDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountDetailController', NasracAdminCustomerAccountDetailController);

    NasracAdminCustomerAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NasracAdminCustomerAccount'];

    function NasracAdminCustomerAccountDetailController($scope, $rootScope, $stateParams, previousState, entity, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminCustomerAccount = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:nasracAdminCustomerAccountUpdate', function(event, result) {
            vm.nasracAdminCustomerAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountDeleteController',NasracAdminCustomerAccountDeleteController);

    NasracAdminCustomerAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracAdminCustomerAccount'];

    function NasracAdminCustomerAccountDeleteController($uibModalInstance, entity, NasracAdminCustomerAccount) {
        var vm = this;

        vm.nasracAdminCustomerAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracAdminCustomerAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('nasrac-admin-customer-account', {
            parent: 'nasrac-admin',
            url: '/nasrac-admin-customer-account',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminCustomerAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-accounts.html',
                    controller: 'NasracAdminCustomerAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminCustomerAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nasrac-admin-customer-account-detail', {
            parent: 'nasrac-admin-customer-account',
            url: '/nasrac-admin-customer-account/{id}',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracAdminCustomerAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-detail.html',
                    controller: 'NasracAdminCustomerAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracAdminCustomerAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NasracAdminCustomerAccount', function($stateParams, NasracAdminCustomerAccount) {
                    return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nasrac-admin-customer-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nasrac-admin-customer-account-detail.edit', {
            parent: 'nasrac-admin-customer-account-detail',
            url: '/detail/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html',
                    controller: 'NasracAdminCustomerAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminCustomerAccount', function(NasracAdminCustomerAccount) {
                            return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-customer-account.new', {
            parent: 'nasrac-admin-customer-account',
            url: '/new',
            data: {
                authorities: roles,
                isReadOnly: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html',
                    controller: 'NasracAdminCustomerAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                siteId: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                phone: null,
                                address: null,
                                city: null,
                                country: null,
                                state: null,
                                zipcode: null,
                                launchDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-customer-account', null, { reload: 'nasrac-admin-customer-account' });
                }, function() {
                    $state.go('nasrac-admin-customer-account');
                });
            }]
        })
        .state('nasrac-admin-customer-account.edit', {
            parent: 'nasrac-admin-customer-account',
            url: '/{id}/edit',
            data: {
                authorities: roles,
                isReadOnly: true

            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html',
                    controller: 'NasracAdminCustomerAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracAdminCustomerAccount', function(NasracAdminCustomerAccount) {
                            return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-customer-account', null, { reload: 'nasrac-admin-customer-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nasrac-admin-customer-account.delete', {
            parent: 'nasrac-admin-customer-account',
            url: '/{id}/delete',
            data: {
                authorities: roles,
                isReadOnly: true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-delete-dialog.html',
                    controller: 'NasracAdminCustomerAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracAdminCustomerAccount', function(NasracAdminCustomerAccount) {
                            return NasracAdminCustomerAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nasrac-admin-customer-account', null, { reload: 'nasrac-admin-customer-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracAdminCustomerAccount', NasracAdminCustomerAccount);

    NasracAdminCustomerAccount.$inject = ['$resource', 'DateUtils'];

    function NasracAdminCustomerAccount ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-admin-customer-accounts/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.launchDate = DateUtils.convertDateTimeFromServer(data.launchDate);
                    }
                    return data;
                }
            },'download' : {
                method : 'GET',
                url : 'api/nasrac-admin-customer-accounts/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountController', NasracAdminCustomerAccountController);
    //remove localstorage for data tables on Page reload
    window.localStorage.removeItem("DataTables_customerusersearchbar_/");

    NasracAdminCustomerAccountController.$inject = ['$scope', '$state', 'NasracAdminCustomerAccount', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal' ];

    function NasracAdminCustomerAccountController ($scope, $state, NasracAdminCustomerAccount, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracAdminCustomerAccounts = [];
        vm.nasracAdminCustomerAccounts = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};

        loadAll();

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();
        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-admin-customer-accounts/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {
                data.columns.shift();
                data.order[0].column = data.order[0].column - 1;
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            }).withPaginationType('full_numbers')
            .withButtons([
                {
                    text: 'Export',
                    extend: "excelHtml5",
                    title:"Customer Account Types",
                    action: function (e, dt, node, config) {
                        NasracAdminCustomerAccount.download().$promise
                            .then(function (data) {
                                //console.log(data);
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_CustomerAccount.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    },
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ])

	.withDisplayLength(25)

	.withOption('createdRow', function (row) {
		// Recompiling so we can bind Angular directive to the DT
	        $compile(angular.element(row).contents())($scope);
	})
	.withOption('saveState', true)
	.withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '85px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('siteId').withTitle('Site Id'),
              DTColumnBuilder.newColumn('firstName').withTitle('First Name'),
              DTColumnBuilder.newColumn('lastName').withTitle('Last Name'),
              DTColumnBuilder.newColumn('email').withTitle('Email'),
              DTColumnBuilder.newColumn('phone').withTitle('Phone'),
              //DTColumnBuilder.newColumn('address').withTitle('Address'),
              //DTColumnBuilder.newColumn('city').withTitle('City'),
              //DTColumnBuilder.newColumn('country').withTitle('Country'),
              //DTColumnBuilder.newColumn('state').withTitle('State'),
              //DTColumnBuilder.newColumn('zipcode').withTitle('Zipcode'),
              DTColumnBuilder.newColumn('launchDate').withTitle('Launch Date').renderWith(function(data,type,full) {
            	  data = $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ');
            	  if (data) {
            		  data += abbr;
            	  }
                  return data;

              })

        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }

        function loadAll() {
            NasracAdminCustomerAccount.query(function(result) {
                vm.nasracAdminCustomerAccounts = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

        // vm.dtOptions.withOption("stateSave",true);
        // if($rootScope.IsSuccess==true) {
        //     if(vm.dtInstance!=undefined) {
        //         vm.dtInstance.DataTable.state.clear();
        //         //vm.dtInstance.reloadData();
        //         vm.dtInstance.DataTable.rerender();
        //     }
        //     vm.dtOptions.withOption("stateSave",true);
        // }
        // else {
        //
        //     //vm.dtOptions.withOption("stateSave",false);
        //     if(vm.dtInstance!=undefined) {
        //         vm.dtInstance.DataTable.state.clear();
        //         // vm.dtInstance.reloadData();
        //         vm.dtInstance.DataTable.rerender();
        //     }
        // }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('nasrac-admin', {
        	abstract: true,
            parent: 'app',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User']
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$rootScope','$scope','Idle','$uibModal','$uibModalStack'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, $rootScope,$scope,Idle,$uibModal,$uibModalStack) {
        var vm = this;

        vm.isAdmin;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
        var copyAccount = function (account) {
            return {
                displayName: account.displayName,
            };
        };
        Principal.identity().then(function(account) {
            vm.accountDetails = copyAccount(account);
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.checkUser = checkUser;
        vm.$state = $state;

        vm.navbar = {
        		fullAccessRoles: "Administrators",
        		adminMenuRoles: "Administrators,DAC Content Administrator,DAC Content User",
        		astbMenuRoles: "Administrators,Billing Administrator,Billing User",
        		dacMenuRoles: "Administrators,DAC Content Administrator,DAC Content User",
        		reportsMenuRoles: "Administrators,DAC Content Administrator,DAC Content User,Customer Users"
        	};
        if(Principal.isAuthenticated())
        {

            Idle.watch();

            $rootScope.$on('IdleStart', function () {
                $uibModal.open({
                    templateUrl: 'app/idleSessionTimeOut.html',
                    windowClass: 'modal-danger',
                    backdrop: false,
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $rootScope.ok=function(){
                                $uibModalStack.dismiss($uibModalStack.getTop().key);
                                Idle.watch();
                            }
                            $rootScope.logout=function(){
                                $uibModalStack.dismissAll();
                                Idle.unwatch();
                                Auth.logout();
                                $state.go('sign-out-home-page', {}, {
                                    reload : true
                                });
                                LoginService.open();
                            }
                        }]
                });

            });
            $rootScope.$on('IdleEnd', function() {

                $uibModalStack.dismiss($uibModalStack.getTop().key);


            });

            $rootScope.$on('IdleTimeout', function () {


                $uibModalStack.dismiss($uibModalStack.getTop().key);
                Idle.unwatch();
                Auth.logout();
                $state.go('sign-out-home-page', {}, {
                    reload : true
                });
                LoginService.open();
            });
        }else {
            Idle.unwatch();
        }

        function login() {
            collapseNavbar();
            LoginService.open();

        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('sign-out-home-page', {}, {
				reload : true
			});
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function checkUser() {
        	var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result){
                vm.isAdmin  = result;

                if(vm.isAdmin === true && Principal.isAuthenticated()){
                    $state.go('home-main.home-page', {}, {
                        reload : false
                    });
                }
                else if(vm.isAdmin===false && Principal.isAuthenticated()){
                    $state.go('user-home-page', {}, {
                        reload : false
                    });
                }
                else{
                    $state.go('sign-out-home-page', {}, {
                        reload : false
                    });
                }
            });


        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

/**
 * Created by rkotha on 8/18/2017.
 */
<!-- This state executes user logs in-->
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('user-home-page', {
            parent: 'app',
            url: '/userhomepage',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/user-home-page/user-home-page.html',
                    controller: 'UserHomePageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('userhomePage');
                    return $translate.refresh();
                }],
                contactEntities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'arrisAccountContacts'}).$promise;
                }],
                announcementsEntities:['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'importantAnnouncements'}).$promise;
                }]


            }
        });
    }
})();

/**
 * Created by rkotha on 8/21/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('UserHomePageController', UserHomePageController);

    UserHomePageController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'contactEntities','announcementsEntities', 'NasracWebContent'];

    function UserHomePageController ($scope, Principal, LoginService, $state, $sce, contactEntities, announcementsEntities,NasracWebContent) {
        //var vm = this;

        var contactsEntity = contactEntities[0];
        var announcementEntity = announcementsEntities[0];
        $scope.contactsTrustedHtml = $sce.trustAsHtml(contactsEntity.content);
        $scope.announcementsTrustedHtml = $sce.trustAsHtml(announcementEntity.content);

    }
})();

/**
 * Created by rkotha on 8/23/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sign-out-home-page', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/sign-out-home-page/sign-out-home-page.html',
                    controller: 'SignOutHomePageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('signOutHomePage');
                    return $translate.refresh();
                }],
                entities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'home'}).$promise;
                }],


            }
        });
    }
})();

/**
 * Created by rkotha on 8/23/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SignOutHomePageController', SignOutHomePageController);

    SignOutHomePageController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce','entities', 'NasracWebContent'];

    function SignOutHomePageController ($scope, Principal, LoginService, $state, $sce, entities,NasracWebContent) {
        var vm = this;

        var Entity = entities[0];
        $scope.contactsTrustedHtml = $sce.trustAsHtml(Entity.content);

        getAccount();

        function getAccount() {
        	var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result){
                vm.isAdmin  = result;

                if(vm.isAdmin === true && Principal.isAuthenticated()){
                    $state.go('home-main.home-page', {}, {
                        reload : false
                    });
                }
                else if(vm.isAdmin===false && Principal.isAuthenticated()){
                    $state.go('user-home-page', {}, {
                        reload : false
                    });
                }
                else{
                    $state.go('sign-out-home-page', {}, {
                        reload : false
                    });
                }
            });
        }

    }
})();

/**
 * Created by rkotha on 8/17/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ImportantAnnouncementsController', ImportantAnnouncementsController);

    ImportantAnnouncementsController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'entities', 'NasracWebContent'];

    function ImportantAnnouncementsController ($scope, Principal, LoginService, $state, $sce, entities, NasracWebContent) {
        var vm = this;
        vm.homePageAnnouncements = {
        		adminRoles: "Administrators"
        	};

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        var entity = entities[0];
        vm.nasrac_web_content = entity;
        $scope.trustedHtml = $sce.trustAsHtml(entity.content);
        $scope.tinymceModel = entity.content;
        vm.clear = $scope.cancelEditor

        $scope.editMode = false;

        $scope.tinymceOptions = {
            inline : false,
            plugins : [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'template paste textcolor colorpicker textpattern imagetools codesample toc'
            ],
            toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
            fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            skin : 'lightgray',
            theme : 'modern',
            height : 600
        };

        $scope.updateContents = function() {
            entity.content = $scope.tinymceModel;
            NasracWebContent.update(entity, onSaveSuccess, onSaveError);
            $scope.editMode = false;
        };

        $scope.cancelEditor = function() {
            $scope.editMode = false;
        }

        $scope.openEditor = function() {
            $scope.editMode = true;
        }



        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function onSaveSuccess(result) {
            $scope.editMode = false;
            $state.go('home-main.important-announcements', {}, {
             reload : 'home-main.important-announcements'
             });
        }

        function onSaveError() {
            $scope.editMode = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('HomePageController', HomePageController);

    HomePageController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'homeEntities', 'NasracWebContent'];

    function HomePageController ($scope, Principal, LoginService, $state, $sce, homeEntities, NasracWebContent) {
        var vm = this;
        
        vm.homePage = {
        		adminRoles: "Administrators"
        	};

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        var entity = homeEntities[0];
        vm.nasrac_web_content = entity;
        $scope.trustedHtml = $sce.trustAsHtml(entity.content);
        $scope.tinymceModel = entity.content;
        vm.clear = $scope.cancelEditor

        $scope.editMode = false;

        $scope.tinymceOptions = {
            inline : false,
            plugins : [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'template paste textcolor colorpicker textpattern imagetools codesample toc'
            ],
            toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
            fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            skin : 'lightgray',
            theme : 'modern',
            height : 600
        };

        $scope.updateContents = function() {
            entity.content = $scope.tinymceModel;
            NasracWebContent.update(entity, onSaveSuccess, onSaveError);
            $scope.editMode = false;
        };

        $scope.cancelEditor = function() {
            $scope.editMode = false;
        }

        $scope.openEditor = function() {
            $scope.editMode = true;
        }

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function onSaveSuccess(result) {
            $scope.editMode = false;
            $state.go('home-main.home-page', {}, {
                reload : 'home-main.home-page'
            });
        }

        function onSaveError() {
            $scope.editMode = true;
        }
    }
})();

/**
 * Created by rkotha on 8/17/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators'];
        $stateProvider.state('home', {
            abstract: true,
            parent: 'app'
        }).state('home-main', {
            abstract: true,
            parent: 'home',
            url: '/home-main',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.homePage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('home-main.home-page', {
            url: '/adminhomePage',
            templateUrl: 'app/home/home-page/home-page.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.homePage.home.title'
            },
            controller: 'HomePageController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homePage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                homeEntities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'home'}).$promise;
                }]
            }
        }).state('home-main.arris-account-contacts', {
            url: '/arrisAccountContacts',
            templateUrl: 'app/home/arris-account-contacts/arris-account-contacts.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.arrisAccountContacts.home.title'
            },
            controller: 'ArrisAccountContactsController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('arrisAccountContacts');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'arrisAccountContacts'}).$promise;
                }]
            }
        }).state('home-main.important-announcements', {
            url: '/importantAnnouncements',
            templateUrl: 'app/home/important-announcements/important-announcements.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.importantAnnouncements.home.title'
            },
            controller: 'ImportantAnnouncementsController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('importantAnnouncements');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'importantAnnouncements'}).$promise;
                }]
            }
        });
    }
})();

/**
 * Created by rkotha on 8/17/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('HomeMainController', HomeMainController);

    HomeMainController.$inject = ['$scope', 'Principal', 'LoginService', '$state','$rootScope','$window'];

    function HomeMainController($scope, Principal, LoginService, $state,$rootScope,$window) {
        var vm = this;
        vm.isAdmin;
        var adminAuthorities = ['Administrators'];
        Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result){
            vm.isAdmin  = result;
            if(vm.isAdmin === true){
                $scope.go('home-main.important-announcements');
            }
            else{
                $scope.go('user-home-Page');
            }
        });
        $scope.tabData   = [
            {
                heading: 'HomePage',
                route:   'home-main.home-page',
                class: 'btn-lg'
            },
            {
                heading: 'Aurora Networks Account Contacts',
                route:   'home-main.arris-account-contacts',
                class: 'btn-lg'
            },
            {
                heading: 'Important Announcements',
                route:   'home-main.important-announcements',
                class: 'btn-lg'
            }

        ];

        $scope.go = function(route){
            $state.go(route);
        };


       // $scope.go('temp-main.home-page');

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ArrisAccountContactsController', ArrisAccountContactsController);

    ArrisAccountContactsController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'entities', 'NasracWebContent'];

    function ArrisAccountContactsController ($scope, Principal, LoginService, $state, $sce, entities, NasracWebContent) {
        var vm = this;
        vm.homePageContacts = {
        		adminRoles: "Administrators"
        	};

        vm.account = null;
        vm.isAuthenticated = null;
        vm.isUser;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        var contactsEntity = entities[0];
        vm.nasrac_web_content = contactsEntity;
        $scope.trustedHtml = $sce.trustAsHtml(contactsEntity.content);
        $scope.contactsTinymceModel = contactsEntity.content;
        vm.clear = $scope.cancelEditor;

        $scope.editMode = false;

        $scope.tinymceOptions = {
            inline : false,
            plugins : [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'template paste textcolor colorpicker textpattern imagetools codesample toc'
            ],
            toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
            fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            skin : 'lightgray',
            theme : 'modern',
            height : 600
        };

        $scope.updateContents = function() {
            contactsEntity.content = $scope.contactsTinymceModel;
            NasracWebContent.update(contactsEntity, onSaveSuccess, onSaveError);
            $scope.editMode = false;
        };

        $scope.cancelEditor = function() {
            $scope.editMode = false;
        };

        $scope.openEditor = function() {
            $scope.editMode = true;
        };

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
            Principal.hasAuthority('Customer Users').then(function(result){
               vm.isUser = true;
            });
        }

        function register() {
            $state.go('register');
        }

        function onSaveSuccess(result) {
            $scope.editMode = false;
            $state.go('home-main.arris-account-contacts', {}, {
                reload : 'home-main.arris-account-contacts'
            });
        }

        function onSaveError() {
            $scope.editMode = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('feedback', {
            parent: 'app',
            url: '/feedback',
            data: {
                authorities: [],
                pageTitle: 'nasracApp.feedback.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/feedback/feedback.html',
                    controller: 'FeedbackController',
                    controllerAs: 'FeedbackCtrl'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('feedback');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular.module('nasracApp').factory('Feedback', Feedback);

    Feedback.$inject = [ '$resource' ];

    function Feedback($resource) {
        var resourceUrl = 'api/feedback';

        return $resource(resourceUrl, {}, {
            'saveFeedbackForm': {
                method:'POST'
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FeedbackController', FeedbackController);

    FeedbackController.$inject = ['$scope', 'Principal', '$state','Feedback','AlertService', '$timeout'];

    function FeedbackController ($scope, Principal, $state,Feedback,AlertServic, $timeout) {

        $scope.tinymceOptions = {
            inline : false,
            plugins : [
                'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                'searchreplace wordcount visualblocks visualchars code fullscreen',
                'insertdatetime media nonbreaking save table contextmenu directionality',
                'template paste textcolor colorpicker textpattern imagetools codesample toc'
            ],
            toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
            fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            skin : 'lightgray',
            theme : 'modern',
            height : 400
        };
        $scope.sendFeedBack = function(){
        	$scope.messageError = false;
        	if(!$scope.feedback.message || $scope.feedback.message.length<1 || $scope.feedback.message == ""){
        		$scope.messageError = true;
        		return;
        	}
            Feedback.saveFeedbackForm($scope.feedback, function(responce){
                if(responce){
                    $scope.isSaved = true;
                	init();
                   // AlertService.success("success","","top");
                }
            });
        };
        var init = function(){
        	 Principal.identity().then(function(account) {
                 $scope.feedback = {};
                 $scope.feedback.name = account.firstName +" "+account.lastName;
                 $scope.feedback.email = account.email;
                 $scope.feedback.siteId=account.siteId;

             });
            $timeout( function(){
                $scope.isSaved = false;
            }, 10000 );
        };
        init();
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('faq', {
            parent: 'app',
            url: '/faq',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/faq/faq.html',
                    controller: 'FaqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                faqEntities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'faq'}).$promise;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('FaqController', FaqController);

    FaqController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'faqEntities', 'NasracWebContent'];

    function FaqController ($scope, Principal, LoginService, $state, $sce, faqEntities, NasracWebContent) {
    	var vm = this;
    	

		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		var entity = faqEntities[0];
		vm.nasrac_web_content = entity;
		vm.trustedHtml = $sce.trustAsHtml(entity.content);
		vm.tinymceModel = entity.content;

		vm.editMode = false;

		vm.tinymceOptions = {
			inline : false,
			plugins : [
			    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
			    'searchreplace wordcount visualblocks visualchars code fullscreen',
			    'insertdatetime media nonbreaking save table contextmenu directionality',
			    'template paste textcolor colorpicker textpattern imagetools codesample toc'
			  ],
			toolbar : 'undo redo | fontselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | print preview media fullpage | forecolor backcolor',
			fontsize_formats : '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
			skin : 'lightgray',
			theme : 'modern',
			height : 600	
		};

		vm.updateContents = function() {
			entity.content = vm.tinymceModel;
			NasracWebContent.update(entity, onSaveSuccess, onSaveError);
			vm.editMode = false;
		};

		vm.cancelEditor = function() {
			vm.editMode = false;
		}

		vm.openEditor = function() {
			vm.editMode = true;
		}

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}
		
		function register() {
			$state.go('register');
		}

		function onSaveSuccess(result) {
			vm.editMode = false;
			$state.go('faq', {}, {
				reload : true
			});
		}

		function onSaveError() {
			vm.editMode = true;
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceTypeDialogController', NasracSourceTypeDialogController);

    NasracSourceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracSourceType'];

    function NasracSourceTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracSourceType) {
        var vm = this;

        vm.nasracSourceType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nasracSourceType.id !== null) {
                NasracSourceType.update(vm.nasracSourceType, onSaveSuccess, onSaveError);
            } else {
                NasracSourceType.save(vm.nasracSourceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracSourceTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceTypeDeleteController',NasracSourceTypeDeleteController);

    NasracSourceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracSourceType'];

    function NasracSourceTypeDeleteController($uibModalInstance, entity, NasracSourceType) {
        var vm = this;

        vm.nasracSourceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, sourceType) {
            NasracSourceType.delete({id: id, sourceType: sourceType},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-source-type', {
            //parent: 'dac-content-main',
            url: '/nasrac-source-type',
            templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-types.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracSourceType.home.title'
            },
            controller: 'NasracSourceTypeController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracSourceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-source-type.new', {
            parent: 'dac-content-main.nasrac-source-type',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-type-dialog.html',
                    controller: 'NasracSourceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sourceTypeId: null,
                                sourceType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source-type', null, { reload: 'dac-content-main.nasrac-source-type' });
                }, function() {
                    $state.go('dac-content-main.nasrac-source-type');
                });
            }]
        })
        .state('dac-content-main.nasrac-source-type.edit', {
            parent: 'dac-content-main.nasrac-source-type',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-type-dialog.html',
                    controller: 'NasracSourceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracSourceType', function(NasracSourceType) {
                            return NasracSourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source-type', null, { reload: 'dac-content-main.nasrac-source-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-source-type.delete', {
            parent: 'dac-content-main.nasrac-source-type',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source-type/nasrac-source-type-delete-dialog.html',
                    controller: 'NasracSourceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracSourceType', function(NasracSourceType) {
                            return NasracSourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source-type', null, { reload: 'dac-content-main.nasrac-source-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracSourceType', NasracSourceType);

    NasracSourceType.$inject = ['$resource'];

    function NasracSourceType ($resource) {
        var resourceUrl =  'api/nasrac-source-types/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
			'download' : {
				method : 'GET',
				url : 'api/nasrac-source-types/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},
			'delete' : {
				method: 'DELETE',
				url: 'api/nasrac-source-types/:id/:sourceType'
			}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceTypeController', NasracSourceTypeController);
    window.localStorage.removeItem("DataTables_nasracsourcetypebar_/");
    NasracSourceTypeController.$inject = ['$scope', '$state', 'NasracSourceType', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile' , 'AuthServerProvider', 'Principal'];

    function NasracSourceTypeController ($scope, $state, NasracSourceType, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracSourceTypes = [];
        vm.nasracSourceTypes = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-source-types/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                data.columns.shift();
                data.order[0].column = data.order[0].column - 1;
            	//alert(JSON.stringify(data));
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
	.withBootstrap()
	.withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        })
        .withButtons([
	    {
	    	text: 'Export',
	    	extend: "excelHtml5",
	        title:"Nasrac Source Types",
	        action: function (e, dt, node, config) {
	    	    console.log(JSON.stringify(NasracSourceType));
	        	NasracSourceType.download().$promise
	            .then(function (data) {
	            	//console.log(data);
	            	var url = URL.createObjectURL(data.response);
	            	var link = document.createElement("a");
	        	    link.href = url;

	        	    //set the visibility hidden so it will not effect on your web-layout
	        	    link.style = "visibility:hidden";
	        	    link.download = "NAS-RAC_SourcesTypes.xlsx"; //this is an example file to download, use yours

	        	    //this part will append the anchor tag and remove it after automatic click
	        	    document.body.appendChild(link);
	        	    link.click();
	        	    document.body.removeChild(link);
	              });
	        },
	        exportOptions: {
	            columns: ':visible'
	        },
	        //CharSet: "utf8",
	        exportData: { decodeEntities: true }
	    }
	])
	.withPaginationType('full_numbers')
	.withDisplayLength(25)

	.withOption('createdRow', function (row) {
		// Recompiling so we can bind Angular directive to the DT
	        $compile(angular.element(row).contents())($scope);
	})
	.withOption('saveState', true)
	.withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);



        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '80px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('id').withTitle('Source Type Id'),
              DTColumnBuilder.newColumn('sourceType').withTitle('Source Type')


        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceDialogController', NasracSourceDialogController);

    NasracSourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracSource', 'NasracSourceType'];

    function NasracSourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracSource, NasracSourceType) {
        var vm = this;

        vm.nasracSource = entity;
        console.log(vm.nasracSource.id);
        vm.isSave=false;
        if(vm.nasracSource.id==null)
        {
            vm.isSave=true;
        }
        vm.clear = clear;
        vm.save = save;
        vm.nasracsourcetypes = NasracSourceType.query();

        $timeout(function (){
            if(vm.isSave)
                angular.element('.form-group:eq(0)>input').focus();
            else
                angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if (vm.isSave) {
                NasracSource.save(vm.nasracSource, onSaveSuccess, onSaveError);
            } else {
                NasracSource.update(vm.nasracSource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracSourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceDeleteController',NasracSourceDeleteController);

    NasracSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracSource'];

    function NasracSourceDeleteController($uibModalInstance, entity, NasracSource) {
        var vm = this;

        vm.nasracSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, sourceName) {
            NasracSource.delete({id: id, sourceName: sourceName},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-source', {
            parent: 'dac-content-main',
            url: '/nasrac-source',
            templateUrl: 'app/dac-content/nasrac-source/nasrac-sources.html',
            controller: 'NasracSourceController',
            controllerAs: 'vm',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracSource.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracSource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-source.new', {
            parent: 'dac-content-main.nasrac-source',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source/nasrac-source-dialog.html',
                    controller: 'NasracSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                               // sourceId: null,
                                sourceName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source', null, { reload: 'dac-content-main.nasrac-source' });
                }, function() {
                    $state.go('dac-content-main.nasrac-source');
                });
            }]
        })
        .state('dac-content-main.nasrac-source.edit', {
            parent: 'dac-content-main.nasrac-source',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source/nasrac-source-dialog.html',
                    controller: 'NasracSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracSource', function(NasracSource) {
                            return NasracSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source', null, { reload: 'dac-content-main.nasrac-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-source.delete', {
            parent: 'dac-content-main.nasrac-source',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source/nasrac-source-delete-dialog.html',
                    controller: 'NasracSourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracSource', function(NasracSource) {
                            return NasracSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source', null, { reload: 'dac-content-main.nasrac-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracSource', NasracSource);

    NasracSource.$inject = ['$resource'];

    function NasracSource ($resource) {
        var resourceUrl =  'api/nasrac-sources/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
			'download' : {
				method : 'GET',
				url : 'api/nasrac-sources/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},
			'delete' : {
				method: 'DELETE',
				url: 'api/nasrac-sources/:id/:sourceName'
			}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceController', NasracSourceController);
    window.localStorage.removeItem("DataTables_nasracsourcebar_/");
    NasracSourceController.$inject = ['$scope', '$state', 'NasracSource', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal'];

    function NasracSourceController ($scope, $state, NasracSource, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracSources = [];

        vm.nasracSources = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-sources/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                // The returned object has 'email' as property, but the server entity has 'emailAddress'
                // We need to override what we ask to the server here otherwise search will not work
//                data.columns[1].data = "emailAddress";
            	data.columns.shift();
            	data.order[0].column = data.order[0].column - 1;
            	data.columns[2].data = 'nasracSourceType.sourceType';

                // Any values you set on the data object will be passed along as parameters to the server
                //data.access_token = AuthenticationService.getAccessToken();
            	//alert(JSON.stringify(data));
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
        .withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        })
    .withPaginationType('full_numbers')
    .withButtons([
	    {
	    	text: 'Export',
	    	extend: "excelHtml5",
	        title:"Nasrac Sources",
	        action: function (e, dt, node, config) {
	        	NasracSource.download().$promise
	            .then(function (data) {
	            	var url = URL.createObjectURL(data.response);
	            	var link = document.createElement("a");
	        	    link.href = url;

	        	    //set the visibility hidden so it will not effect on your web-layout
	        	    link.style = "visibility:hidden";
	        	    link.download = "NAS-RAC_Sources.xlsx"; //this is an example file to download, use yours

	        	    //this part will append the anchor tag and remove it after automatic click
	        	    document.body.appendChild(link);
	        	    link.click();
	        	    document.body.removeChild(link);
	              });
	        },
	        exportOptions: {
	            columns: ':visible'
	        },
	        //CharSet: "utf8",
	        exportData: { decodeEntities: true }
	    }
	])

    .withDisplayLength(25)

    .withOption('createdRow', function (row) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
    })
    .withOption('saveState', true)
    .withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
	            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '80px').notSortable()
	            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('id').withTitle('Source Id'),
              DTColumnBuilder.newColumn('sourceName').withTitle('Source Name'),
              DTColumnBuilder.newColumn('nasracSourceTypeSourceType').withTitle('Source Type')
        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracUnusedDialogController', NasracUnusedDialogController);

    NasracUnusedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracService', 'NasracSource', 'NasracProvider'];

    function NasracUnusedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracService, NasracSource, NasracProvider) {
        var vm = this;
        vm.close = close;
        vm.nasracService = entity;

        function close () {
            $uibModalInstance.dismiss('close');
        }

        function getMissingBRSIds () {

            NasracService.query(vm.nasracService, onGetMissingBRSIdsSuccess, onGetMissingBRSIdsError);

        }

        function onGetMissingBRSIdsSuccess (result) {

            vm.unusedBsgList =findMissingNumbers(result);// result;
        }

        function onGetMissingBRSIdsError () {

        }
        function findMissingNumbers(result) {

            var a = [];
            // var missingList = [];
            var missingRangeList = [];
            for(var i=0;i<result.length;i++){
                a.push(result[i].id);
            }
            a = a.sort(function (e1, e2) {  return e1 - e2;  });



            var numberExists = true;
            var missingRange = "";
            var j = a[0];
            for (var i=0;i<a.length;i++)
            {
                if(a.length-1 !== i && a[i]+1 !== a[i+1]){
                    missingRange = a[i]+1 +""+ (a[i]+2 == a[i+1] ? "" : " - "+(a[i+1]-1).toString() );
                    missingRangeList.push(missingRange);
                } else
                {
                    continue;
                }

                /*
                if (j==a[i])
                {
                    if(!numberExists){
                        numberExists = !numberExists;
                        missingRange = missingRange +""+ (missingRange == j-1 ? "" : " - "+(j-1).toString() );
                        missingRangeList.push(missingRange);
                        missingRange = "";
                    }
                    numberExists = true;
                    j++;
                    continue;
                }
                else
                {
                    if(numberExists){
                        numberExists = !numberExists;
                        missingRange = j;
                    }
                    numberExists = false;
                    // missingList.push(j);
                    i--;
                    j++;
                }*/
            }
            return missingRangeList;

        }
        getMissingBRSIds();
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracServiceDialogController', NasracServiceDialogController);

    NasracServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracService', 'NasracSource', 'NasracProvider'];

    function NasracServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracService, NasracSource, NasracProvider) {
        var vm = this;

        vm.nasracService = entity;
        vm.isSave=false;
        if(vm.nasracService.id==null)
        {
            vm.isSave=true;
        }
        vm.clear = clear;
        vm.save = save;

        vm.clear = clear;
        vm.save = save;
        vm.nasracsources = NasracSource.query();
        vm.nasracproviders = NasracProvider.query();

        $timeout(function (){
            if(vm.isSave)
                angular.element('.form-group:eq(0)>input').focus();
            else
                angular.element('.form-group:eq(1)>select').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.isSave) {
                NasracService.save(vm.nasracService, onSaveSuccess, onSaveError);
            } else {
                NasracService.update(vm.nasracService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracServiceDeleteController',NasracServiceDeleteController);

    NasracServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracService'];

    function NasracServiceDeleteController($uibModalInstance, entity, NasracService) {
        var vm = this;

        vm.nasracService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-service', {
            parent: 'dac-content-main',
            url: '/nasrac-service',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracService.home.title'
            },
            templateUrl: 'app/dac-content/nasrac-service/nasrac-services.html',
            controller: 'NasracServiceController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-service.new', {
            parent: 'dac-content-main.nasrac-service',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-service/nasrac-service-dialog.html',
                    controller: 'NasracServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            //    bsgHandle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                }, function() {
                    $state.go('dac-content-main.nasrac-service');
                });
            }]
        })
        .state('dac-content-main.nasrac-service.unusedBsgList', {
                parent: 'dac-content-main',
                url: '/bsgList',
                data: {
                    authorities: roles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/dac-content/nasrac-service/nasrac-service-unusedBsg-dialog.html',
                        controller: 'NasracUnusedDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    //    bsgHandle: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                    }, function() {
                        $state.go('dac-content-main.nasrac-service');
                    });
                }]
        })
        .state('dac-content-main.nasrac-service.edit', {
            parent: 'dac-content-main.nasrac-service',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-service/nasrac-service-dialog.html',
                    controller: 'NasracServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracService', function(NasracService) {
                            return NasracService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-service.delete', {
            parent: 'dac-content-main.nasrac-service',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-service/nasrac-service-delete-dialog.html',
                    controller: 'NasracServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracService', function(NasracService) {
                            return NasracService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-service', null, { reload: 'dac-content-main.nasrac-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracService', NasracService);

    NasracService.$inject = ['$resource'];

    function NasracService ($resource) {
        var resourceUrl =  'api/nasrac-services/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getMissingBRSIds' : {
                method : 'GET',
                url : 'api/nasrac-services/getMissingBRSIds',
                cache: false,
                isArray: true

            },
			'download' : {
				method : 'GET',
				url : 'api/nasrac-services/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracServiceController', NasracServiceController);
    window.localStorage.removeItem("DataTables_nasracservicebar_/");
    NasracServiceController.$inject = ['$scope', '$state', 'NasracService', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile' , 'AuthServerProvider', 'Principal'];

    function NasracServiceController ($scope, $state, NasracService, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracServices = [];

        vm.nasracServices = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
				        .withOption('ajax', {
				            contentType: 'application/json',
				            url: '/api/nasrac-services/datatables-view',
				            type: 'POST',
				            beforeSend: function(xhr){
				                xhr.setRequestHeader("Authorization",
				                    "Bearer " + AuthServerProvider.getToken());
				            },
				            data: function(data, dtInstance) {

				                data.columns.shift();
				                data.order[0].column = data.order[0].column - 1;
				                data.columns[1].data = 'nasracSource.id';
				                data.columns[2].data = 'nasracSource.sourceName';
				                data.columns[3].data = 'nasracSource.nasracSourceType.sourceType';
				                data.columns[4].data = 'nasracProvider.providerType';
				            	//alert(JSON.stringify(data));
				                return JSON.stringify(data);
				            }
				        })
                        .withOption('stateSave',true)
				        .withDOM(
							"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
							"<'row'<'col-sm-12'tr>>" +
							"<'row'<'col-sm-5'i><'col-sm-7'p>>")
				        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
				        .withOption('serverSide', true)
					.withBootstrap()
					.withBootstrapOptions({
				            TableTools: {
				                classes: {
				                    container: 'btn-group',
				                    buttons: {
				                        normal: 'btn btn-danger'
				                    }
				                }
				            },
				            ColVis: {
				                classes: {
				                    masterButton: 'btn btn-primary'
				                }
				            },
				            pagination: {
				                classes: {
				                    ul: 'pagination pagination-sm'
				                }
				            }
				        })
				        .withButtons([
						    {
						    	text: 'Export',
						    	extend: "excelHtml5",
						        title:"Nasrac Services",
						        action: function (e, dt, node, config) {
						        	NasracService.download().$promise
						            .then(function (data) {
						            	var url = URL.createObjectURL(data.response);
						            	var link = document.createElement("a");
						        	    link.href = url;

						        	    //set the visibility hidden so it will not effect on your web-layout
						        	    link.style = "visibility:hidden";
						        	    link.download = "NAS-RAC_Services.xlsx"; //this is an example file to download, use yours

						        	    //this part will append the anchor tag and remove it after automatic click
						        	    document.body.appendChild(link);
						        	    link.click();
						        	    document.body.removeChild(link);
						              });
						        },
						        exportOptions: {
						            columns: ':visible'
						        },
						        //CharSet: "utf8",
						        exportData: { decodeEntities: true }
						    }
						])
					.withPaginationType('full_numbers')
					.withDisplayLength(25)

					.withOption('createdRow', function (row) {
						// Recompiling so we can bind Angular directive to the DT
					        $compile(angular.element(row).contents())($scope);
					})
					.withOption('saveState', true)
					.withOption('order', [1, 'asc'])
                    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '80px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('id').withTitle('Service BSG Handle'),
              DTColumnBuilder.newColumn('nasracSourceId').withTitle('Source Id'),
              DTColumnBuilder.newColumn('nasracSourceSourceName').withTitle('Source Name'),
              DTColumnBuilder.newColumn('nasracSourceSourceType').withTitle('Source Type'),
              DTColumnBuilder.newColumn('nasracProviderProviderType').withTitle('Provider Type')

        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracProviderDialogController', NasracProviderDialogController);

    NasracProviderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracProvider'];

    function NasracProviderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracProvider) {
        var vm = this;

        vm.nasracProvider = entity;
        vm.isSave=false;
        if(vm.nasracProvider.id==null)
        {
            vm.isSave=true;
        }
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            if(vm.isSave) {
                angular.element('.form-group:eq(0)>input').focus();
            }
            else {
                angular.element('.form-group:eq(1)>input').focus();
            }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.isSave) {
                NasracProvider.save(vm.nasracProvider, onSaveSuccess, onSaveError);
            } else {
                NasracProvider.update(vm.nasracProvider, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracProviderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracProviderDeleteController',NasracProviderDeleteController);

    NasracProviderDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracProvider'];

    function NasracProviderDeleteController($uibModalInstance, entity, NasracProvider) {
        var vm = this;

        vm.nasracProvider = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, providerType) {
            NasracProvider.delete({id: id, providerType: providerType},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-provider', {
            parent: 'dac-content-main',
            url: '/nasrac-provider',
            templateUrl: 'app/dac-content/nasrac-provider/nasrac-providers.html',
            controller: 'NasracProviderController',
            controllerAs: 'vm',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracProvider.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracProvider');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-provider.new', {
            parent: 'dac-content-main.nasrac-provider',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-provider/nasrac-provider-dialog.html',
                    controller: 'NasracProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                //providerId: null,
                                providerType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-provider', null, { reload: 'dac-content-main.nasrac-provider' });
                }, function() {
                    $state.go('dac-content-main.nasrac-provider');
                });
            }]
        })
        .state('dac-content-main.nasrac-provider.edit', {
            parent: 'dac-content-main.nasrac-provider',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-provider/nasrac-provider-dialog.html',
                    controller: 'NasracProviderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracProvider', function(NasracProvider) {
                            return NasracProvider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-provider', null, { reload: 'dac-content-main.nasrac-provider' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-provider.delete', {
            parent: 'dac-content-main.nasrac-provider',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-provider/nasrac-provider-delete-dialog.html',
                    controller: 'NasracProviderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracProvider', function(NasracProvider) {
                            return NasracProvider.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-provider', null, { reload: 'dac-content-main.nasrac-provider' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracProvider', NasracProvider);

    NasracProvider.$inject = ['$resource'];

    function NasracProvider ($resource) {
        var resourceUrl =  'api/nasrac-providers/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
			'download' : {
				method : 'GET',
				url : 'api/nasrac-providers/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},
			'delete' : {
				method: 'DELETE',
				url: 'api/nasrac-providers/:id/:providerType'
			}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracProviderController', NasracProviderController);
    window.localStorage.removeItem("DataTables_nasracproviderbar_/");
    NasracProviderController.$inject = ['$scope', '$state', 'NasracProvider', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile' , 'AuthServerProvider', 'Principal'];

    function NasracProviderController ($scope, $state, NasracProvider, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracProviders = [];

        vm.nasracProviders = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};


        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-providers/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                data.columns.shift();
                data.order[0].column = data.order[0].column - 1;
            	//alert(JSON.stringify(data));
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
	.withBootstrap()
	.withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        })
	.withPaginationType('full_numbers')
	.withDisplayLength(25)
	.withButtons([
	    {
	    	text: 'Export',
	    	extend: "excelHtml5",
	        title:"Nasrac Provider",
	        action: function (e, dt, node, config) {
	        	NasracProvider.download().$promise
	            .then(function (data) {
	            	var url = URL.createObjectURL(data.response);
	            	var link = document.createElement("a");
	        	    link.href = url;

	        	    //set the visibility hidden so it will not effect on your web-layout
	        	    link.style = "visibility:hidden";
	        	    link.download = "NAS-RAC_ProvidersSources.xlsx"; //this is an example file to download, use yours

	        	    //this part will append the anchor tag and remove it after automatic click
	        	    document.body.appendChild(link);
	        	    link.click();
	        	    document.body.removeChild(link);
	              });
	        },
	        exportOptions: {
	            columns: ':visible'
	        },
	        //CharSet: "utf8",
	        exportData: { decodeEntities: true }
	    }
	])
	.withOption('createdRow', function (row) {
		// Recompiling so we can bind Angular directive to the DT
	        $compile(angular.element(row).contents())($scope);
	})
	.withOption('saveState', true)
	.withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '80px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('id').withTitle('Provider Id'),
              DTColumnBuilder.newColumn('providerType').withTitle('Provider Type')
        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageUnusedListDialogController', NasracPackageUnusedListDialogController);

    NasracPackageUnusedListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracPackage'];

    function NasracPackageUnusedListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracPackage) {
        var vm = this;

        vm.nasracPackage = entity;
        vm.close = close;

        function close () {
            $uibModalInstance.dismiss('close');
        }

        vm.findPackageList = function  () {

                NasracPackage.query(vm.nasracPackage, onGetSuccess, onGetError);

        };

        function onGetSuccess (result) {
            vm.unusedPckList = findMissingNumbers(result);
        }

        function findMissingNumbers(result) {

            var a = [];
            // var missingList = [];
            var missingRangeList = [];
             for(var i=0;i<result.length;i++){
                 a.push(result[i].packageBsgHandle);
             }
            a = a.sort(function (e1, e2) {  return e1 - e2;  });

            var numberExists = true;
            var missingRange = "";
            var j = a[0];
            for (var i=0;i<a.length;i++)
            {
                if (j==a[i])
                {
                    if(!numberExists){
                        numberExists = !numberExists;
                        missingRange = missingRange +""+ (missingRange == j-1 ? "" : " - "+(j-1).toString() );
                        missingRangeList.push(missingRange);
                        missingRange = "";
                    }
                    numberExists = true;
                    j++;
                    continue;
                }
                else
                {
                    if(numberExists){
                        numberExists = !numberExists;
                        missingRange = j;
                    }
                    numberExists = false;
                    // missingList.push(j);
                    i--;
                    j++;
                }
            }
            return missingRangeList;

        }

        function onGetError (error) {
            //Error code here
        }
        vm.findPackageList();

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageDialogController', NasracPackageDialogController);

    NasracPackageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracPackage'];

    function NasracPackageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracPackage) {
        var vm = this;

        vm.nasracPackage = entity;
        vm.clear = clear;
        vm.save = save;
        vm.showMissingNumbrs = true;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nasracPackage.id !== null) {
                NasracPackage.update(vm.nasracPackage, onSaveSuccess, onSaveError);
            } else {
                NasracPackage.save(vm.nasracPackage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracPackageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.findPackageList = function  () {

            NasracPackage.query(vm.nasracPackage, onGetSuccess, onGetError);

        };

        function onGetSuccess (result) {
            vm.unusedPckList = findMissingNumbers(result);
        }

        function findMissingNumbers(result) {

            var a = [];
             var missingList = [];
            var missingRangeList = [];
            for(var i=0;i<result.length;i++){
                a.push(result[i].packageBsgHandle);
            }
            a = a.sort(function (e1, e2) {  return e1 - e2;  });

            var numberExists = true;
            var missingRange = "";
            var j = a[0];
            for (var i=0;i<a.length;i++)
            {
                if (j==a[i])
                {
                    if(!numberExists){
                        numberExists = !numberExists;
                        missingRange = missingRange +""+ (missingRange == j-1 ? "" : " - "+(j-1).toString() );
                        missingRangeList.push(missingRange);
                        missingRange = "";
                    }
                    numberExists = true;
                    j++;
                    continue;
                }
                else
                {
                    if(numberExists){
                        numberExists = !numberExists;
                        missingRange = j;
                    }
                    numberExists = false;
                     missingList.push(j);
                    i--;
                    j++;
                }
            }
            return missingList;

        }

        function onGetError (error) {
            //Error code here
        }
        vm.findPackageList();

        vm.bindVal = function(s){
            vm.showMissingNumbrs = false;
            vm.nasracPackage.packageBsgHandle = s;
        };

        vm.pckBsgChanged = function(){
            vm.showMissingNumbrs = true;

        };

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageDeleteController',NasracPackageDeleteController);

    NasracPackageDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracPackage'];

    function NasracPackageDeleteController($uibModalInstance, entity, NasracPackage) {
        var vm = this;

        vm.nasracPackage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NasracPackage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-package', {
            parent: 'dac-content-main',
            url: '/nasrac-package',
            templateUrl: 'app/dac-content/nasrac-package/nasrac-packages.html',
            controller: 'NasracPackageController',
            controllerAs: 'vm',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracPackage.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracPackage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-package.new', {
            parent: 'dac-content-main.nasrac-package',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-dialog.html',
                    controller: 'NasracPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                packageBsgHandle: null,
                                packageId: null,
                                packageName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('dac-content-main.nasrac-package');
                });
            }]
        })
        .state('dac-content-main.nasrac-package.edit', {
            parent: 'dac-content-main.nasrac-package',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-dialog.html',
                    controller: 'NasracPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracPackage', function(NasracPackage) {
                            return NasracPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-package.delete', {
            parent: 'dac-content-main.nasrac-package',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-delete-dialog.html',
                    controller: 'NasracPackageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracPackage', function(NasracPackage) {
                            return NasracPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('dac-content-main.nasrac-package.unusedPckList', {
            parent: 'dac-content-main.nasrac-package',
            url: '/unusedPckList',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-package/nasrac-package-unusedlist-dialog.html',
                    controller: 'NasracPackageUnusedListDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracPackage', function(NasracPackage) {
                            //return NasracPackage.get({id : $stateParams.id}).$promise;
                            return {
                                id : null
                            }
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-package', null, { reload: 'dac-content-main.nasrac-package' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracPackage', NasracPackage);

    NasracPackage.$inject = ['$resource'];

    function NasracPackage ($resource) {
        var resourceUrl =  'api/nasrac-packages/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
				method : 'GET',
				url : 'api/nasrac-packages/download',
				headers: {
					accept: xlsxContentType
		        },
		        responseType: 'arraybuffer',
		        cache: false,
		        transformResponse: function (data) {
		          return {
			            response: new Blob([data], {type: xlsxContentType})
			          };
		        }
			},
            'downloadUserAccounts' : {
                method : 'GET',
                url : 'api/nasrac-packages/downloadUserAccounts',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracPackageController', NasracPackageController);
    window.localStorage.removeItem("DataTables_nasracpackagebar_/");
    NasracPackageController.$inject = ['$scope', '$state', 'NasracPackage', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal'];

    function NasracPackageController ($scope, $state, NasracPackage, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracPackages = [];

        vm.nasracPackages = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};


        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-packages/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {

                // The returned object has 'email' as property, but the server entity has 'emailAddress'
                // We need to override what we ask to the server here otherwise search will not work
//                data.columns[1].data = "emailAddress";
            	data.columns.shift();
            	data.order[0].column = data.order[0].column - 1;
                // Any values you set on the data object will be passed along as parameters to the server
                //data.access_token = AuthenticationService.getAccessToken();
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
			"<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
			"<'row'<'col-sm-12'tr>>" +
			"<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
        .withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        })
    .withPaginationType('full_numbers')
    .withButtons([
	    {
	    	text: 'Export',
	    	extend: "excelHtml5",
	        title:"Nasrac Sources",
	        action: function (e, dt, node, config) {
	        	NasracPackage.download().$promise
	            .then(function (data) {
	            	var url = URL.createObjectURL(data.response);
	            	var link = document.createElement("a");
	        	    link.href = url;

	        	    //set the visibility hidden so it will not effect on your web-layout
	        	    link.style = "visibility:hidden";
	        	    link.download = "NAS-RAC_Packages.xlsx"; //this is an example file to download, use yours

	        	    //this part will append the anchor tag and remove it after automatic click
	        	    document.body.appendChild(link);
	        	    link.click();
	        	    document.body.removeChild(link);
	              });
	        },
	        exportOptions: {
	            columns: ':visible'
	        },
	        //CharSet: "utf8",
	        exportData: { decodeEntities: true }
	    }
	])

    .withDisplayLength(25)

    .withOption('createdRow', function (row) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
    })
    .withOption('saveState', true)
    .withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);
        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('packageBsgHandle').withTitle('Package BSG Handle'),
              DTColumnBuilder.newColumn('id').withTitle('Package Id'),
              DTColumnBuilder.newColumn('packageName').withTitle('Package Name')
        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }


        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dac-content', {
            abstract: true,
            parent: 'app'
        })
        .state('dac-content-main', {
        	abstract: true,
        	parent: 'dac-content',
            url: '/dac-content-main',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dac-content/templates/dac-content.html',
                    controller: 'DacContentController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('DacContentController', DacContentController);

    DacContentController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

	function DacContentController($scope, Principal, LoginService, $state) {

		
		$scope.tabData   = [
			{
                heading: 'Service',
                route:   'dac-content-main.nasrac-service',
                class: 'btn-lg'
            },
            {
                heading: 'Package',
                route:   'dac-content-main.nasrac-package',
                class: 'btn-lg'
            },
            {
                heading: 'Source',
                route:   'dac-content-main.nasrac-source',
                class: 'btn-lg'
            },
            {
              heading: 'Source Type',
              route:   'dac-content-main.nasrac-source-type',
              class: 'btn-lg'
            },
            {
                heading: 'Provider',
                route:   'dac-content-main.nasrac-provider',
                class: 'btn-lg'
            }
          ];
        
        $scope.go = function(route){
            $state.go(route);
        };
        
        
        $scope.go('dac-content-main.nasrac-service');

	}
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('nasracApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('nasracApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            kbSize:kbSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }
        function kbSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return bytesToSize(size);
            }

            return formatAsBytes(size(base64String));
        }
        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
        };


        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('nasracApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance','Principal','Idle','$uibModal','LoginService','$uibModalStack'];
    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance,Principal,Idle,$uibModal,LoginService,$uibModalStack) {
        var vm = this;
        vm.authenticationError = false;
        vm.authenticationErrorMessage = '';
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password =  localStorage.password;
        vm.register = register;
        vm.rememberMe = (localStorage.rememberMe === 'true');
        vm.requestResetPassword = requestResetPassword;
        vm.username = localStorage.username;



        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            if(vm.rememberMe){
                localStorage.username = vm.username;
                localStorage.password = vm.password;
                localStorage.rememberMe = true;
            }else {
                localStorage.username = '';
                localStorage.password = '';
                localStorage.rememberMe = false;
            }
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                vm.identity = Principal.currentIdentity;
                $rootScope.username = Principal.currentIdentity.login;

                if ($state.current.name === 'register' || $state.current.name === 'activate' || $state.current.name === 'forms' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    gotoHome();

                }else if($state.current.name === 'sign-out-home-page')
                {
                    var updFlag = Principal.currentIdentity.userPasswordUpdFlag;
                    if(updFlag){
                        gotoChangePassword();
                    }else{
                        gotoHome();
                    }
                }
                //$rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (error) {
            	if(error.data != null && error.data.AuthenticationException != null
            			&& error.data.AuthenticationException != 'Bad credentials') {
            		vm.authenticationErrorMessage = error.data.AuthenticationException + '.';
            	} else {
            		vm.authenticationErrorMessage = 'Please check your credentials and try again.';
            	}

                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

        function gotoHome() {

        	var adminAuthorities = ['Administrators'];
        	Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result) {
                vm.isAdmin = result;

                if (vm.isAdmin === true && Principal.isAuthenticated()) {
                    $state.go('home-main.important-announcements', {}, {
                        reload: true
                    });
                }
                else if (vm.isAdmin === false && Principal.isAuthenticated()) {
                    $state.go('user-home-page', {}, {
                        reload: true
                    });
                }
        	});
        }

        function gotoChangePassword(){
            $state.go('password', {}, {
                reload: true
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'ua': 'Українська',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('nasracApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('nasracApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('nasracApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('nasracApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('nasracApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
	'use strict';
	angular.module('nasracApp').factory('Revenue', Revenue);

	Revenue.$inject = [ '$resource' ];

	function Revenue($resource) {
		var resourceUrl = 'api/revenue';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/revenue/reportdates',
				isArray : true
			},

			'download' : {
				method : 'GET',
				url : 'api/revenue/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();

(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('RevenueController', RevenueController);

	RevenueController.$inject = [ '$scope', 'Revenue', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function RevenueController($scope, Revenue, AuthServerProvider,
			DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;

        $scope.loadData = function() {

			Revenue.query({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
                $scope.revenueList = result;
				$scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();
				$scope.getTotal(result);
			});
		};
		$scope.getTotal = function (result){
			$scope.total = {};
			$scope.total.digitalMot = 0;
			$scope.total.digitalNonMot = 0 ;
			$scope.total.dta = 0;
			$scope.total.totalactiveUnits = 0;
			$scope.total.serviceCharge = 0;
				angular.forEach(result,function(revenue,index){
					$scope.total.digitalMot = $scope.total.digitalMot + revenue.digitalMot;
					$scope.total.digitalNonMot = $scope.total.digitalNonMot + revenue.digitalNonMot;
					$scope.total.dta = $scope.total.dta + revenue.dta;
					$scope.total.totalactiveUnits = $scope.total.totalactiveUnits + revenue.totalactiveUnits;
					$scope.total.serviceCharge = $scope.total.serviceCharge + revenue.serviceCharge;
				});
		};

		Revenue.getReportDates(function(result) {
			$scope.reportDate = result;
            $scope.selectedMonth = result[0];

		});

		$scope.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
			.withDisplayLength(25)
			.withButtons([ {
			//extend: 'csvHtml5', // removing action column
			text : 'Export',
			key : '1',
			action : function(e, dt, node, config) {

				Revenue.download({

					date : $scope.selectedMonth.reportDate.substring(0, 10)
				}).$promise.then(function(data) {
					var url = URL.createObjectURL(data.response);
					var link = document.createElement("a");
					link.href = url;

					//set the visibility hidden so it will not effect on your web-layout
					link.style = "visibility:hidden";
					link.download = "Revenue_summary_For_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

					//this part will append the anchor tag and remove it after automatic click
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			}
		} ]).withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")


	}
})();

(function() {
	'use strict';
	angular.module('nasracApp').factory('NonNctc', NonNctc);

	NonNctc.$inject = [ '$resource' ];

	function NonNctc($resource) {
		var resourceUrl = 'api/nonnctc';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/nonnctc/reportdates',
				isArray : true
			},
			'getMsoNames' : {
				method : 'GET',
				url : 'api/nonnctc/msonames',
				isArray : true
			},
			'download' : {
				method : 'GET',
				url : 'api/nonnctc/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();

(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('NonNctcController', NonNctcController);

	NonNctcController.$inject = [ '$scope', 'NonNctc', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function NonNctcController($scope, NonNctc, AuthServerProvider,
			DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;

        $scope.loadData = function() {
			if (!$scope.selectedMso || !$scope.selectedMso.msoName || $scope.selectedMso.msoName == null) {
				$scope.selectedMso = {};
				$scope.selectedMso.msoName = undefined;
			}
			NonNctc.query({
				msoName : $scope.selectedMso.msoName,
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
                $scope.nonNctcList = result;
                $scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();//getting current time
                $scope.getTotal(result);

			});
		};
				$scope.getTotal = function (result){
					$scope.total = {};
					$scope.total.digitalMot = 0;
					$scope.total.digitalNonMot = 0;
					$scope.total.dta = 0;
					$scope.total.setTopCount = 0;
					$scope.total.stdRateCharges = 0;
					$scope.total.minimumFee = 0;
					$scope.total.serviceCharge = 0;
					angular.forEach(result,function(nonNctc,index){
						$scope.total.digitalMot = $scope.total.digitalMot + nonNctc.digitalMot;
						$scope.total.digitalNonMot = $scope.total.digitalNonMot + nonNctc.digitalNonMot;
						$scope.total.dta = $scope.total.dta + nonNctc.dta;
						$scope.total.setTopCount=$scope.total.setTopCount+nonNctc.setTopCount;
						$scope.total.stdRateCharges =$scope.total.stdRateCharges +nonNctc.stdRateCharges;
						$scope.total.minimumFee = $scope.total.minimumFee+nonNctc.minimumFee;
						$scope.total.serviceCharge = $scope.total.serviceCharge + nonNctc.serviceCharge;
				});
			};

		NonNctc.getReportDates(function(result) {
			$scope.reportDate = result;
            $scope.selectedMonth = result[0];
			$scope.onDateChange();
		});

		$scope.onDateChange = function() {
			//console.log($scope.selectedMonth.reportDate);

			NonNctc.getMsoNames({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
				$scope.msoList = result;
				$scope.selectedMso = "";
			});
		};

		$scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(25)
            .withPaginationType('full_numbers')
            .withButtons(
				[ {
					//extend: 'csvHtml5', // removing action column TODO : remove action header
					text : 'Export',
					key : '1',
					action : function(e, dt, node, config) {
						/*var msoName;
						if ($scope.selectedMso === "" || $scope.selectedMso.msoName == null) {
							msoName = undefined;
						} else {
							msoName = parseInt($scope.selectedMso.msoName);
						}*/
						NonNctc.download({
							msoName : $scope.selectedMso.msoName,
							date : $scope.selectedMonth.reportDate.substring(0,10)
						}).$promise.then(function(data) {
							var url = URL.createObjectURL(data.response);
							var link = document.createElement("a");
							link.href = url;

							//set the visibility hidden so it will not effect on your web-layout
							link.style = "visibility:hidden";
							link.download = "Authorization_Fee_summary_For_NonNCTC_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

							//this part will append the anchor tag and remove it after automatic click
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						});
					}
				} ]).withDOM(
		                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
		                "<'row'<'col-sm-12'tr>>" +
		                "<'row'<'col-sm-5'i><'col-sm-7'p>>");

	}
})();

(function() {
	'use strict';
	angular.module('nasracApp').factory('Nctc', Nctc);

	Nctc.$inject = [ '$resource' ];

	function Nctc($resource) {
		var resourceUrl = 'api/nctc';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/nctc/reportdates',
				isArray : true
			},

			'download' : {
				method : 'GET',
				url : 'api/nctc/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();

(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('NctcController', NctcController);

	NctcController.$inject = [ '$scope', 'Nctc', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function NctcController($scope, Nctc, AuthServerProvider, DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;

        $scope.loadData = function() {
			Nctc.query({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
				$scope.nctcList = result;
				$scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();
				$scope.getTotal(result);
			});
		};

		$scope.getTotal = function (result){
			$scope.total = {};
			$scope.total.digitalMot = 0;
			$scope.total.digitalNonMot = 0;
			$scope.total.dta = 0;
			$scope.total.setTopCount = 0;
			$scope.total.stdRateCharges = 0;
			$scope.total.minimumFee = 0;
			$scope.total.serviceCharge = 0;
			angular.forEach(result,function(nctc,index){
				$scope.total.digitalMot = $scope.total.digitalMot + nctc.digitalMot;
				$scope.total.digitalNonMot = $scope.total.digitalNonMot + nctc.digitalNonMot;
				$scope.total.dta = $scope.total.dta + nctc.dta;
				$scope.total.setTopCount=$scope.total.setTopCount+nctc.setTopCount;
				$scope.total.stdRateCharges =$scope.total.stdRateCharges +nctc.stdRateCharges;
				$scope.total.minimumFee = $scope.total.minimumFee+nctc.minimumFee;
				$scope.total.serviceCharge = $scope.total.serviceCharge + nctc.serviceCharge;
			});
		};

		Nctc.getReportDates(function(result) {
			$scope.reportDate = result;
			$scope.selectedMonth = result[0];

		});

		$scope.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(25)
            .withButtons([ {
			//extend: 'csvHtml5', // removing action column TODO : remove action header
			text : 'Export',
			key : '1',
			action : function(e, dt, node, config) {

				Nctc.download({

					date : $scope.selectedMonth.reportDate.substring(0, 10)
				}).$promise.then(function(data) {
					var url = URL.createObjectURL(data.response);
					var link = document.createElement("a");
					link.href = url;

					//set the visibility hidden so it will not effect on your web-layout
					link.style = "visibility:hidden";
					link.download = "Authorization_Fee_summary_For_NCTC_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

					//this part will append the anchor tag and remove it after automatic click
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			}
		} ]).withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>");


	}
})();

(function() {
	'use strict';
	angular.module('nasracApp').factory('Dta', Dta);

	Dta.$inject = [ '$resource' ];

	function Dta($resource) {
		var resourceUrl = 'api/dta';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/dta/reportdates',
				isArray : true
			},

			'download' : {
				method : 'GET',
				url : 'api/dta/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();

(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('DtaController', DtaController);

	DtaController.$inject = [ '$scope', 'Dta', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function DtaController($scope, Dta, AuthServerProvider, DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;
		$scope.loadData = function() {
			Dta.query({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
    			$scope.dtaList = result;
				$scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();
				$scope.getTotal(result);
			});
		};
		$scope.getTotal = function (result){
			$scope.total = {};
			$scope.total.digitalMot = 0;
			$scope.total.digitalNonMot = 0 ;
			$scope.total.dta = 0;
			$scope.total.setTopCount = 0;
			$scope.total.stdRateCharges = 0;
			$scope.total.minimumFee = 0;
			$scope.total.serviceCharge = 0;
				angular.forEach(result,function(dta,index){
					$scope.total.digitalMot = $scope.total.digitalMot + dta.digitalMot;
					$scope.total.digitalNonMot = $scope.total.digitalNonMot + dta.digitalNonMot;
					$scope.total.dta = $scope.total.dta + dta.dta;
					$scope.total.setTopCount=$scope.total.setTopCount+dta.setTopCount;
					$scope.total.stdRateCharges =$scope.total.stdRateCharges +dta.stdRateCharges;
					$scope.total.minimumFee = $scope.total.minimumFee+dta.minimumFee;
					$scope.total.serviceCharge = $scope.total.serviceCharge + dta.serviceCharge;
				});
		};

		Dta.getReportDates(function(result) {
			$scope.reportDate = result;
			$scope.selectedMonth = result[0];

		});

		$scope.dtOptions = DTOptionsBuilder.newOptions()
            .withDisplayLength(25)
            .withPaginationType('full_numbers')
            .withButtons([ {
			//extend: 'csvHtml5', // removing action column TODO : remove action header
			text : 'Export',
			key : '1',
			action : function(e, dt, node, config) {

				Dta.download({

					date : $scope.selectedMonth.reportDate.substring(0, 10)
				}).$promise.then(function(data) {
					var url = URL.createObjectURL(data.response);
					var link = document.createElement("a");
					link.href = url;

					//set the visibility hidden so it will not effect on your web-layout
					link.style = "visibility:hidden";
					link.download = "Authorization_Fee_summary_For_DTA_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

					//this part will append the anchor tag and remove it after automatic click
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				});
			}
		} ]).withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>");


	}
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'Billing Administrator', 'Billing User'];
        $stateProvider.state('billing-reports', {
            abstract: true,
            parent: 'app'
        }).state('billing-reports-main', {
            abstract: true,
            parent: 'billing-reports',
            url: '/billing-reports-main',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nonnctc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/billing-reports/billing-reports.html',
                    controller: 'BillingReportsMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('billing-reports-main.nonnctc', {
            url:         '/nonnctc',
            templateUrl: 'app/billing-reports/nonnctc/nonnctc.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nonnctc.home.title'
            },
            controller: 'NonNctcController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('nonnctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('billing-reports-main.nctc', {
            url:         '/nctc',
            templateUrl: 'app/billing-reports/nctc/nctc.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nctc.home.title'
            },
            controller: 'NctcController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('nctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('billing-reports-main.dta', {
            url:         '/dta',
            templateUrl: 'app/billing-reports/dta/dta.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.dta.home.title'
            },
            controller: 'DtaController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('dta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('billing-reports-main.revenue', {
            url:          '/revenue',
            templateUrl: 'app/billing-reports/revenue/revenue.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.revenue.home.title'
            },
            controller: 'RevenueController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                     $translatePartialLoader.addPart('revenue');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('BillingReportsMainController', MainController);

	// AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
	MainController.$inject = [ '$scope', '$state' ];

	function MainController($scope, $state) {

		$scope.tabData = [ {
			heading : 'Authorization Fee Summary-NON-NCTC',
            route : 'billing-reports-main.nonnctc',
            class: 'btn-lg'

		}, {
			heading : 'Authorization Fee Summary-NCTC',
			route : 'billing-reports-main.nctc',
            class: 'btn-lg'
		}, {
			heading : 'Authorization Fee Summary-DTA',
            route : 'billing-reports-main.dta',
            class: 'btn-lg'
		}, {
			heading : 'Revenue Summary',
			route : 'billing-reports-main.revenue',
            class: 'btn-lg'
		} ];

		$scope.go = function(route) {
		};
	}

})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBOfficeDialogController', OfficeDialogController);

    OfficeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Office', 'Mso'];

    function OfficeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Office, Mso) {
        var vm = this;

        vm.office = entity;
        vm.clear = clear;
        vm.save = save;
        vm.msos = Mso.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.office.id !== null) {
                Office.update(vm.office, onSaveSuccess, onSaveError);
            } else {
                Office.save(vm.office, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:officeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBOfficeDeleteController',OfficeDeleteController);

    OfficeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Office'];

    function OfficeDeleteController($uibModalInstance, entity, Office) {
        var vm = this;

        vm.office = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, officeName) {
            Office.delete({id: id, officeName: officeName},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('office', {
            parent: 'entity',
            url: '/office',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.office.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/office/offices.html',
                    controller: 'OfficeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('office-detail', {
            parent: 'office',
            url: '/office/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.office.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/office/office-detail.html',
                    controller: 'OfficeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Office', function($stateParams, Office) {
                    return Office.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'office',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('office-detail.edit', {
            parent: 'office-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office.new', {
            parent: 'office',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                officeName: null,
                                officeAddress: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: 'office' });
                }, function() {
                    $state.go('office');
                });
            }]
        })
        .state('office.edit', {
            parent: 'office',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/office/office-dialog.html',
                    controller: 'OfficeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: 'office' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('office.delete', {
            parent: 'office',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/office/office-delete-dialog.html',
                    controller: 'OfficeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Office', function(Office) {
                            return Office.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('office', null, { reload: 'office' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Office', Office);

    Office.$inject = ['$resource'];

    function Office ($resource) {
        var resourceUrl =  'api/offices/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
                method : 'GET',
                url : 'api/offices/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'delete' : {
                method : 'DELETE',
                url: 'api/offices/:id/:officeName'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ASTBOfficeController', OfficeController);
    window.localStorage.removeItem("DataTables_nasracofficebar_/");
    OfficeController.$inject = ['$scope', '$state', 'Office', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder' , 'GUIUtils', '$filter', '$compile', 'Principal', 'AuthServerProvider'];

    function OfficeController ($scope, $state, Office, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, Principal, AuthServerProvider ) {
        var vm = this;
        vm.offices = [];

        vm.office = {
        		createOfficeRoles: "Administrators,Billing Administrator"
        	};


        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/offices/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {

                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
                    //  data.columns[1].data = "emailAddress";
                    data.columns.shift();
                    //data.columns.splice(3);
                    data.order[0].column = data.order[0].column - 1;
                    data.columns[2].data = "mso.msoName";
                   // data.column[2].data="office.mso."
                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                }
            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")

            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            })
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withButtons([
                {
                    //extend: 'csvHtml5', // removing action column TODO : remove action header
                    text:'Export',
                    key:'1',

                    /*exportOptions: {
                     columns: [1, 2, 3]
                     }*/
                    action: function (e, dt, node, config) {
                        Office.download().$promise
                            .then(function (data) {
//                    	console.log(data);
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_ Office.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    }
                }
            ])
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);


          vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('officeName').withTitle('Office Name'),

              DTColumnBuilder.newColumn('officeAddress').withTitle('Office Address'),
            DTColumnBuilder.newColumn('msoMsoName').withTitle('MSO Name')

           ];

        if (Principal.hasAnyAuthority(['Billing User'])){
        	vm.dtColumns[0].visible = false;
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoDialogController', MsoDialogController);

    MsoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Mso','AlertService'];

    function MsoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Mso,AlertService) {
        var vm = this;

        vm.mso = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mso.id !== null) {
                Mso.update(vm.mso, onSaveSuccess, onSaveError);
            } else {
                Mso.save(vm.mso, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:msoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoDetailController', MsoDetailController);

    MsoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Mso'];

    function MsoDetailController($scope, $rootScope, $stateParams, previousState, entity, Mso) {
        var vm = this;

        vm.mso = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:msoUpdate', function(event, result) {
            vm.mso = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoDeleteController',MsoDeleteController);

    MsoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Mso'];

    function MsoDeleteController($uibModalInstance, entity, Mso) {
        var vm = this;

        vm.mso = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, msoName) {
            Mso.delete({id: id, msoName: msoName},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mso', {
            parent: 'entity',
            url: '/mso',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.mso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/mso/msos.html',
                    controller: 'MsoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mso-detail', {
            parent: 'mso',
            url: '/mso/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.mso.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/mso/mso-detail.html',
                    controller: 'MsoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Mso', function($stateParams, Mso) {
                    return Mso.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mso',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mso-detail.edit', {
            parent: 'mso-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'MsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mso.new', {
            parent: 'mso',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'MsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                msoName: null,
                                msoAddress: null,
                                msoNoMotcode: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('mso', null, { reload: 'mso' });
                }, function() {
                    $state.go('mso');
                });
            }]
        })
        .state('mso.edit', {
            parent: 'mso',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'MsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mso', null, { reload: 'mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mso.delete', {
            parent: 'mso',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-delete-dialog.html',
                    controller: 'MsoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mso', null, { reload: 'mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Mso', Mso);

    Mso.$inject = ['$resource'];

    function Mso ($resource) {
        var resourceUrl =  'api/msos/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
                method : 'GET',
                url : 'api/msos/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'delete' : {
                method : 'DELETE',
                url: 'api/msos/:id/:msoName'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoController', MsoController);
    window.localStorage.removeItem("DataTables_nasracmsobar_/");
    MsoController.$inject = ['$scope', '$state', 'Mso', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile','Principal','AuthServerProvider'];

    function MsoController ($scope, $state, Mso, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ,Principal,AuthServerProvider) {
        var vm = this;
        vm.msos = [];

        vm.mso = {
        		createMsoRoles: "Administrators,Billing Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/msos/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {

                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
//                data.columns[1].data = "emailAddress";
                   // data.columns.splice(3);
                    data.columns.shift();
                    data.order[0].column = data.order[0].column -1;
                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                }
            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withBootstrapOptions({
            TableTools: {
                classes: {
                    container: 'btn-group',
                    buttons: {
                        normal: 'btn btn-danger'
                    }
                }
            },
            ColVis: {
                classes: {
                    masterButton: 'btn btn-primary'
                }
            },
            pagination: {
                classes: {
                    ul: 'pagination pagination-sm'
                }
            }
        })
            .withPaginationType('simple_numbers')
            .withDisplayLength(10)
                .withButtons([

                    {
                        text: 'Export',
                        key: '1',
                        action: function (e, dt, node, config) {
                            Mso.download().$promise
                                .then(function (data) {
//                    	console.log(data);
                                    var url = URL.createObjectURL(data.response);
                                    var link = document.createElement("a");
                                    link.href = url;

                                    //set the visibility hidden so it will not effect on your web-layout
                                    link.style = "visibility:hidden";
                                    link.download = "NAS-RAC_MSO.xlsx"; //this is an example file to download, use yours

                                    //this part will append the anchor tag and remove it after automatic click
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                });
                        }
                    }
                ])

            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('msoName').withTitle('MSO Name'),
              DTColumnBuilder.newColumn('msoAddress').withTitle('MSO Address'),
              DTColumnBuilder.newColumn('msoNoMotcode').withTitle('Non Motcode Flag'),

        ];

        if (Principal.hasAnyAuthority(['Billing User'])){
        	vm.dtColumns[0].visible = false;
        }



        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('HeadendManagePricingDialogController', HeadendManagePricingDialogController);

    HeadendManagePricingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HeadendManagePricing'];

    function HeadendManagePricingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HeadendManagePricing) {
        var vm = this;

        vm.headendManagePricing = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.headendManagePricing.id !== null) {
                HeadendManagePricing.update(vm.headendManagePricing, onSaveSuccess, onSaveError);
            } else {
                HeadendManagePricing.save(vm.headendManagePricing, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:headendManagePricingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('headend-manage-pricing', {
            parent: 'astbmso-main.headend',
            url: '/headend-manage-pricing',
            data: {
                authorities: ['Administrators', 'Billing Administrator']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-manage-pricing-dialog.html',
                    controller: 'HeadendManagePricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                boxFeeMot: null,
                                boxFeeNonMot: null,
                                dtaFee: null,
                                applyTo: 'ALL',
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                }, function() {
                    $state.go('astbmso-main.headend');
                });
            }]
        })
        
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('HeadendManagePricing', HeadendManagePricing);

    HeadendManagePricing.$inject = ['$resource'];

    function HeadendManagePricing ($resource) {
        var resourceUrl =  'api/headend-manage-pricings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .controller('ASTBHeadendDialogController', HeadendDialogController);
    HeadendDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Headend', 'Office', 'HeadendManagePricing' ];
    function HeadendDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Headend, Office, HeadendManagePricing) {
        var vm = this;
        vm.headend = entity;
        vm.clear = clear;
        vm.save = save;
        vm.offices = Office.query();
        vm.toggleNctcMember= toggleNctcMember;
        HeadendManagePricing.query().$promise.then(function(data) {
            if(vm.headend.id==null) {
                vm.headend.boxFeeMot = data[0].boxFeeMot;
                vm.headend.boxFeeNonMot = data[0].boxFeeNonMot;
                vm.headend.dtaFee = data[0].dtaFee;
                //vm.headend.minimumFee = 250;
            }
        });

        vm.headendTypeChanged =  function () {
            if(vm.headend.headendType === 'HB')
                vm.headend.minimumFee = 250;
            else if(vm.headend.headendType === 'DL')
                vm.headend.minimumFee = 25;
        };
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function save () {
            vm.isSaving = true;
            if (vm.headend.id !== null) {
                Headend.update(vm.headend, onSaveSuccess, onSaveError);
            } else {
                Headend.save(vm.headend, onSaveSuccess, onSaveError);
            }
        }
        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:headendUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        function onSaveError () {
            vm.isSaving = false;
        }
        function toggleNctcMember(){
            vm.headend.nctcMemberId = "";
            vm.headend.nctcSystemId = "";
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBHeadendDeleteController',HeadendDeleteController);

    HeadendDeleteController.$inject = ['$uibModalInstance', 'entity', 'Headend'];

    function HeadendDeleteController($uibModalInstance, entity, Headend) {
        var vm = this;

        vm.headend = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Headend.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('headend', {
            parent: 'entity',
            url: '/headend',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.headend.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/headend/headends.html',
                    controller: 'HeadendController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('headend');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('headend-detail', {
            parent: 'headend',
            url: '/headend/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.headend.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/headend/headend-detail.html',
                    controller: 'HeadendDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('headend');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Headend', function($stateParams, Headend) {
                    return Headend.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'headend',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('headend-detail.edit', {
            parent: 'headend-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-dialog.html',
                    controller: 'HeadendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Headend', function(Headend) {
                            return Headend.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('headend.new', {
            parent: 'headend',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-dialog.html',
                    controller: 'HeadendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                bsiCode: null,
                                headendType: null,
                                headendName: null,
                                headendAddress: null,
                                headendCity: null,
                                headendState: null,
                                headendZip: null,
                                headendContactName: null,
                                headendPhoneNumber: null,
                                downlinkLocation: null,
                                boxFeeMot: null,
                                boxFeeNonMot: null,
                                dtaFee: null,
                                minimumFee: null,
                                usingNonMotCode: false,
                                nctcMember: false,
                                nctcMemberId: null,
                                nctcSystemId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('headend', null, { reload: 'headend' });
                }, function() {
                    $state.go('headend');
                });
            }]
        })
        .state('headend.edit', {
            parent: 'headend',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-dialog.html',
                    controller: 'HeadendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Headend', function(Headend) {
                            return Headend.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('headend', null, { reload: 'headend' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('headend.delete', {
            parent: 'headend',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-delete-dialog.html',
                    controller: 'HeadendDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Headend', function(Headend) {
                            return Headend.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('headend', null, { reload: 'headend' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Headend', Headend);

    Headend.$inject = ['$resource'];

    function Headend ($resource) {
        var resourceUrl =  'api/headends/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },

            'download' : {
                method : 'GET',
                url : 'api/headends/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBHeadendController', HeadendController);
    window.localStorage.removeItem("DataTables_nasracheadendbar_/");
    HeadendController.$inject = ['$scope', '$state','Headend','$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'Principal', 'AuthServerProvider'];

    function HeadendController($scope, $state,Headend,$q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, Principal, AuthServerProvider ) {

        var vm = this;

        vm.headends = [];

        vm.headend = {
        		createHeadendRoles: "Administrators,Billing Administrator"
        	};

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                contentType: 'application/json',
                url: '/api/headends/datatables-view',
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader("Authorization",
                        "Bearer " + AuthServerProvider.getToken());
                },
                data: function(data, dtInstance) {

                    // The returned object has 'email' as property, but the server entity has 'emailAddress'
                    // We need to override what we ask to the server here otherwise search will not work
                    //data.columns[1].data = "emailAddress";
                    data.columns.shift();
                    //data.columns.splice(17);
                    data.order[0].column = data.order[0].column-1;
                    data.columns[1].data="office.officeName";
                    data.columns[0].data="office.mso.msoName";
                    // Any values you set on the data object will be passed along as parameters to the server
                    //data.access_token = AuthenticationService.getAccessToken();
                    return JSON.stringify(data);
                },
            })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
            .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
            .withOption('serverSide', true)
            .withBootstrap()
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            })
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withButtons([
                {
                    //extend: 'csvHtml5', // removing action column TODO : remove action header
                    text:'Export',
                    key:'1',

                    /*exportOptions: {
                     columns: [1, 2, 3]
                     }*/
                    action: function (e, dt, node, config) {
                        Headend.download().$promise
                            .then(function (data) {
//                    	console.log(data);
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_ChannelMap.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    }
                }
            ])
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('saveState', true)
            .withOption('order', [1, 'asc'])
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml),
            DTColumnBuilder.newColumn('officeMsoName').withTitle('MSO Name'),
            DTColumnBuilder.newColumn('officeOfficeName').withTitle('Office Name'),
            DTColumnBuilder.newColumn('bsiCode').notVisible().withTitle('Bsi Code'),
            DTColumnBuilder.newColumn('headendType').withTitle('Channel Map Type'),
            DTColumnBuilder.newColumn('headendName').withTitle('Channel Map Name'),
            DTColumnBuilder.newColumn('headendCity').withTitle('Headend City'),
            DTColumnBuilder.newColumn('usingNonMotCode').withTitle('Using Non AURORA NETWORKS Code'),
            DTColumnBuilder.newColumn('nctcMember').withTitle('NCTC Member'),
            DTColumnBuilder.newColumn('nctcMemberId').withTitle('NCTC Member Id'),
            DTColumnBuilder.newColumn('nctcSystemId').withTitle('NCTC System Id'),
            DTColumnBuilder.newColumn('boxFeeMot').withTitle('Box Fee AURORA NETWORKS'),
            DTColumnBuilder.newColumn('boxFeeNonMot').withTitle('Box Fee Non AURORA NETWORKS'),
            DTColumnBuilder.newColumn('dtaFee').withTitle('DTA Fee'),
            DTColumnBuilder.newColumn('minimumFee').withTitle('Minimum Fee'),
            DTColumnBuilder.newColumn('downlinkLocation').withTitle('Downlink Location'),

        ];

        if (Principal.hasAnyAuthority(['Billing User'])){
        	vm.dtColumns[0].visible = false;
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update','delete']);
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('nasracApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        var roles = ['Administrators', 'Billing Administrator', 'Billing User'];
        var fullAccessRoles = ['Administrators', 'Billing Administrator'];
        $stateProvider.state('astb', {
            abstract: true,
            parent: 'app'
        }).state('astbmso-main', {
            abstract: true,
            parent: 'astb',
            url: '/astbmso-main',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.mso.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/astb/astb.html',
                    controller: 'ASTBMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('astbmso-main.mso', {
            url:         '/mso',
            templateUrl: 'app/astb/mso/msos.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.mso.home.title'
            },
            controller: 'ASTBMsoController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('astbmso-main.mso.new', {
            parent: 'astbmso-main.mso',
            url: '/new',
            data: {
                authorities: fullAccessRoles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'ASTBMsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                msoName: null,
                                msoAddress: null,
                                msoNoMotcode: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.mso', null, { reload: 'astbmso-main.mso' });
                }, function() {
                    $state.go('astbmso-main.mso');
                });
            }]
        }).state('astbmso-main.mso.edit', {
            parent: 'astbmso-main.mso',
            url: '/{id}/edit',
            data: {
                authorities: fullAccessRoles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-dialog.html',
                    controller: 'ASTBMsoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.mso', null, { reload: 'astbmso-main.mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('astbmso-main.mso.delete', {
            parent: 'astbmso-main.mso',
            url: '/{id}/delete',
            data: {
                authorities: fullAccessRoles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/mso/mso-delete-dialog.html',
                    controller: 'ASTBMsoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Mso', function(Mso) {
                            return Mso.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.mso', null, { reload: 'astbmso-main.mso' });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('astbmso-main.office', {
            parent: 'astbmso-main',
            url: '/office',
            templateUrl: 'app/astb/office/offices.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.office.home.title'
            },
            controller: 'ASTBOfficeController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('office');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('astbmso-main.office-detail', {
                parent: 'astbmso-main.office',
                url: '/office/{id}',
                data: {
                    authorities: fullAccessRoles,
                    pageTitle: 'nasracApp.office.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/astb/office/office-detail.html',
                        controller: 'ASTBOfficeDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('office');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Office', function($stateParams, Office) {
                        return Office.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'office',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('astbmso-main.office-detail.edit', {
                parent: 'astbmso-main.office-detail',
                url: '/detail/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-dialog.html',
                        controller: 'ASTBOfficeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Office', function(Office) {
                                return Office.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.office.new', {
                parent: 'astbmso-main.office',
                url: '/new',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-dialog.html',
                        controller: 'ASTBOfficeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    officeName: null,
                                    officeAddress: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.office', null, { reload: 'astbmso-main.office' });
                    }, function() {
                        $state.go('astbmso-main.office');
                    });
                }]
            })
            .state('astbmso-main.office.edit', {
                parent: 'astbmso-main.office',
                url: '/{id}/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-dialog.html',
                        controller: 'ASTBOfficeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Office', function(Office) {
                                return Office.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.office', null, { reload: 'astbmso-main.office' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.office.delete', {
                parent: 'astbmso-main.office',
                url: '/{id}/delete',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/office/office-delete-dialog.html',
                        controller: 'ASTBOfficeDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Office', function(Office) {
                                return Office.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.office', null, { reload: 'astbmso-main.office' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }).state('astbmso-main.headend', {
            parent: 'astbmso-main',
            url: '/headend',
            templateUrl: 'app/astb/headend/headends.html',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.headend.home.title'
            },
            controller: 'ASTBHeadendController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('headend');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('astbmso-main.headend-detail', {
                parent: 'astbmso-main.headend',
                url: '/headend/{id}',
                data: {
                    authorities: fullAccessRoles,
                    pageTitle: 'nasracApp.headend.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/astb/headend/headend-detail.html',
                        controller: 'ASTBHeadendDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('headend');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Headend', function($stateParams, Headend) {
                        return Headend.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'headend',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('astbmso-main.headend-detail.edit', {
                parent: 'astbmso-main.headend-detail',
                url: '/detail/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-dialog.html',
                        controller: 'ASTBHeadendDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Headend', function(Headend) {
                                return Headend.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.headend.new', {
                parent: 'astbmso-main.headend',
                url: '/new',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-dialog.html',
                        controller: 'ASTBHeadendDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    bsiCode: null,
                                    headendType: null,
                                    headendName: null,
                                    headendAddress: null,
                                    headendCity: null,
                                    headendState: null,
                                    headendZip: null,
                                    headendContactName: null,
                                    headendPhoneNumber: null,
                                    downlinkLocation: null,
                                    boxFeeMot: null,
                                    boxFeeNonMot: null,
                                    dtaFee: null,
                                    minimumFee: null,
                                    usingNonMotCode: false,
                                    nctcMember: false,
                                    nctcMemberId: '',
                                    nctcSystemId: '',
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                    }, function() {
                        $state.go('astbmso-main.headend');
                    });
                }]
            })
            .state('astbmso-main.headend.edit', {
                parent: 'astbmso-main.headend',
                url: '/{id}/edit',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-dialog.html',
                        controller: 'ASTBHeadendDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Headend', function(Headend) {
                                return Headend.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.headend.delete', {
                parent: 'astbmso-main.headend',
                url: '/{id}/delete',
                data: {
                    authorities: fullAccessRoles
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/astb/headend/headend-delete-dialog.html',
                        controller: 'ASTBHeadendDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Headend', function(Headend) {
                                return Headend.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('astbmso-main.billing-current-reports', {
                url:         '/billing-current-reports',
                templateUrl: 'app/astb/templates/billing-current-reports.html',
                data: {
                    authorities: roles,
                },
                controller: 'ASTBMsoController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('mso');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
        /*  }).state('astbmso-main.billing-current-reports', {
         parent: 'astb',
         url: '/billing-current-reports',
         views: {
         'content@': {
         templateUrl: 'app/astb/templates/billing-current-reports.html',
         controller: 'AstbBillingController',
         controllerAs: 'AstbBillingCtrl'
         }
         }
         })*/
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ASTBMainController', MsoMainController);

   // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    MsoMainController.$inject = ['$scope', '$state', 'Mso', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider'];

    function MsoMainController ($scope, $state, Mso, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider ) {

        $scope.tabData   = [
            {
                heading: 'Channel Map',
                route:   'astbmso-main.headend',
                class: 'btn-lg'
            },
            {
                heading: 'Office',
                route:   'astbmso-main.office',
                class: 'btn-lg'
            },
            {
                heading: 'MSO',
                route:   'astbmso-main.mso',
                class: 'btn-lg'
            }

        ];

        $scope.go = function(route){
            $state.go(route);
        };


        $scope.go('astbmso-main.headend');

    }
   /* function AstbBillingController ($scope, Principal, LoginService, $state) {

    }*/
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('archivedbilling', {
            abstract: true,
            parent: 'app'
        }).state('archivedbilling-main', {
            abstract: true,
            parent: 'archivedbilling',
            url: '/archivedbilling-main',
            data: {
                authorities: ['ROLE_USER'],
               /* pageTitle: 'nasracApp.nonnctc.home.title'*/
            },
            views: {
                'content@': {
                    templateUrl: 'app/archived-billing/archivedbilling.html',
                    controller: 'ArchivedBillingMainController',
                    controllerAs: 'vm'
                }
            }
        }).state('archivedbilling-main.archived-nonnctc', {
            url:         '/archived-nonnctc',
            templateUrl: 'app/archived-billing/templates/archived-nonnctc.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-nonnctc.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('archived-nonnctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('archivedbilling-main.archived-nctc', {
            url:         '/archived-nctc',
            templateUrl: 'app/archived-billing/templates/archived-nctc.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-nctc.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   // $translatePartialLoader.addPart('archived-nctc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('archivedbilling-main.archived-dta', {
            url:         '/archived-dta',
            templateUrl: 'app/archived-billing/templates/archived-dta.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-dta.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                   // $translatePartialLoader.addPart('archived-dta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('archivedbilling-main.archived-revenue', {
            url:          '/archived-revenue',
            templateUrl: 'app/archived-billing/templates/archived-revenue.html',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'nasracApp.archived-revenue.home.title'
            },
            controller: 'ArchivedBillingMainController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('archived-revenue');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ArchivedBillingMainController', MainController);

   // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    MainController.$inject = ['$scope', '$state'];

    function MainController ($scope, $state) {

        $scope.archivedBillingtabData   = [
            {
                heading: 'Authorization Fee Summary [non-NCTC] [choice of MSO]',
                route:   'archivedbilling-main.archived-nonnctc'

            },
            {
                heading: 'Authorization Fee Summary [NCTC]',
                route:   'archivedbilling-main.archived-nctc'
            },{
                heading: 'Authorization Fee Summary [DTA]',
                route:   'archivedbilling-main.archived-dta'
            },
            {
                heading: 'Revenue Summary',
                route:   'archivedbilling-main.archived-revenue'
            }
        ];

        $scope.go = function(route){
            $state.go(route);
        };

        $scope.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var date = new Date();
        $scope.result = [];

        var dirty = false;
        for (var i = 2006; i <=  date.getFullYear(); i++) {
            angular.forEach($scope.months,function(month,index){
                if($scope.months[date.getMonth()] === month  &&  date.getFullYear() === i){
                    dirty = true;
                }
                if(dirty === false)
                    $scope.result.push(month+' '+i);
            });
        }
        $scope.result.reverse();

        $scope.month =   $scope.months[date.getMonth()-1] + ' ' + date.getFullYear();

        //$scope.go('');

    }
   /* function AstbBillingController ($scope, Principal, LoginService, $state) {

    }*/
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);
    angular
    .module('nasracApp').directive('trackingcode', trackingcode);

    function trackingcode() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/trackingcode.directive.html',

			controller: ['$http', '$scope', function($http, $scope) {
				  var vm = this;
				  vm.siteid = $http.get('/api/nasrac-web-contents/page/piwik-siteid').then(function(result) {

					  var data = JSON.parse(result.data[0].content);
					  $scope.trackingcodevalue = data.siteId;
					  $scope.ipAddress = data.ipAddress;

	                  return data.siteId;
	                });

			}],
	        controllerAs: 'vm',
	        bindToController: true,

			scope : {
				trackingcodevalue : '=trackingcodevalue'
			},
			link : linkFunc,
		};

		return directive;

		function linkFunc(scope, el, attr, ctrl) {

			scope.$watch('trackingcodevalue', function(newVal, oldValue) {
				if (newVal){
                	var IDSITE = scope.trackingcodevalue;
                	var PIWIK_URL = scope.ipAddress;

					_paq.push([ 'trackPageView' ]);
					_paq.push([ 'enableLinkTracking' ]);
					(function() {
						var u = "//"+ PIWIK_URL +"/";
						_paq.push([ 'setTrackerUrl', u + 'piwik.php' ]);
						_paq.push([ 'setSiteId', IDSITE ]);
						var d = document, g = d.createElement('script'), s = d
						.getElementsByTagName('script')[0];
						g.type = 'text/javascript';
						g.async = true;
						g.defer = true;
						g.src = u + 'piwik.js';
						s.parentNode.insertBefore(g, s);
					})();

				}
			});
		}
	}

    stateConfig.$inject = ['$stateProvider','IdleProvider','KeepaliveProvider'];

    function stateConfig($stateProvider,IdleProvider,KeepaliveProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });

        IdleProvider.idle(900); // 15 minutes idle
        IdleProvider.timeout(30); // after 30 seconds idle, time the user out
        KeepaliveProvider.interval(5 * 60);
        IdleProvider.autoResume("notIdle");
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('nasracApp')
        .constant('VERSION', "1.6.3")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['Administrators'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['Administrators']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['Administrators']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['Administrators'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['Administrators']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('nasracApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate','$state'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate,$state) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                email: account.email,
                lastName: account.lastName,
                login: account.login,
                nasracAdminCustomerAccountFirstName: account.nasracAdminCustomerAccountFirstName,
                displayName: account.displayName,
                firstName:account.firstName,
                userFirstName:account.firstName
            };
        };

        Principal.identity().then(function(account) {
           // vm.settingsAccount=account;
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                   // vm.settingsAccount=account;
                    vm.settingsAccount = copyAccount(account);
                    gotoHome();
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });

            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }


        function gotoHome() {

            var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result) {
                vm.isAdmin = result;
                if (vm.isAdmin === true && Principal.isAuthenticated()) {
                    $state.go('home-main.home-page', {}, {
                        reload: true
                    });
                }
                else if (vm.isAdmin === false && Principal.isAuthenticated()) {
                    $state.go('user-home-page', {}, {
                        reload: true
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'login not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal','$state'];

    function PasswordController (Auth, Principal, $state) {
        var vm = this;
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.passwords = {};

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
               vm.password =  vm.confirmPassword;
                vm.doNotMatch = null;
                //vm.passwords.oldPassword =vm.oldPassword;
                //vm.passwords.newPassword = vm.password;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    Principal.identity(true).then(function(account) {
                        vm.account = account;
                        gotoHome();
                    });

                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function gotoHome() {

            var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result) {
                vm.isAdmin = result;

                if (vm.isAdmin === true && Principal.isAuthenticated()) {
                    $state.go('home-main.home-page', {}, {
                        reload: true
                    });
                }
                else if (vm.isAdmin === false && Principal.isAuthenticated()) {
                    $state.go('user-home-page', {}, {
                        reload: true
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('nasracApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/idleSessionTimeOut.html','<div class="modal-header"><h5>For security reasons your session will be expired. Please click Extend to continue.</h5></div><div idle-countdown="countdown" ng-init="countdown=30" class="modal-body"><uib-progressbar max="30" value="30" animate="false" class="progress-striped active">You\'ll be logged out in {{countdown}} second(s).</uib-progressbar></div><div class="modal-footer"><button id="btnOk" type="button" class="btn btn-default" ng-click="ok()">Extend</button> <button id="btnLogoutNow" type="button" class="btn btn-default" ng-click="logout()">Logout now</button></div>');
$templateCache.put('app/trackingcode.directive.html','<script type="text/javascript">var _paq = _paq || [];</script>');
$templateCache.put('app/archived-billing/archivedbilling.html','<!--\n<h1 text="center">ARCHIVED-BILLING-REPORTS</h1>\n--><div ng-cloak><div class="row"><div class="col-md-12"><h1 class="text-center">NAS-RAC ARCHIVED BILLING REPORTS</h1></div></div></div><section class="content"><tabs data="archivedBillingtabData" type="pills"></tabs></section>');
$templateCache.put('app/astb/astb.html','<section class="content"><tabs data="tabData" type="pills"></tabs></section>');
$templateCache.put('app/billing-reports/billing-reports.html','<section class="content"><tabs data="tabData" type="pills"></tabs></section>');
$templateCache.put('app/faq/faq.html','<div ng-cloak><div class="text-right" ng-show="vm.isAuthenticated()" has-authority="Administrators" id="faqeditorBtn"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.openEditor()" id="faq-editor-open-button"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.editor"></span></button></div><br><!-- form  --><div ng-show="vm.isAuthenticated() && vm.editMode" id="faqeditorForm"><form name="editForm" method="post" role="form" novalidate ng-submit="vm.updateContents()" id="faq-editor-form"><textarea ui-tinymce="vm.tinymceOptions" ng-model="vm.tinymceModel"></textarea><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancelEditor()" id="faq-editor-cancel-button"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" id="faq-editor-save-button"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div><div ng-show="!vm.editMode"><div class="paraStyle" ng-bind-html="vm.trustedHtml" id="faq-noedit-text"></div></div></div>');
$templateCache.put('app/feedback/feedback.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1>Feedback to NAS-RAC Project Team - San Diego</h1><br><div data-ng-if="isSaved" id="alertOnSave" class="alert alert-success col-md-7">Message has been sent sucessfully...</div><form name="feedbackForm" novalidate ng-submit="sendFeedBack()"><div class="form-group col-md-7"><lable style="font-weight: bold">Email:</lable><br><input type="text" class="form-control" id="field_email" data-ng-model="feedback.email" data-ng-disabled="true"></div><div class="form-group col-md-7"><lable style="font-weight: bold">Name:</lable><br><input type="text" class="form-control" id="field_name" data-ng-model="feedback.name" data-ng-disabled="true"></div><div class="form-group col-md-7"><lable style="font-weight: bold">Subject:</lable><br><input type="text" class="form-control" id="field_subject" name="subject" data-ng-model="feedback.subject" placeholder="Subject" required ng-maxlength="255"><div ng-show="feedbackForm.subject.$invalid"><p class="help-block" ng-show="feedbackForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="feedbackForm.subject.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group col-md-7"><lable style="font-weight: bold">Message:</lable><br><textarea ui-tinymce="tinymceOptions" id="field_message" ng-model="feedback.message"></textarea><span ng-if="messageError" class="alert alert-danger">This field is required.</span></div><div class="form-group col-md-7"><lable style="font-weight: bold"><input type="checkbox" id="field_sendCopy" ng-model="feedback.sendCopy"> Send Copy to Myself?</lable></div><div class="form-group margin-left col-md-7"><button type="submit" class="btn btn-primary" data-ng-disabled="feedbackForm.$invalid"><span class="glyphicon glyphicon-send"></span>&nbsp; Send</button></div></form></div></div></div>');
$templateCache.put('app/home/home.html','<section class="content" ng-show="vm.isAdmin"><tabs data="tabData" type="pills"></tabs></section>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.userFirstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="diplayName" data-translate="settings.form.displayname">Display Name</label><input type="text" class="form-control" id="displayName" name="displayName" placeholder="{{\'settings.form.displayname.placeholder\' | translate}}" ng-model="vm.settingsAccount.displayName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.displayName.$dirty && form.displayName.$invalid"></div><p class="help-block" ng-show="form.displaytName.$error.required" data-translate="settings.messages.validate.displayname.required">Your display name is required.</p><p class="help-block" ng-show="form.displayName.$error.minlength" data-translate="settings.messages.validate.displayname.minlength">Your display name is required to be at least 1 character.</p><p class="help-block" ng-show="form.displayName.$error.maxlength" data-translate="settings.messages.validate.displayname.maxlength">Your display name cannot be longer than 50 characters.</p></div><!--<div class="form-group">\n                    <label for="langKey" data-translate="settings.form.language">Language</label>\n                    <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>\n                </div>--> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/archived-billing/templates/archived-dta.html','<section class="content"><h3>Authorization Fee Summary [DTA]</h3><p>Click on the "GO" button to generate the report.</p><div class="row"><div class="col-xs-4"><span>Select Report Date :</span><select ng-model="month" ng-options="currMonth for currMonth in result"></select><div style="margin-top: 10px"><button class="btn btn-primary" ui-sref="archivedbilling-main.archived-dta"><span>Go</span></button></div></div></div></section>');
$templateCache.put('app/archived-billing/templates/archived-nctc.html','<section class="content"><h3>Authorization Fee Summary [NCTC]</h3><p>Click on the "GO" button to generate the report.</p><div class="row"><div class="col-xs-4"><span>Select Report Date :</span><select ng-model="month" ng-options="currMonth for currMonth in result"></select><div style="margin-top: 10px"><button class="btn btn-primary" ui-sref="archivedbilling-main.archived-nctc"><span>Go</span></button></div></div></div></section>');
$templateCache.put('app/archived-billing/templates/archived-nonnctc.html','<section class="content"><h3>Authorization Fee Summary [non-NCTC] [choice of MSO]</h3><p>Select "MSO" and click on the "GO" button to generate the report.</p><div class="row"><div class="col-xs-4"><span>Select Report Date :</span><select ng-model="month" ng-options="currMonth for currMonth in result"></select><div style="margin-top:10px"><span>Select MSO :</span><select data-ng-model="selectedMSO"><option value="">-- All --</option></select></div><div style="margin-top: 10px"><button class="btn btn-primary" ui-sref="archivedbilling-main.archived-nonnctc"><span>Go</span></button></div></div></div></section>');
$templateCache.put('app/archived-billing/templates/archived-revenue.html','<section class="content"><h3>Revenue Summary</h3><p>Click on the "GO" button to generate the report.</p><div class="row"><div class="col-xs-4"><span>Select Report Date :</span><select ng-model="month" ng-options="currMonth for currMonth in result"></select><div style="margin-top: 10px"><button class="btn btn-primary" ui-sref="archivedbilling-main.archived-revenue"><span>Go</span></button></div></div></div></section>');
$templateCache.put('app/astb/headend/headend-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.headend.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.headend.delete.question" translate-values="{id: \'{{vm.headend.id}}\'}">Are you sure you want to delete this Headend?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/astb/headend/headend-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation id="headend-dialog-form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHeadendLabel" data-translate="nasracApp.headend.home.createOrEditLabel">Create or edit a Headend</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.headend.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.headend.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.bsiCode" for="field_bsiCode">Bsi Code</label><input type="number" class="form-control" name="bsiCode" id="field_bsiCode" ng-model="vm.headend.bsiCode" required><div ng-show="editForm.bsiCode.$invalid"><p class="help-block" ng-show="editForm.bsiCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bsiCode.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendType" for="field_headendType">Headend Type</label><select class="form-control" name="headendType" id="field_headendType" ng-model="vm.headend.headendType" ng-change="vm.headendTypeChanged()" required><option>HB</option><option>DL</option></select><div ng-show="editForm.headendType.$invalid"><p class="help-block" ng-show="editForm.headendType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendName" for="field_headendName">Headend Name</label><input type="text" class="form-control" name="headendName" id="field_headendName" ng-model="vm.headend.headendName" required ng-maxlength="50"><div ng-show="editForm.headendName.$invalid"><p class="help-block" ng-show="editForm.headendName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.headendName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendAddress" for="field_headendAddress">Headend Address</label><input type="text" class="form-control" name="headendAddress" id="field_headendAddress" ng-model="vm.headend.headendAddress" ng-maxlength="255"><div ng-show="editForm.headendAddress.$invalid"><p class="help-block" ng-show="editForm.headendAddress.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendCity" for="field_headendCity">Headend City</label><input type="text" class="form-control" name="headendCity" id="field_headendCity" ng-model="vm.headend.headendCity" ng-maxlength="50"><div ng-show="editForm.headendCity.$invalid"><p class="help-block" ng-show="editForm.headendCity.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendState" for="field_headendState">Headend State</label><input type="text" class="form-control" name="headendState" id="field_headendState" ng-model="vm.headend.headendState" ng-maxlength="50"><div ng-show="editForm.headendState.$invalid"><p class="help-block" ng-show="editForm.headendState.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendZip" for="field_headendZip">Headend Zip</label><input type="text" class="form-control" name="headendZip" id="field_headendZip" ng-model="vm.headend.headendZip" ng-maxlength="50"><div ng-show="editForm.headendZip.$invalid"><p class="help-block" ng-show="editForm.headendZip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendContactName" for="field_headendContactName">Headend Contact Name</label><input type="text" class="form-control" name="headendContactName" id="field_headendContactName" ng-model="vm.headend.headendContactName" ng-maxlength="50"><div ng-show="editForm.headendContactName.$invalid"><p class="help-block" ng-show="editForm.headendContactName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.headendPhoneNumber" for="field_headendPhoneNumber">Headend Phone Number</label><input type="text" class="form-control" name="headendPhoneNumber" id="field_headendPhoneNumber" ng-model="vm.headend.headendPhoneNumber" ng-maxlength="50"><div ng-show="editForm.headendPhoneNumber.$invalid"><p class="help-block" ng-show="editForm.headendPhoneNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.downlinkLocation" for="field_downlinkLocation">Downlink Location</label><input type="text" class="form-control" name="downlinkLocation" id="field_downlinkLocation" ng-model="vm.headend.downlinkLocation" required ng-maxlength="80"><div ng-show="editForm.downlinkLocation.$invalid"><p class="help-block" ng-show="editForm.downlinkLocation.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.downlinkLocation.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.boxFeeMot" for="field_boxFeeMot">Box Fee AURORA NETWORKS</label><input type="number" class="form-control" name="boxFeeMot" id="field_boxFeeMot" ng-model="vm.headend.boxFeeMot" required><div ng-show="editForm.boxFeeMot.$invalid"><p class="help-block" ng-show="editForm.boxFeeMot.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.boxFeeMot.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.boxFeeNonMot" for="field_boxFeeNonMot">Box Fee Non AURORA NETWORKS</label><input type="number" class="form-control" name="boxFeeNonMot" id="field_boxFeeNonMot" ng-model="vm.headend.boxFeeNonMot" required><div ng-show="editForm.boxFeeNonMot.$invalid"><p class="help-block" ng-show="editForm.boxFeeNonMot.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.boxFeeNonMot.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.dtaFee" for="field_dtaFee">DTA Fee</label><input type="number" class="form-control" name="dtaFee" id="field_dtaFee" ng-model="vm.headend.dtaFee" required><div ng-show="editForm.dtaFee.$invalid"><p class="help-block" ng-show="editForm.dtaFee.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dtaFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.minimumFee" for="field_minimumFee">Minimum Fee</label><input type="number" class="form-control" name="minimumFee" id="field_minimumFee" ng-model="vm.headend.minimumFee" required><div ng-show="editForm.minimumFee.$invalid"><p class="help-block" ng-show="editForm.minimumFee.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.minimumFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.usingNonMotCode" for="field_usingNonMotCode">Using Non AURORA NETWORKS Code</label><input type="checkbox" name="usingNonMotCode" id="field_usingNonMotCode" ng-model="vm.headend.usingNonMotCode"><div ng-show="editForm.usingNonMotCode.$invalid"><p class="help-block" ng-show="editForm.usingNonMotCode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.nctcMember" for="field_nctcMember">NCTC Member</label><input type="checkbox" name="nctcMember" id="field_nctcMember" ng-model="vm.headend.nctcMember" ng-change="vm.toggleNctcMember()"><div ng-show="editForm.nctcMember.$invalid"><p class="help-block" ng-show="editForm.nctcMember.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.nctcMemberId" for="field_nctcMemberId">NCTC Member Id</label><input type="text" class="form-control" name="nctcMemberId" id="field_nctcMemberId" ng-model="vm.headend.nctcMemberId" ng-disabled="!vm.headend.nctcMember" ng-required="vm.headend.nctcMember"><div ng-show="editForm.nctcMemberId.$invalid"><p class="help-block" ng-show="editForm.nctcMemberId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nctcMemberId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 50 characters .</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.headend.nctcSystemId" for="field_nctcSystemId">NCTC System Id</label><input type="number" class="form-control" name="nctcSystemId" id="field_nctcSystemId" ng-model="vm.headend.nctcSystemId" ng-disabled="!vm.headend.nctcMember" ng-required="vm.headend.nctcMember"><div ng-show="editForm.nctcSystemId.$invalid"><p class="help-block" ng-show="editForm.nctcSystemId.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nctcSystemId.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="nasracApp.headend.office" for="field_office">Office</label><select class="form-control" id="field_office" name="office" ng-model="vm.headend.officeId" ng-options="office.id as office.officeName + \' (\' + office.msoMsoName +\' )\' for office in vm.offices | orderBy:\'officeName\'" required></select></div><div ng-show="editForm.office.$invalid"><p class="help-block" ng-show="editForm.office.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/astb/headend/headend-manage-pricing-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHeadendManagePricingLabel">Channel Map Manage Pricing</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_boxFeeMot">Box Fee AURORA NETWORKS</label><input type="number" class="form-control" name="boxFeeMot" id="field_boxFeeMot" ng-model="vm.headendManagePricing.boxFeeMot" required><div ng-show="editForm.boxFeeMot.$invalid"><p class="help-block" ng-show="editForm.boxFeeMot.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.boxFeeMot.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_boxFeeNonMot">Box Fee Non AURORA NETWORKS</label><input type="number" class="form-control" name="boxFeeNonMot" id="field_boxFeeNonMot" ng-model="vm.headendManagePricing.boxFeeNonMot" required><div ng-show="editForm.boxFeeNonMot.$invalid"><p class="help-block" ng-show="editForm.boxFeeNonMot.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.boxFeeNonMot.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_dtaFee">DTA Fee</label><input type="number" class="form-control" name="dtaFee" id="field_dtaFee" ng-model="vm.headendManagePricing.dtaFee" required><div ng-show="editForm.dtaFee.$invalid"><p class="help-block" ng-show="editForm.dtaFee.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dtaFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_applyTo">Apply To</label><select class="form-control" name="applyTo" ng-model="vm.headendManagePricing.applyTo" id="field_applyTo" required disabled="disabled"><option value="ALL" selected="selected">ALL</option></select><div ng-show="editForm.applyTo.$invalid"><p class="help-block" ng-show="editForm.applyTo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/astb/headend/headends.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.headend.createHeadendRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="astbmso-main.headend.new"><span class="glyphicon glyphicon-flash"></span> <span>New Channel Map</span></button> <button class="btn btn-primary" ui-sref="headend-manage-pricing"><span class="glyphicon glyphicon-flash"></span> <span>Manage Pricing</span></button></div></div><br><div class="row"><div class="col-xs-12"><div class="table-responsive"><table id="nasracheadendbar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered" id="headend-table"></table></div></div></div></section>');
$templateCache.put('app/astb/mso/mso-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mso.id, vm.mso.msoName)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error id="alert-error"></jhi-alert-error><p data-translate="nasracApp.mso.delete.question" translate-values="{id: \'{{vm.mso.msoName}}\'}">Are you sure you want to delete this Mso?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/astb/mso/mso-detail.html','<div><h2><span data-translate="nasracApp.mso.detail.title">Mso</span> {{vm.mso.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="nasracApp.mso.msoName">Mso Name</span></dt><dd><span>{{vm.mso.msoName}}</span></dd><dt><span data-translate="nasracApp.mso.msoAddress">Mso Address</span></dt><dd><span>{{vm.mso.msoAddress}}</span></dd><dt><span data-translate="nasracApp.mso.msoNoMotcode">Mso No Motcode</span></dt><dd><span>{{vm.mso.msoNoMotcode}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="astbmso-main.mso-detail.edit({id:vm.mso.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/astb/mso/mso-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMsoLabel" data-translate="nasracApp.mso.home.createOrEditLabel">Create or edit a Mso</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.mso.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mso.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.mso.msoName" for="field_msoName">MSO Name</label><input type="text" class="form-control" name="msoName" id="field_msoName" ng-model="vm.mso.msoName" required ng-maxlength="50"><div ng-show="editForm.msoName.$invalid"><p class="help-block" ng-show="editForm.msoName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.mso_name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.mso.msoAddress" for="field_msoAddress">MSO Address</label><textarea rows="4" cols="50" class="form-control" name="msoAddress" id="field_msoAddress" ng-model="vm.mso.msoAddress" ng-maxlength="255"></textarea><div ng-show="editForm.msoAddress.$invalid"><p class="help-block" ng-show="editForm.msoAddress.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><input type="checkbox" name="msoNoMotcode" id="field_msoNoMotcode" ng-model="vm.mso.msoNoMotcode"> &nbsp;<label class="control-label" data-translate="nasracApp.mso.msoNoMotcode" for="field_msoNoMotcode">Mso Motcode Flag</label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/astb/mso/msos.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.mso.createMsoRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="astbmso-main.mso.new"><span class="glyphicon glyphicon-flash"></span> <span>New MSO</span></button></div></div><br><div class="row"><div class="col-xs-12"><div class="table-responsive"><table id="nasracmsobar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></section>');
$templateCache.put('app/astb/office/office-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.office.id, vm.office.officeName)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.office.delete.question" translate-values="{id: \'{{vm.office.officename}}\'}">Are you sure you want to delete this Office?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/astb/office/office-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOfficeLabel" data-translate="nasracApp.office.home.createOrEditLabel">Create or edit a Office</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.office.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.office.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.office.officeName" for="field_officeName">Office Name</label><input type="text" class="form-control" name="officeName" id="field_officeName" ng-model="vm.office.officeName" required ng-maxlength="50"><div ng-show="editForm.officeName.$invalid"><p class="help-block" ng-show="editForm.officeName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.officeName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.office.officeAddress" for="field_officeAddress">Office Address</label><textarea type="text" class="form-control" name="officeAddress" id="field_officeAddress" ng-model="vm.office.officeAddress" ng-maxlength="255"></textarea><div ng-show="editForm.officeAddress.$invalid"><p class="help-block" ng-show="editForm.officeAddress.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label data-translate="nasracApp.office.mso" for="field_mso">Mso</label><select class="form-control" id="field_mso" name="mso" ng-model="vm.office.msoId" ng-options="mso.id as mso.msoName for mso in vm.msos | orderBy:\'msoName\'" required></select></div><div ng-show="editForm.mso.$invalid"><p class="help-block" ng-show="editForm.mso.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/astb/office/offices.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.office.createOfficeRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="astbmso-main.office.new"><span class="glyphicon glyphicon-flash"></span> <span>New Office</span></button></div></div><br><div class="row"><div class="col-xs-12"><div class="table-responsive"><table id="nasracmsobar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></section>');
$templateCache.put('app/astb/templates/billing-current-reports.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 class="text-center">NAS-RAC CURRENT BILLING REPORTS</h1></div></div></div>');
$templateCache.put('app/astb-billing/templates/billing-archived-reports.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 class="text-center">NAS-RAC ARCHIVED BILLING REPORTS</h1></div></div></div>');
$templateCache.put('app/billing-reports/dta/dta.html','<section class="content"><br><p>Select a "Report Date" then click on the "GO" button to generate the report</p><div class="row"><div class="col-lg-12 col-md-12"><span>Report Date :</span><select data-ng-model="selectedMonth" data-ng-options="item.reportDateLabel for item in reportDate"></select><button class="btn btn-primary" data-ng-click="loadData();" style="margin-left: 15px"><span>Go</span></button></div></div><div data-ng-if="dtaList.length>0"><div class="row border-white-with-padding"><div class="row align-center"><div class="col-md-12">AURORA NETWORKS International</div></div><div class="row align-center"><div class="col-md-12">NAS-RAC</div></div><div class="row align-center"><div class="col-md-12">Authorization Fee Summary for {{date.reportDateLabel}}</div></div></div><div class="row col-xs-12 table-responsive"><table datatable="ng" dt-options="dtOptions" class="table table-striped table-bordered" id="dtaDT"><thead><tr><th>Office Name</th><th>Headend Name</th><th>Digital_HE_Type</th><th>Using_NonARRISCode</th><th>Digital_ARRIS</th><th>Digital_NonARRIS</th><th>DTA</th><th>SetTop_Count</th><th>Std_Rate_Charges</th><th>MinimumFee</th><th>Service_Charge</th></tr></thead><tbody><tr data-ng-repeat="dta in dtaList"><td>{{ dta.officeName }}</td><td>{{ dta.headendName }}</td><td>{{ dta.headendType }}</td><td>{{ dta.usingNonMotCode== false ? \'No\' : \'Yes\' }}</td><td>{{ dta.digitalMot }}</td><td>{{ dta.digitalNonMot }}</td><td>{{ dta.dta }}</td><td>{{ dta.setTopCount }}</td><td>{{ dta.stdRateCharges| currency }}</td><td>{{ dta.minimumFee| currency }}</td><td>{{ dta.serviceCharge| currency }}</td></tr></tbody><tfoot><tr style="font-weight: bold"><td>Total</td><td></td><td></td><td></td><td>{{total.digitalMot}}</td><td>{{total.digitalNonMot}}</td><td>{{total.dta}}</td><td>{{total.setTopCount}}</td><td>{{total.stdRateCharges | currency}}</td><td>{{total.minimumFee | currency}}</td><td>{{total.serviceCharge | currency}}</td></tr></tfoot></table></div><div class="align-center">As of {{currentTime}}</div></div><div data-ng-if="dtaList.length==0"><p class="align-center">No Data is Available</p></div></section>');
$templateCache.put('app/billing-reports/nctc/nctc.html','<section class="content"><br><p>Select a "Report Date" then click on the "GO" button to generate the report</p><div class="row"><div class="col-lg-12 col-md-12"><span>Report Date :</span><select data-ng-model="selectedMonth" data-ng-options="item.reportDateLabel for item in reportDate"></select><button class="btn btn-primary" data-ng-click="loadData();" style="margin-left: 15px"><span>Go</span></button></div></div><div data-ng-if="nctcList.length>0"><div class="row border-white-with-padding"><div class="row align-center"><div class="col-md-12">AURORA NETWORKS International</div></div><div class="row align-center"><div class="col-md-12">NAS-RAC</div></div><div class="row align-center"><div class="col-md-12">Authorization Fee Summary for {{date.reportDateLabel}}</div></div></div><div class="row col-xs-12 table-responsive"><table data-datatable="ng" data-dt-options="dtOptions" class="table table-striped table-bordered" id="nctcDT"><thead><tr><th>Office Name</th><th>Headend Name</th><th>Digital_HE_Type</th><th>Using_NonARRISCode</th><th>Digital_ARRIS</th><th>Digital_NonARRIS</th><th>DTA</th><th>SetTop_Count</th><th>Std_Rate_Charges</th><th>MinimumFee</th><th>Service_Charge</th><th data-ng-hide="true">NCTC_Member_Yes_No</th><th>NCTC_Member_Id</th><th>NCTC_System_Id</th></tr></thead><tbody><tr data-ng-repeat="nctc  in nctcList"><td>{{ nctc.officeName }}</td><td>{{ nctc.headendName }}</td><td>{{ nctc.headendType }}</td><td>{{ nctc.usingNonMotCode == false ? \'No\' : \'Yes\'}}</td><td>{{ nctc.digitalMot }}</td><td>{{ nctc.digitalNonMot }}</td><td>{{ nctc.dta }}</td><td>{{ nctc.setTopCount }}</td><td>{{ nctc.stdRateCharges | currency }}</td><td>{{ nctc.minimumFee | currency }}</td><td>{{ nctc.serviceCharge | currency }}</td><td data-ng-hide="true">{{ nctc.nctcMemberYesNo}}</td><td>{{ nctc.nctcMemberId }}</td><td>{{ nctc.nctcSystemId }}</td></tr></tbody><tfoot><tr style="font-weight: bold"><td>Total</td><td></td><td></td><td></td><td>{{total.digitalMot}}</td><td>{{total.digitalNonMot}}</td><td>{{total.dta}}</td><td>{{total.setTopCount}}</td><td>{{total.stdRateCharges | currency}}</td><td>{{total.minimumFee | currency}}</td><td>{{total.serviceCharge | currency}}</td><td></td><td></td><td></td></tr></tfoot></table></div><div class="align-center">As of {{currentTime}}</div></div><div data-ng-if="nctcList.length==0"><p class="align-center">No Data is Available</p></div></section>');
$templateCache.put('app/billing-reports/nonnctc/nonnctc.html','<section class="content"><br><p>Select a "Report Date" then the "MSO" and click on the "GO" button to generate the report</p><div class="row"><div class="col-lg-12 col-md-12"><span>Report Date :</span><select data-ng-model="selectedMonth" data-ng-change="onDateChange();" data-ng-options="item.reportDateLabel for item in reportDate"></select><span style="margin-left: 15px">Select MSO :</span><select data-ng-model="selectedMso" data-ng-options="item.msoName for item in msoList"><option value="">-- All --</option></select><button class="btn btn-primary" data-ng-click="loadData();" style="margin-left: 15px"><span>Go</span></button></div><!--<div style="margin-top: 10px;">--></div><div data-ng-if="nonNctcList.length>0"><div class="row border-white-with-padding"><div class="row align-center"><div class="col-md-12">AURORA NETWORKS International</div></div><div class="row align-center"><div class="col-md-12">NAS-RAC</div></div><div class="row align-center"><div class="col-md-12">Authorization Fee Summary for <span data-ng-if="selectedMso.msoName.length>0">{{selectedMso.msoName}} </span>{{date.reportDateLabel}}</div></div></div><div class="row col-xs-12 table-responsive"><table datatable="ng" dt-options="dtOptions" class="table table-striped table-bordered" id="nonNctcDT"><thead><tr><th>Office Name</th><th>Headend Name</th><th>Digital_HE_Type</th><th>Using_NonARRISCode</th><th>Digital_ARRIS</th><th>Digital_NonARRIS</th><th>DTA</th><th>SetTop_Count</th><th>Std_Rate_Charges</th><th>MinimumFee</th><th>Service_Charge</th></tr></thead><tbody><tr data-ng-repeat="nonNctc in nonNctcList"><td>{{ nonNctc.officeName }}</td><td>{{ nonNctc.headendName }}</td><td>{{ nonNctc.headendType }}</td><td>{{ nonNctc.usingNonMotCode == false ? \'No\' : \'Yes\'}}</td><td>{{ nonNctc.digitalMot }}</td><td>{{ nonNctc.digitalNonMot }}</td><td>{{ nonNctc.dta }}</td><td>{{ nonNctc.setTopCount }}</td><td>{{ nonNctc.stdRateCharges | currency }}</td><td>{{ nonNctc.minimumFee | currency }}</td><td>{{ nonNctc.serviceCharge | currency}}</td></tr></tbody><tfoot><tr style="font-weight: bold"><td>Total</td><td></td><td></td><td></td><td>{{total.digitalMot}}</td><td>{{total.digitalNonMot}}</td><td>{{total.dta}}</td><td>{{total.setTopCount}}</td><td>{{total.stdRateCharges | currency}}</td><td>{{total.minimumFee | currency}}</td><td>{{total.serviceCharge | currency}}</td></tr></tfoot></table></div><div class="align-center">As of {{currentTime}}</div></div><div data-ng-if="nonNctcList.length==0"><p class="align-center">No Data is Available</p></div></section>');
$templateCache.put('app/billing-reports/revenue/revenue.html','<section class="content"><br><p>Select a "Report Date" then click on the "GO" button to generate the report</p><div class="row"><div class="col-lg-12 col-md-12"><span>Report Date :</span><select data-ng-model="selectedMonth" data-ng-options="item.reportDateLabel for item in reportDate"></select><button class="btn btn-primary" data-ng-click="loadData();" style="margin-left: 15px"><span>Go</span></button></div></div><div data-ng-if="revenueList.length>0"><div class="row border-white-with-padding"><div class="row align-center"><div class="col-md-12">AURORA NETWORKS International</div></div><div class="row align-center"><div class="col-md-12">NAS-RAC</div></div><div class="row align-center"><div class="col-md-12">Revenue Summary for {{date.reportDateLabel}}</div></div></div><div class="row"><table datatable="ng" dt-options="dtOptions" class="table table-striped table-bordered" id="revenueDT"><thead><tr><th>MSO Name</th><th>Digital_ARRIS</th><th>Digital_NonARRIS</th><th>DTA</th><th>TotalActiveUnits</th><th>Service_Charge</th></tr></thead><tbody><tr data-ng-repeat="revenue  in revenueList"><td>{{ revenue.msoName }}</td><td>{{ revenue.digitalMot }}</td><td>{{ revenue.digitalNonMot }}</td><td>{{ revenue.dta }}</td><td>{{ revenue.totalactiveUnits }}</td><td>{{ revenue.serviceCharge | currency }}</td></tr></tbody><tfoot><tr style="font-weight: bold"><td>Total</td><td>{{ total.digitalMot }}</td><td>{{ total.digitalNonMot }}</td><td>{{ total.dta }}</td><td>{{ total.totalactiveUnits }}</td><td>{{ total.serviceCharge | currency }}</td></tr></tfoot></table></div><div class="align-center">As of {{currentTime}}</div></div><div data-ng-if="revenueList.length==0"><p class="align-center">No Data is Available</p></div></section>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>Failed to sign in!</strong> {{vm.authenticationErrorMessage}}</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/dac-content/nasrac-package/nasrac-package-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracPackage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracPackage.delete.question" translate-values="{id: \'{{vm.nasracPackage.packageName}}\'}">Are you sure you want to delete this Nasrac Package?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-package/nasrac-package-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracPackageLabel" data-translate="nasracApp.nasracPackage.home.createOrEditLabel">Create or edit a NAS-RAC Package</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.nasracPackage.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.nasracPackage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracPackage.packageBsgHandle" for="field_packageBsgHandle">Package BSG Handle</label><input type="number" class="form-control" name="packageBsgHandle" id="field_packageBsgHandle" ng-model="vm.nasracPackage.packageBsgHandle" ng-change="vm.pckBsgChanged()" required><div class="controls panel panel-default formSearchFilter" style="max-height: 200px;overflow: auto" ng-show="vm.showMissingNumbrs"><ul class="list-group searchFormGroup"><li class="fontStyle" ng-repeat="s in vm.unusedPckList | filter:vm.nasracPackage.packageBsgHandle" ng-click="vm.bindVal(s)">{{s}}</li></ul></div></div><div ng-show="editForm.packageBsgHandle.$invalid"><p class="help-block" ng-show="editForm.packageBsgHandle.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracPackage.packageName" for="field_packageName">Package Name</label><input type="text" class="form-control" name="packageName" id="field_packageName" ng-model="vm.nasracPackage.packageName" required ng-maxlength="50"><div ng-show="editForm.packageName.$invalid"><p class="help-block" ng-show="editForm.packageName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.packageName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-package/nasrac-package-unusedlist-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracServiceLabel">List of unused Package id\'s</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="brs-unused-list"><ul><li ng-repeat="unusedPckRange in vm.unusedPckList">{{unusedPckRange}}</li></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div>');
$templateCache.put('app/dac-content/nasrac-package/nasrac-packages.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracPackages.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="dac-content-main.nasrac-package.new"><span class="glyphicon glyphicon-flash"></span> <span>New Package</span></button> <button class="btn btn-primary" ui-sref="dac-content-main.nasrac-package.unusedPckList"><span></span> <span>Ununsed Package BSG\'s</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="nasracpackagebar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/dac-content/nasrac-provider/nasrac-provider-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracProvider.id, vm.nasracProvider.providerType)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracProvider.delete.question" translate-values="{id: \'{{vm.nasracProvider.providerType}}\'}">Are you sure you want to delete this Nasrac Provider?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-provider/nasrac-provider-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracProviderLabel" data-translate="nasracApp.nasracProvider.home.createOrEditLabel">Create or edit a Nasrac Provider</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracProvider.providerId" for="field_providerId">Provider Id</label><input type="number" class="form-control" name="providerId" id="field_providerId" ng-readonly="!vm.isSave" ng-model="vm.nasracProvider.id" required><div ng-show="editForm.providerId.$invalid"><p class="help-block" ng-show="editForm.providerId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracProvider.providerType" for="field_providerType">Provider Type</label><input type="text" class="form-control" name="providerType" id="field_providerType" ng-model="vm.nasracProvider.providerType" required ng-maxlength="50"><div ng-show="editForm.providerType.$invalid"><p class="help-block" ng-show="editForm.providerType.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.providerType.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-provider/nasrac-providers.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracProviders.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="dac-content-main.nasrac-provider.new"><span class="glyphicon glyphicon-flash"></span> <span>New Provider</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="nasracproviderbar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/dac-content/nasrac-service/nasrac-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracService.delete.question" translate-values="{id: \'{{vm.nasracService.id}}\'}">Are you sure you want to delete this Nasrac Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-service/nasrac-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracServiceLabel" data-translate="nasracApp.nasracService.home.createOrEditLabel">Create or edit a Nasrac Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="nasracApp.nasracService.bsgHandle" for="field_bsgHandle">Service BSG Handle</label><input type="number" class="form-control" id="field_bsgHandle" name="bsgHandle" ng-model="vm.nasracService.id" ng-readonly="!vm.isSave" required><div ng-show="editForm.bsgHandle.$invalid"><p class="help-block" ng-show="editForm.bsgHandle.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="nasracApp.nasracService.nasracSource" for="field_nasracSource">Nasrac Source</label><select class="form-control" id="field_nasracSource" name="nasracSource" ng-model="vm.nasracService.nasracSourceId" ng-options="nasracSource.id as nasracSource.sourceName for nasracSource in vm.nasracsources | orderBy:\'sourceName\'" required></select></div><div ng-show="editForm.nasracSource.$invalid"><p class="help-block" ng-show="editForm.nasracSource.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="nasracApp.nasracService.nasracProvider" for="field_nasracProvider">Nasrac Provider</label><select class="form-control" id="field_nasracProvider" name="nasracProvider" ng-model="vm.nasracService.nasracProviderId" ng-options="nasracProvider.id as nasracProvider.providerType for nasracProvider in vm.nasracproviders | orderBy:\'providerType\'" required></select></div><div ng-show="editForm.nasracProvider.$invalid"><p class="help-block" ng-show="editForm.nasracProvider.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-service/nasrac-service-unusedBsg-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracServiceLabel">List of unused BSG id\'s</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="brs-unused-list"><ul><li ng-repeat="unusedBsgRange in vm.unusedBsgList">{{unusedBsgRange}}</li></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div>');
$templateCache.put('app/dac-content/nasrac-service/nasrac-services.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracServices.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="dac-content-main.nasrac-service.new"><span class="glyphicon glyphicon-flash"></span> <span>New Service</span></button> <button class="btn btn-primary" ui-sref="dac-content-main.nasrac-service.unusedBsgList"><span class="bt-lg"></span> <span>Unused BSG\'s</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="nasracservicebar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/dac-content/nasrac-source/nasrac-source-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracSource.id, vm.nasracSource.sourceName)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracSource.delete.question" translate-values="{id: \'{{vm.nasracSource.sourceName}}\'}">Are you sure you want to delete this Nasrac Source?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-source/nasrac-source-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracSourceLabel" data-translate="nasracApp.nasracSource.home.createOrEditLabel">Create or edit a Nasrac Source</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="nasracApp.nasracSource.sourceId" for="field_sourceId">Source Id</label><input type="number" class="form-control" id="field_sourceId" name="sourceId" ng-model="vm.nasracSource.id" ng-readonly="!vm.isSave" required><div ng-show="editForm.sourceId.$invalid"><p class="help-block" ng-show="editForm.sourceId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracSource.sourceName" for="field_sourceName">Source Name</label><input type="text" class="form-control" name="sourceName" id="field_sourceName" ng-model="vm.nasracSource.sourceName" required ng-maxlength="75"><div ng-show="editForm.sourceName.$invalid"><p class="help-block" ng-show="editForm.sourceName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sourceName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="75">This field cannot be longer than 75 characters.</p></div></div><div class="form-group"><label data-translate="nasracApp.nasracSource.nasracSourceType" for="field_nasracSourceType">Source Type</label><select class="form-control" id="field_nasracSourceType" name="nasracSourceType" ng-model="vm.nasracSource.nasracSourceTypeId" ng-options="nasracSourceType.id as nasracSourceType.sourceType for nasracSourceType in vm.nasracsourcetypes" required><option value=""></option></select></div><div ng-show="editForm.nasracSourceType.$invalid"><p class="help-block" ng-show="editForm.nasracSourceType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-source/nasrac-sources.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracSources.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="dac-content-main.nasrac-source.new"><span class="glyphicon glyphicon-flash"></span> <span>New Source</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="nasracsourcebar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/dac-content/nasrac-source-type/nasrac-source-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracSourceType.id, vm.nasracSourceType.sourceType)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracSourceType.delete.question" translate-values="{id: \'{{vm.nasracSourceType.sourceType}}\'}">Are you sure you want to delete this Nasrac Source Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-source-type/nasrac-source-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracSourceTypeLabel" data-translate="nasracApp.nasracSourceType.home.createOrEditLabel">Create or edit a Nasrac Source Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.nasracSourceType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.nasracSourceType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracSourceType.sourceType" for="field_sourceType">Source Type</label><input type="text" class="form-control" name="sourceType" id="field_sourceType" ng-model="vm.nasracSourceType.sourceType" required ng-maxlength="50"><div ng-show="editForm.sourceType.$invalid"><p class="help-block" ng-show="editForm.sourceType.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.sourceType.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/dac-content/nasrac-source-type/nasrac-source-types.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracSourceTypes.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="dac-content-main.nasrac-source-type.new"><span class="glyphicon glyphicon-flash"></span> <span>New Source Type</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="nasracsourcetypebar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/dac-content/templates/dac-content.html','<section class="content"><tabs data="tabData" type="pills"></tabs></section>');
$templateCache.put('app/home/arris-account-contacts/arris-account-contacts.html','<div ng-cloak><div class="text-right" ng-show="vm.isAuthenticated()" has-any-authority="{{vm.homePageContacts.adminRoles}}" id="editorBtn"><button type="submit" class="btn btn-primary btn-sm" ng-click="openEditor()" id="home-editor-open-button"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.editor"></span></button></div><br><!-- form  --><div ng-show="vm.isAuthenticated() && editMode" id="editorForm"><form name="editForm" method="post" role="form" novalidate ng-submit="updateContents()" id="home-editor-form"><textarea ui-tinymce="tinymceOptions" ng-model="contactsTinymceModel"></textarea><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="cancelEditor()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel" id="home-editor-cancel-button">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" id="home-editor-save-button"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div><div ng-show="!editMode"><div ng-bind-html="trustedHtml" id="home-noedit-text"></div></div></div>');
$templateCache.put('app/home/home-page/home-page.html','<div ng-cloak><div class="text-right" ng-show="vm.isAuthenticated()" has-any-authority="{{vm.homePage.adminRoles}}" id="editorBtn"><button type="submit" class="btn btn-primary btn-sm" ng-click="openEditor()" id="home-editor-open-button"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.editor"></span></button></div><br><!-- form  --><div ng-show="vm.isAuthenticated() && editMode" id="editorForm"><form name="editForm" method="post" role="form" novalidate ng-submit="updateContents()" id="home-editor-form"><textarea ui-tinymce="tinymceOptions" ng-model="tinymceModel"></textarea><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="cancelEditor()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel" id="home-editor-cancel-button">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" id="home-editor-save-button"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div><div ng-show="!editMode"><div ng-bind-html="trustedHtml" id="home-noedit-text"></div></div></div>');
$templateCache.put('app/home/important-announcements/important-announcements.html','<div ng-cloak><div class="text-right" ng-show="vm.isAuthenticated()" has-any-authority="{{vm.homePageAnnouncements.adminRoles}}" id="editorBtn"><button type="submit" class="btn btn-primary btn-sm" ng-click="openEditor()" id="home-editor-open-button"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.editor"></span></button></div><br><div class="header"><h2>Important Announcements</h2></div><div><p>Please always check this area for important announcements from AURORA NETWORKS NAS-RAC project team.</p></div><div><div class="row border-white-with-padding"><!-- form --><div ng-show="vm.isAuthenticated() && editMode" id="editorForm"><form name="editForm" method="post" role="form" novalidate ng-submit="updateContents()" id="home-editor-form"><textarea ui-tinymce="tinymceOptions" ng-model="tinymceModel"></textarea><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="cancelEditor()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel" id="home-editor-cancel-button">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" id="home-editor-save-button"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div><div ng-show="!editMode"><div ng-bind-html="trustedHtml" id="home-noedit-text"></div></div></div></div><div><p>Thanks for your support.</p></div></div>');
$templateCache.put('app/home/sign-out-home-page/sign-out-home-page.html','<div ng-cloak><div ng-bind-html="contactsTrustedHtml"></div></div>');
$templateCache.put('app/home/user-home-page/user-home-page.html','<div ng-cloak><div class="header"><h2>Important Announcements</h2></div><div><p>Please always check this area for important announcements from AURORA NETWORKS NAS-RAC project team.</p></div><div><div class="row border-white-with-padding"><div ng-bind-html="announcementsTrustedHtml"></div></div></div><div><p>Thanks for your support.</p></div><br><br><div ng-bind-html="contactsTrustedHtml"></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/home-main/homePage" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/Aurora_Logo_TM_RGB_Primary.png" alt="logo"> <span>NAS-RAC</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-left"><!--<li id="li_home" ui-sref-active="active">\n                    <a ui-sref="home" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-home"></span>\n                        <span class="hidden-sm" >Home</span>\n                    </a>\n                </li>--><li id="li_home" ng-class="{active: vm.$state.in(\'home-main\')|| vm.$state.includes(\'user-home-page\') || vm.$state.includes(\'sign-out-home-page\')}"><a ng-click="vm.checkUser()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm">Home</span></a></li><li id="li_forms" ng-class="{active: vm.$state.includes(\'forms\')}"><a ui-sref="forms" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm">Forms</span></a></li><li id="li_dac_content" ng-class="{active: vm.$state.includes(\'dac-content-main\')}" ng-switch-when="true" has-any-authority="{{vm.navbar.dacMenuRoles}}"><a ui-sref="dac-content-main.nasrac-service"><span class="glyphicon glyphicon-book"></span> <span class="hidden-sm">DAC CONTENT</span></a></li><li id="li_reports" ng-class="{active: vm.$state.includes(\'reports\')}" ng-switch-when="true" has-any-authority="{{vm.navbar.reportsMenuRoles}}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="li_reports_menu"><span><span class="glyphicon glyphicon-list-alt"></span> <span class="hidden-sm">Reports</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="change-management-hours-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>Change Management Hours Reports</span></a></li><li ui-sref-active="active"><a ui-sref="nasrac-customer-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>Customer Reports</span></a></li><li ui-sref-active="active" has-any-authority="{{vm.navbar.fullAccessRoles}}"><a ui-sref="siteadminreports" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>Site Admin Reports</span></a></li><!--removing other menu items from the reports menu--><!--<li ui-sref-active="active">\n                            <a ui-sref="reports-contracts" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span>Customer Contracts Explorer</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="reports-management" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span>Management Reports</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="reports-user" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span>User Reports</span>\n                            </a>\n                        </li>--></ul></li><li id="li_faq" ng-class="{active: vm.$state.includes(\'faq\')}"><a ui-sref="faq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-question-sign"></span> <span class="hidden-sm">F.A.Q.</span></a></li><li id="li_feedback" ng-class="{active: vm.$state.includes(\'feedback\')}" ng-switch-when="true"><a ui-sref="feedback" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-comment"></span> <span class="hidden-sm">Feedback</span></a></li><li id="li_astb_billing" ng-class=" {active: vm.$state.includes(\'billing-reports\') || vm.$state.includes(\'astb\')} " ng-switch-when="true" has-any-authority="{{vm.navbar.astbMenuRoles}}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="billing_menu"><span><span class="glyphicon glyphicon-usd"></span> <span class="hidden-sm">ASTB Billing</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="astbmso-main.headend" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-usd"></span>&nbsp; <span>Business System</span></a></li><!-- <li ui-sref-active="active">\n                            <a ui-sref="astbmso-main.billing-current-reports" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-usd"></span>&nbsp;\n                                <span>Current Billing Reports</span>\n                            </a>\n                        </li> --><li ui-sref-active="active"><a ui-sref="billing-reports-main.nonnctc" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-usd"></span>&nbsp; <span>Billing Reports</span></a></li></ul></li><li id="li_nasrac_admin" ng-class="{active: vm.$state.includes(\'nasrac-admin\')}" ng-switch-when="true" has-any-authority="{{vm.navbar.adminMenuRoles}}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Admin</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="nasrac-admin-customer-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>Customer Accounts</span></a></li><li ui-sref-active="active"><a ui-sref="nasrac-admin-user-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User Accounts</span></a></li><li ui-sref-active="active"><a ui-sref="security-roles" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cog"></span>&nbsp; <span>Security Roles</span></a></li><li ui-sref-active="active" has-any-authority="{{vm.navbar.adminMenuRoles}}"><a ui-sref="configuresiteadmin" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>Configure Site Admin</span></a></li></ul></li><!-- <li id="li_admin" ng-class="{active: vm.$state.includes(\'admin\')}"  ng-switch-when="true" has-authority="Administrators" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm">Administration</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active">\n                            <a ui-sref="user-management" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\n                                <span>User management</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\n                                <span>Metrics</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-heart"></span>&nbsp;\n                                <span>Health</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\n                                <span>Configuration</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="audits" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-bell"></span>&nbsp;\n                                <span>Audits</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="logs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-tasks"></span>&nbsp;\n                                <span>Logs</span>\n                            </a>\n                        </li>\n                        <li ng-show="vm.swaggerEnabled" ui-sref-active="active">\n                            <a ui-sref="docs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span>API</span>\n                            </a>\n                        </li>\n                        jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here\n                    </ul>\n                </li> --><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul><div ng-show="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">{{ vm.accountDetails.displayName}} </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Profile</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Change Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span>Register</span></a></li></ul></li></ul></div><div ng-show="!vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Sign in</span></a></li></ul></div></div></div></nav>');
$templateCache.put('app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracAdminCustomerAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracAdminCustomerAccount.delete.question" translate-values="{id: \'{{vm.nasracAdminCustomerAccount.siteId}}\'}">Are you sure you want to delete this Nasrac Admin Customer Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-detail.html','<div><h2><span data-translate="nasracApp.nasracAdminCustomerAccount.detail.title">Nasrac Admin Customer Account</span> {{vm.nasracAdminCustomerAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.siteId">Site Id</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.siteId}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.firstName">First Name</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.firstName}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.lastName">Last Name</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.lastName}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.email">Email</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.email}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.phone">Phone</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.phone}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.address">Address</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.address}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.city">City</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.city}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.country">Country</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.country}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.state">State</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.state}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.zipcode">Zipcode</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.zipcode}}</span></dd><dt><span data-translate="nasracApp.nasracAdminCustomerAccount.launchDate">Launch Date</span></dt><dd><span>{{vm.nasracAdminCustomerAccount.launchDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="nasrac-admin-customer-account-detail.edit({id:vm.nasracAdminCustomerAccount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracAdminCustomerAccountLabel" data-translate="nasracApp.nasracAdminCustomerAccount.home.createOrEditLabel">Create or edit a Nasrac Admin Customer Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.nasracAdminCustomerAccount.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.nasracAdminCustomerAccount.id" readonly="readonly"></div><div class="form-group"><!--<label>Site Id</label>--><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.siteId" for="field_siteId">Site Id</label><input type="number" class="form-control" name="siteId" id="field_siteId" ng-model="vm.nasracAdminCustomerAccount.siteId" ng-readonly="vm.isReadOnly"><!--<div ng-show="editForm.siteId.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.siteId.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.siteId.$error.number" data-translate="entity.validation.number">\n                    This field should be a number.\n                </p>\n            </div>--></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.nasracAdminCustomerAccount.firstName" required ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.nasracAdminCustomerAccount.lastName" required ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.nasracAdminCustomerAccount.email" required ng-maxlength="80"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.nasracAdminCustomerAccount.phone" required ng-maxlength="30"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.nasracAdminCustomerAccount.address" ng-maxlength="120"><div ng-show="editForm.address.$invalid"><p class="help-block" ng-show="editForm.address.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="120">This field cannot be longer than 120 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.nasracAdminCustomerAccount.city" ng-maxlength="50"><div ng-show="editForm.city.$invalid"><p class="help-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.country" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.nasracAdminCustomerAccount.country" ng-maxlength="50"><div ng-show="editForm.country.$invalid"><p class="help-block" ng-show="editForm.country.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.state" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.nasracAdminCustomerAccount.state" ng-maxlength="50"><div ng-show="editForm.state.$invalid"><p class="help-block" ng-show="editForm.state.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminCustomerAccount.zipcode" for="field_zipcode">Zipcode</label><input type="text" class="form-control" name="zipcode" id="field_zipcode" ng-model="vm.nasracAdminCustomerAccount.zipcode" ng-maxlength="12"><div ng-show="editForm.zipcode.$invalid"><p class="help-block" ng-show="editForm.zipcode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/nasrac-admin/nasrac-admin-customer-account/nasrac-admin-customer-accounts.html','<section class="content-header"><br></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracAdminCustomerAccounts.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="nasrac-admin-customer-account.new"><span class="glyphicon glyphicon-flash"></span> <span>New Customer Account</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="customerusersearchbar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nasracAdminUserAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.nasracAdminUserAccount.delete.question" translate-values="{id: \'{{vm.nasracAdminUserAccount.login}}\'}">Are you sure you want to delete this Nasrac Admin User Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-detail.html','<div><h2><span data-translate="nasracApp.nasracAdminUserAccount.detail.title">Nasrac Admin User Account</span> {{vm.nasracAdminUserAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="nasracApp.nasracAdminUserAccount.login">Login</span></dt><dd><span>{{vm.nasracAdminUserAccount.login}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.password">Password</span></dt><dd><span>{{vm.nasracAdminUserAccount.password}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.lastName">Last Name</span></dt><dd><span>{{vm.nasracAdminUserAccount.lastName}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.displayName">Display Name</span></dt><dd><span>{{vm.nasracAdminUserAccount.displayName}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.email">Email</span></dt><dd><span>{{vm.nasracAdminUserAccount.email}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.authorizeFlag">Authorize Flag</span></dt><dd><span>{{vm.nasracAdminUserAccount.authorizeFlag}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.notifyFlag">Notify Flag</span></dt><dd><span>{{vm.nasracAdminUserAccount.notifyFlag}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.createdDate">Created Date</span></dt><dd><span>{{vm.nasracAdminUserAccount.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.lastLoginTime">Last Login Time</span></dt><dd><span>{{vm.nasracAdminUserAccount.lastLoginTime | date:\'medium\'}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.lastActivityTime">Last Activity Time</span></dt><dd><span>{{vm.nasracAdminUserAccount.lastActivityTime | date:\'medium\'}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.lastPasswordChangeTime">Last Password Change Time</span></dt><dd><span>{{vm.nasracAdminUserAccount.lastPasswordChangeTime | date:\'medium\'}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.lastLockOutTime">Last Lock Out Time</span></dt><dd><span>{{vm.nasracAdminUserAccount.lastLockOutTime | date:\'medium\'}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.userOnlineFlag">User Online Flag</span></dt><dd><span>{{vm.nasracAdminUserAccount.userOnlineFlag}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.userLockOutFlag">User Lock Out Flag</span></dt><dd><span>{{vm.nasracAdminUserAccount.userLockOutFlag}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.userPasswordUpdFlag">User Password Upd Flag</span></dt><dd><span>{{vm.nasracAdminUserAccount.userPasswordUpdFlag}}</span></dd><dt><span data-translate="nasracApp.nasracAdminUserAccount.nasracAdminCustomerAccount">Nasrac Admin Customer Account</span></dt><dd><a ui-sref="nasrac-admin-customer-account-detail({id:vm.nasracAdminUserAccount.nasracAdminCustomerAccountId})">{{vm.nasracAdminUserAccount.nasracAdminCustomerAccountSiteId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="nasrac-admin-user-account-detail.edit({id:vm.nasracAdminUserAccount.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNasracAdminUserAccountLabel" data-translate="nasracApp.nasracAdminUserAccount.home.createOrEditLabel">Create or edit a Nasrac Admin User Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminUserAccount.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.nasracAdminUserAccount.login" required ng-maxlength="50"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><!-- <div ng-class="{\'form-group\':vm.showPasswordField}" ng-show="vm.showPasswordField">\n            <label class="control-label" data-translate="nasracApp.nasracAdminUserAccount.password" for="field_password">Password</label>\n            <input type="text" class="form-control" name="password" id="field_password"\n                    ng-model="vm.nasracAdminUserAccount.password"\n                    required ng-maxlength="50"/>\n            <div ng-show="editForm.password.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.password.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.password.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">\n                    This field cannot be longer than 50 characters.\n                </p>\n            </div>\n        </div> --><div class="form-group" ng-show="vm.isSiteIdEnable"><label>Site Id</label><!-- data-translate="nasracApp.nasracAdminUserAccount.nasracAdminCustomerAccount" --> <input type="text" class="form-control" name="login" id="field_siteId" ng-model="vm.nasracAdminUserAccount.siteId" ng-readonly="true"><!-- <label  for="field_nasracAdminCustomerAccount">Site Id</label>\n          <select class="form-control" id="field_nasracAdminCustomerAccount"\n            name="nasracAdminCustomerAccount" ng-model="vm.nasracAdminUserAccount.nasracAdminCustomerAccountId"\n            ng-options="nasracAdminCustomerAccount.id as (nasracAdminCustomerAccount.siteId + \' - \' + nasracAdminCustomerAccount.firstName) for nasracAdminCustomerAccount in vm.nasracadmincustomeraccounts"\n                         required>\n            </select>\n\n            <div ng-show="editForm.nasracAdminCustomerAccount.$invalid">\n\t            <p class="help-block"\n\t                ng-show="editForm.nasracAdminCustomerAccount.$error.required" data-translate="entity.validation.required">\n\t                This field is required.\n\t            </p>\n        \t</div>--></div><div class="form-group"><label class="control-label" for="field_userFirstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_userFirstName" ng-model="vm.nasracAdminUserAccount.firstName" required ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminUserAccount.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.nasracAdminUserAccount.lastName" required ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminUserAccount.displayName" for="field_displayName">Display Name</label><input type="text" class="form-control" name="displayName" id="field_displayName" ng-model="vm.nasracAdminUserAccount.displayName" required ng-maxlength="100"><div ng-show="editForm.displayName.$invalid"><p class="help-block" ng-show="editForm.displayName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.displayName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.nasracAdminUserAccount.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.nasracAdminUserAccount.email" required ng-maxlength="80"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><!-- <div class="form-group">\n            <label  for="field_securityRoles">Security Roles</label>\n            <select class="form-control" id="field_securityRoles"\n            name="securityRoles"  ng-model="vm.nasracAdminUserAccount.securityRoles"\n            ng-options="role.securityRoleName for role in vm.securityRolesMap track  by role.id"\n                         required multiple>\n            </select>\n\n            <div ng-show="editForm.securityRoles.$invalid">\n\t            <p class="help-block"\n\t                ng-show="editForm.securityRoles.$error.required" data-translate="entity.validation.required">\n\t                This field is required.\n\t            </p>\n        \t</div>\n        </div> --><div class="form-group"><label for="field_securityRoles">Security Roles</label><div class="row"><div ng-repeat="list in vm.models" class="col-md-6" tooltip-class="customClass" tooltip-placement="top" uib-tooltip-html="\'Drag and Drop the roles</br> <i>Tip:</i> Select multiple roles with single click on each\'"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">{{list.listName}}</h3></div><div class="panel-body"><ul dnd-list dnd-drop="vm.onDrop(list, item, index)"><li ng-repeat="item in list.items" dnd-draggable="vm.getSelectedItemsIncluding(list, item)" dnd-dragstart="vm.onDragstart(list, event)" dnd-moved="vm.onMoved(list)" dnd-dragend="list.dragging = false" dnd-selected="item.selected = !item.selected" ng-class="{\'selected\': item.selected}" ng-hide="list.dragging && item.selected"><!-- dnd-disable-if="$parent.$index == 1 && list.items.length == 1" --> {{item.label}}</li></ul></div></div></div></div><div ng-show="vm.nasracAdminUserAccount.securityRoles == null || vm.nasracAdminUserAccount.securityRoles.length == 0"><p class="help-block" ng-show="vm.nasracAdminUserAccount.securityRoles == null || vm.nasracAdminUserAccount.securityRoles.length == 0">This field is required. At least one role should be selected.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.nasracAdminUserAccount.securityRoles == null || vm.nasracAdminUserAccount.securityRoles.length == 0" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/nasrac-admin/nasrac-admin-user-account/nasrac-admin-user-accounts.html','<section class="content-header"><!-- <h1>NAS-RAC User Accounts</h1> --><!-- <div ncy-breadcrumb class="breadcrumb"></div> --></section><section class="content"><div class="row" has-any-authority="{{ vm.nasracAdminUserAccounts.createRoles }}"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="nasrac-admin-user-account.new"><span class="glyphicon glyphicon-flash"></span> <span>New User Account</span></button></div></div><br><div class="row"><div class="col-xs-12"><table id="usersearchbar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/nasrac-admin/security-roles/security-roles-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.securityRoles.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.securityRoles.delete.question" translate-values="{id: \'{{vm.securityRoles.id}}\'}">Are you sure you want to delete this Security Roles?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/nasrac-admin/security-roles/security-roles-detail.html','<div><h2><span data-translate="nasracApp.securityRoles.detail.title">Security Roles</span> {{vm.securityRoles.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="nasracApp.securityRoles.securityRoleName">Security Role Name</span></dt><dd><span>{{vm.securityRoles.securityRoleName}}</span></dd><dt><span data-translate="nasracApp.securityRoles.securityRoleDesc">Security Role Desc</span></dt><dd><span>{{vm.securityRoles.securityRoleDesc}}</span></dd><dt><span data-translate="nasracApp.securityRoles.securityRoleGroup">Security Role Group</span></dt><dd><span>{{vm.securityRoles.securityRoleGroup}}</span></dd><dt><span data-translate="nasracApp.securityRoles.publicRoleFlag">Public Role Flag</span></dt><dd><span>{{vm.securityRoles.publicRoleFlag}}</span></dd><dt><span data-translate="nasracApp.securityRoles.autoAssignFlag">Auto Assign Flag</span></dt><dd><span>{{vm.securityRoles.autoAssignFlag}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="security-roles-detail.edit({id:vm.securityRoles.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/nasrac-admin/security-roles/security-roles-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySecurityRolesLabel" data-translate="nasracApp.securityRoles.home.createOrEditLabel">Create or edit a Security Roles</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.securityRoles.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.securityRoles.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.securityRoles.securityRoleName" for="field_securityRoleName">Security Role Name</label><input type="text" class="form-control" name="securityRoleName" id="field_securityRoleName" ng-model="vm.securityRoles.securityRoleName" required ng-maxlength="50"><div ng-show="editForm.securityRoleName.$invalid"><p class="help-block" ng-show="editForm.securityRoleName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.securityRoleName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.securityRoles.securityRoleDesc" for="field_securityRoleDesc">Security Role Desc</label><input type="text" class="form-control" name="securityRoleDesc" id="field_securityRoleDesc" ng-model="vm.securityRoles.securityRoleDesc" required ng-maxlength="250"><div ng-show="editForm.securityRoleDesc.$invalid"><p class="help-block" ng-show="editForm.securityRoleDesc.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.securityRoleDesc.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.securityRoles.securityRoleGroup" for="field_securityRoleGroup">Security Role Group</label><input type="text" class="form-control" name="securityRoleGroup" id="field_securityRoleGroup" ng-model="vm.securityRoles.securityRoleGroup" ng-maxlength="50"><div ng-show="editForm.securityRoleGroup.$invalid"><p class="help-block" ng-show="editForm.securityRoleGroup.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.securityRoles.publicRoleFlag" for="field_publicRoleFlag">Public Role Flag</label><input type="checkbox" name="publicRoleFlag" id="field_publicRoleFlag" ng-model="vm.securityRoles.publicRoleFlag"><div ng-show="editForm.publicRoleFlag.$invalid"><p class="help-block" ng-show="editForm.publicRoleFlag.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="nasracApp.securityRoles.autoAssignFlag" for="field_autoAssignFlag">Auto Assign Flag</label><input type="checkbox" name="autoAssignFlag" id="field_autoAssignFlag" ng-model="vm.securityRoles.autoAssignFlag"><div ng-show="editForm.autoAssignFlag.$invalid"><p class="help-block" ng-show="editForm.autoAssignFlag.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/nasrac-admin/security-roles/security-roles.html','<section class="content-header"><br></section><section class="content"><div class="row"><div class="col-xs-12"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/nasrac-admin/site-admin/configure-site-admin.html','<div><div class="text-left" ng-show="vm.isAuthenticated()" has-authority="Administrators" id="siteeditorBtn"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.openEditor()" id="faq-editor-open-button"><span class="glyphicon glyphicon-cog"></span> Configure</button></div><br><!-- form  --><div ng-show="vm.isAuthenticated() && vm.editMode" id="siteeditorForm"><form name="editForm" method="post" role="form" novalidate ng-submit="vm.updateContents()" id="site-editor-form"><label for="iframeText">Piwik Widgetize dashboards</label><textarea id="iframeText" ng-model="vm.tinymceModel" class="form-control"></textarea><br><label for="siteId">Piwik Site Id from Piwik tracking code</label><input type="number" min="0" id="siteId" ng-model="vm.siteContent.siteId" class="form-control"><br><label for="siteURL">Piwik IP Address from Piwik tracking code</label><input id="siteURL" ng-model="vm.siteContent.ipAddress" class="form-control"><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancelEditor()" id="site-editor-cancel-button"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" id="site-editor-save-button"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div></div>');
$templateCache.put('app/nasrac-forms/forms/forms-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.forms.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="nasracApp.forms.delete.question" translate-values="{id: \'{{vm.forms.id}}\'}">Are you sure you want to delete this Forms?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/nasrac-forms/forms/forms-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">x</button><h4 class="modal-title" id="myFormsLabel" data-translate="nasracApp.forms.home.createOrEditLabel">Upload Document</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.forms.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.forms.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="nasracApp.forms.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.forms.title" required ng-maxlength="50"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Type</label><select class="form-control" palceholder="select document type" id="field_doctype" name="doctype" ng-model="vm.forms.doctype" required><!--<option value="default">select doc type</option>--><option value="Channel Map">Channel Map</option><option value="Launch Document">Launch Document</option><option value="other">Other</option></select><div ng-show="editForm.doctype.$invalid"><p class="help-block" ng-show="editForm.doctype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label>Visibility</label><select class="form-control" id="field_docvisibility" name="docvisibility" ng-model="vm.forms.docvisibility" required><!--<option value="default">select doc visibility</option>--><option value="All">All</option><option value="Administrators">Administrators</option></select></div><div ng-show="editForm.docvisibility.$invalid"><p class="help-block" ng-show="editForm.docvisibility.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--<div class="form-group">\n            <label class="control-label" data-translate="nasracApp.forms.doctype" for="field_doctype">Doctype</label>\n            <input type="text" class="form-control" name="doctype" id="field_doctype"\n                    ng-model="vm.forms.doctype"\n                    />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="nasracApp.forms.docvisibility" for="field_docvisibility">Docvisibility</label>\n            <input type="text" class="form-control" name="docvisibility" id="field_docvisibility"\n                    ng-model="vm.forms.docvisibility"\n                    />--><div class="form-group"><label class="control-label" data-translate="nasracApp.forms.description" for="field_description">Description</label><textarea rows="4" cols="50" class="form-control" name="description" id="field_description" ng-model="vm.forms.description" required ng-maxlength="255"></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFileupload($file, vm.forms)"><label class="control-label" data-translate="nasracApp.forms.fileupload" for="field_fileupload">File Upload</label><div><div ng-if="vm.forms.fileupload" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.forms.fileuploadContentType, vm.forms.fileupload)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.forms.fileuploadContentType}}, {{vm.byteSize(vm.forms.fileupload)}}</span> <button type="button" ng-click="vm.forms.fileupload=null;vm.forms.fileuploadContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFileupload($file, vm.forms)" data-translate="entity.action.addblob">Browse</button></div><input type="hidden" class="form-control" name="fileupload" id="field_fileupload" ng-model="vm.forms.fileupload" required> <input type="hidden" class="form-control" name="fileuploadContentType" id="field_fileuploadContentType" ng-model="vm.forms.fileuploadContentType"></div><div ng-show="editForm.fileupload.$invalid"><p class="help-block" ng-show="editForm.fileupload.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--<div class="form-group">\n            <label class="control-label" data-translate="nasracApp.forms.uploaddate" for="field_uploaddate">Uploaddate</label>\n                <div class="input-group">\n                    <input id="field_uploaddate" type="text" class="form-control" name="uploaddate" datetime-picker="{{dateformat}}" ng-model="vm.forms.uploaddate" is-open="vm.datePickerOpenStatus.uploaddate"\n                    />\n                    <span class="input-group-btn">\n                        <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'uploaddate\')"><i class="glyphicon glyphicon-calendar"></i></button>\n                    </span>\n                </div>\n        </div>--><!--<div class="form-group">\n            <label class="control-label" data-translate="nasracApp.forms.uploadedby" for="field_uploadedby">Uploadedby</label>\n            <input type="text" class="form-control" name="uploadedby" id="field_uploadedby"\n                    ng-model="vm.forms.uploadedby"\n                    />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="nasracApp.forms.noofdownloads" for="field_noofdownloads">Noofdownloads</label>\n            <input type="number" class="form-control" name="noofdownloads" id="field_noofdownloads"\n                    ng-model="vm.forms.noofdownloads"\n                    />\n        </div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/nasrac-forms/forms/forms.html','<section class="content-header"><h1>Forms</h1><br></section><section class="content"><div class="row" ng-if="vm.isAuthenticated()" has-authority="Administrators"><div class="col-xs-2"><button class="btn btn-primary" ui-sref="forms.new"><span class="glyphicon glyphicon-flash"></span> <span>Upload Document</span></button></div></div><br><div class="row"><div class="col-xs-12"><div class="table-responsive" width="100%"><table id="nasracformsbar" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered forms-table-custom"></table></div></div></div></section>');
$templateCache.put('app/reports/change-management-hours-report/change-management-hours-report.html','<section class="content-header"><h1>Change Management Hours Reports</h1><!-- <div ncy-breadcrumb class="breadcrumb"></div> --><ol class="breadcrumb"><li class="breadcrumb-item active"><a ng-click="vm.reload_state();">Change Management Hours Reports</a></li><li class="breadcrumb-item" ng-show="vm.reportsFlag"><a ng-click="vm.query_by_year(vm.clliCode);">{{vm.clliCode}}</a></li><li class="breadcrumb-item" ng-show="vm.caseIdFlag">{{vm.caseId}}</li></ol><section class="content"><div ng-hide="vm.reportsFlag"><p>Select a "Report Year" then the "Customer" and click on the "GO" button to generate the report</p><div class="row"><div class="col-lg-12 col-md-12"><span>Report Year :</span><select data-ng-model="selectedYear" ng-change="onYearChange();" ng-options="item.range for item in reportYear"></select><span style="margin-left: 15px" ng-show="isAdmin">Select Customer:</span><select ng-show="isAdmin" data-ng-model="selectedCustomer" ng-change="onCustomerChange();" ng-options="item.customerName for item in customerList"><option value="">--- ALL ---</option></select><span style="margin-left: 15px" ng-show="isAdmin">Select Site Id:</span><select ng-show="isAdmin" data-ng-model="selectedClliCode" ng-change="onClliCodeChange();" ng-options="item.clliCode for item in clliCodeList"><option value="">--- ALL ---</option></select><button class="btn btn-primary" data-ng-click="loadDataHoursReport();" style="margin-left: 15px"><span>Go</span></button></div><!--<div style="margin-top: 10px;">--></div></div><div data-ng-if="reportData.length>0"><div class="row border-white-with-padding"><div class="row align-center"><div class="col-md-12">AURORA NETWORKS International</div></div><div class="row align-center"><div class="col-md-12">NAS-RAC</div></div><div class="row align-center"><div class="col-md-12">{{selectedYear.range}} Change Management Hours <span data-ng-if="vm.clliCode!=null">for - {{vm.clliCode}} - {{siteName}}</span><br><span data-ng-if="vm.caseIdFlag">Case Id {{vm.caseId}}</span></div></div></div><div class="row"><div class="col-xs-12"><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table datatable="" dt-options="dtOptions" dt-instance="dtInstance" dt-columns="dtColumns" class="table table-striped table-bordered"><tfoot ng-show="vm.reportsFlag"><tr data-ng-if="vm.reportsFlag&&vm.caseIdFlag" style="font-weight: bold"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>Total</td><td>{{total | number:2}}</td></tr><tr data-ng-if="vm.reportsFlag&&!vm.caseIdFlag" style="font-weight: bold"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>Total</td><td></td><td></td><td>{{total | number:2}}</td></tr></tfoot></table></div></div></div><div class="align-center">As of {{currentTime}}</div></div><!-- <div data-ng-if="reportData.length==0">\n             <p class="align-center">No Data is Available</p>\n         </div>--></section></section>');
$templateCache.put('app/reports/nasrac-customer-report/nasrac-customer-reports.html','<section class="content-header"><h1>NAS-RAC Customer Reports</h1><!-- <div ncy-breadcrumb class="breadcrumb"></div> --><ol class="breadcrumb"><li class="breadcrumb-item active"><a ng-click="vm.reload_state();">Customer Reports</a></li><li class="breadcrumb-item" ng-show="vm.reportsFlag">{{vm.siteId}}</li></ol></section><section class="content"><div class="row" ng-show="vm.reportsFlag"><div class="col-xs-4"><uib-tabset type="pills"><uib-tab heading="Current Reports" ng-click="vm.get_siteId_files(vm.siteId, false)" classes="btn-lg"></uib-tab><uib-tab heading="Archive  Reports" ng-click="vm.get_siteId_files(vm.siteId, true)" classes="btn-lg"></uib-tab></uib-tabset></div></div><!-- <br> --><div class="row"><div class="col-xs-12"><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-instance="vm.dtInstance" dt-columns="vm.dtColumns" class="table table-striped table-bordered"></table></div></div></div></section>');
$templateCache.put('app/reports/site-admin-reports/site-admin-reports.html','<div><div ng-if="vm.trustedHtml ===\'\' "><h3>Configure Site Admin <a ui-sref="configuresiteadmin">here</a></h3></div><div ng-if="vm.trustedHtml !==\'\' "><div class="embed-responsive embed-responsive-16by9"><div ng-bind-html="vm.trustedHtml" id="site-noedit-text"></div></div></div></div>');
$templateCache.put('app/reports/templates/modules-usage.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 class="text-center">Modules Usage</h1></div></div></div>');
$templateCache.put('app/reports/templates/monthly-hits.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 class="text-center">Monthly Hits</h1></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. The key provided is invalid.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>Username/Login isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the username/login you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Username/Login</label><input type="text" class="form-control" id="email" name="email" placeholder="Your login" ng-model="vm.resetAccount.email" ng-minlength="1" ng-maxlength="50" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your Login is required.</p><p class="help-block" ng-show="form.email.$error.minlength">Your login is required to be at least 1 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your login cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();